import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import CampoDataHora from '../components/CampoDataHora';
import { useNavigate, useLocation } from 'react-router-dom';

function token() { return localStorage.getItem('token'); }
// A Comunicação é da equipe toda desde 28/10/2026: a assinatura padrão leva o
// nome de quem está logado, e a engrenagem ⚙️ (conta de e-mail, chave da
// Comtele) segue só com o Vagner (o servidor também barra a troca)
const ehVagner = () => localStorage.getItem('nomeUsuario') === 'Vagner Freitas';
const assinatura = (abertura) => `${abertura}\n\n\n\nAtenciosamente,\n${localStorage.getItem('nomeUsuario') || 'Vagner Freitas'}\nPreserva Marcas®`;
function api(path, opts = {}) {
  return fetch(path, { ...opts, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}`, ...(opts.headers || {}) } });
}

const VARIAVEIS = ['{nome}', '{marca}', '{processo}', '{telefone}', '{data}'];

const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 3, display: 'block' };
const inp = { width: '100%', padding: '6px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit' };
const btn = (cor = '#0a1628') => ({ background: cor, color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontSize: 12, fontWeight: 600, cursor: 'pointer' });
const btnOut = { background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '6px 14px', fontSize: 12, cursor: 'pointer' };

function statusBadge(s) {
  if (s === 'enviado') return { label: 'Enviado', bg: '#f0fdf4', cor: '#16a34a' };
  if (s === 'falhou') return { label: 'Falhou', bg: '#fef2f2', cor: '#dc2626' };
  return { label: 'Agendado', bg: '#fffbeb', cor: '#d97706' };
}

function fmtDt(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

// ── Aba Templates ─────────────────────────────────────────────────────────────
function AbaTemplates() {
  const [lista, setLista] = useState([]);
  const [form, setForm] = useState({ titulo: '', texto: '' });
  const [editando, setEditando] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const carregar = useCallback(() => {
    api('/comunicacao/templates').then(r => r.json()).then(setLista).catch(() => {});
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  async function salvar() {
    if (!form.titulo.trim() || !form.texto.trim()) return alert('Preencha título e texto.');
    setSalvando(true);
    if (editando) {
      await api(`/comunicacao/templates/${editando}`, { method: 'PUT', body: JSON.stringify(form) });
    } else {
      await api('/comunicacao/templates', { method: 'POST', body: JSON.stringify(form) });
    }
    setSalvando(false);
    setForm({ titulo: '', texto: '' });
    setEditando(null);
    carregar();
  }

  async function excluir(id) {
    if (!window.confirm('Excluir este template?')) return;
    await api(`/comunicacao/templates/${id}`, { method: 'DELETE' });
    carregar();
  }

  function editar(t) {
    setEditando(t._id);
    setForm({ titulo: t.titulo, texto: t.texto });
    window.scrollTo(0, 0);
  }

  function inserirVariavel(v) {
    setForm(f => ({ ...f, texto: f.texto + v }));
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, alignItems: 'start' }}>
      {/* Formulário */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#0a1628', marginBottom: 14 }}>
          {editando ? 'Editar Template' : 'Novo Template'}
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={lbl}>Título</label>
          <input style={inp} value={form.titulo} onChange={e => setForm(f => ({ ...f, titulo: e.target.value }))} placeholder="Ex: Processo Deferido" />
        </div>
        <div style={{ marginBottom: 8 }}>
          <label style={lbl}>Texto da Mensagem</label>
          <textarea style={{ ...inp, minHeight: 120, resize: 'vertical' }} value={form.texto}
            onChange={e => setForm(f => ({ ...f, texto: e.target.value }))}
            placeholder="Ex: Olá {nome}, seu processo da marca {marca} foi deferido!" />
        </div>
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 5 }}>Clique para inserir variável:</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {VARIAVEIS.map(v => (
              <button key={v} onClick={() => inserirVariavel(v)}
                style={{ background: '#f0f4ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 4, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>
                {v}
              </button>
            ))}
          </div>
        </div>
        {form.texto && (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 6, padding: 10, marginBottom: 12 }}>
            <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>Pré-visualização:</div>
            <div style={{ fontSize: 13, color: '#374151', whiteSpace: 'pre-wrap' }}>
              {form.texto.replace(/\{nome\}/g, 'João Silva').replace(/\{marca\}/g, 'MINHABRAND').replace(/\{processo\}/g, '912345678').replace(/\{telefone\}/g, '(11) 99999-9999').replace(/\{data\}/g, new Date().toLocaleDateString('pt-BR'))}
            </div>
          </div>
        )}
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={btn()} onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : editando ? 'Atualizar' : 'Salvar Template'}</button>
          {editando && <button style={btnOut} onClick={() => { setEditando(null); setForm({ titulo: '', texto: '' }); }}>Cancelar</button>}
        </div>
      </div>

      {/* Lista */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {lista.length === 0 ? (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
            Nenhum template cadastrado.
          </div>
        ) : lista.map(t => (
          <div key={t._id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>{t.titulo}</div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button style={{ ...btnOut, padding: '3px 10px', fontSize: 11 }} onClick={() => editar(t)}>Editar</button>
                <button style={{ ...btn('#dc2626'), padding: '3px 10px', fontSize: 11 }} onClick={() => excluir(t._id)}>Excluir</button>
              </div>
            </div>
            <div style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>{t.texto}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Aba Agendar ───────────────────────────────────────────────────────────────
function AbaAgendar({ onAgendado }) {
  const [templates, setTemplates] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState('');
  const [clienteSel, setClienteSel] = useState(null);
  const [templateSel, setTemplateSel] = useState(null);
  const [textoPrev, setTextoPrev] = useState('');
  const [agendadoPara, setAgendadoPara] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [anexos, setAnexos] = useState([]);      // [{ arquivo, nome, tamanho }]
  const [subindo, setSubindo] = useState(false);
  // Destino: 'cadastro' (clientes) · 'crm' (oportunidades) · 'parceiros' ·
  // 'avulso' (digita o número na hora). O card do CRM chega aqui por URL
  // (?para_tel=&para_nome=) já com o contato preenchido no modo avulso.
  const paramsIniciais = new URLSearchParams(window.location.search);
  const telParam = (paramsIniciais.get('para_tel') || '').trim();
  const nomeParam = (paramsIniciais.get('para_nome') || '').trim();
  const [modoDestino, setModoDestino] = useState(telParam ? 'avulso' : 'cadastro');
  const [avulsoTel, setAvulsoTel] = useState(telParam);
  const [avulsoNome, setAvulsoNome] = useState(nomeParam);
  // Listas do CRM e dos parceiros: buscadas uma vez, filtradas na digitação
  const [fontes, setFontes] = useState({});
  const [buscaFonte, setBuscaFonte] = useState('');
  useEffect(() => {
    if (!['crm', 'parceiros'].includes(modoDestino) || fontes[modoDestino]) return;
    const url = modoDestino === 'crm' ? '/oportunidades' : '/parceiros';
    api(url).then(r => r.json()).then(arr => {
      const itens = (Array.isArray(arr) ? arr : [])
        .map(x => modoDestino === 'crm'
          ? { nome: x.nome_cliente || '', telefone: x.telefone || '', extra: [x.etapa, x.closer].filter(Boolean).join(' · ') }
          : { nome: x.nome || '', telefone: x.telefone || '', extra: [x.tipo, x.empresa || x.cidade_uf].filter(Boolean).join(' · ') })
        .filter(x => x.nome);
      setFontes(f => ({ ...f, [modoDestino]: itens }));
    }).catch(() => setFontes(f => ({ ...f, [modoDestino]: [] })));
  }, [modoDestino, fontes]);
  // De onde sai: '' = Contato da Preserva; senão, id da sessão pessoal
  const [remetentes, setRemetentes] = useState([]);
  const [remetenteSel, setRemetenteSel] = useState('');
  // Cartões minimizáveis (pedido 18/08): escolheu numa fase, ela se fecha e
  // vira uma linha de resumo — o fluxo inteiro cabe na tela sem rolagem.
  // Chegando do CRM com o contato pronto, o destino já abre minimizado.
  const [fechadas, setFechadas] = useState(telParam ? { destino: true } : {});
  const fecharSec = (k) => setFechadas(f => ({ ...f, [k]: true }));
  const cartao = (id, titulo, resumo, conteudo) => {
    const fechado = !!fechadas[id];
    return (
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8 }}>
        <div onClick={() => setFechadas(f => ({ ...f, [id]: !f[id] }))}
          title={fechado ? 'Clique pra abrir' : 'Clique pra minimizar'}
          style={{ padding: '11px 14px', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', userSelect: 'none' }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', whiteSpace: 'nowrap' }}>{titulo}</span>
          {fechado && resumo
            ? <span style={{ fontSize: 12, color: '#15803d', fontWeight: 600, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', textAlign: 'right' }}>✓ {resumo}</span>
            : <span style={{ flex: 1 }} />}
          <span style={{ color: '#9ca3af', fontSize: 11 }}>{fechado ? '▸' : '▾'}</span>
        </div>
        {!fechado && <div style={{ padding: '0 14px 14px' }}>{conteudo}</div>}
      </div>
    );
  };

  useEffect(() => {
    api('/comunicacao/templates').then(r => r.json()).then(setTemplates).catch(() => {});
    api('/comunicacao/remetentes').then(r => r.json())
      .then(d => setRemetentes(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!busca.trim()) { setClientes([]); return; }
    const timer = setTimeout(() => {
      api(`/clientes?busca=${encodeURIComponent(busca)}`).then(r => r.json()).then(d => setClientes(Array.isArray(d) ? d.slice(0, 8) : [])).catch(() => {});
    }, 300);
    return () => clearTimeout(timer);
  }, [busca]);

  const clientesFiltrados = clientes;

  function selecionarTemplate(t) {
    setTemplateSel(t);
    fecharSec('template');
    if (clienteSel) {
      const marca = clienteSel.processos?.[0]?.nome_marca || '';
      const processo = clienteSel.processos?.[0]?.numero_processo || '';
      setTextoPrev(t.texto.replace(/\{nome\}/gi, clienteSel.nome || '').replace(/\{marca\}/gi, marca).replace(/\{processo\}/gi, processo).replace(/\{telefone\}/gi, clienteSel.telefone || '').replace(/\{data\}/gi, new Date().toLocaleDateString('pt-BR')));
    } else {
      setTextoPrev(t.texto);
    }
  }

  function selecionarCliente(c) {
    setClienteSel(c);
    setBusca('');
    fecharSec('destino');
    if (templateSel) {
      const marca = c.processos?.[0]?.nome_marca || '';
      const processo = c.processos?.[0]?.numero_processo || '';
      setTextoPrev(templateSel.texto.replace(/\{nome\}/gi, c.nome || '').replace(/\{marca\}/gi, marca).replace(/\{processo\}/gi, processo).replace(/\{telefone\}/gi, c.telefone || '').replace(/\{data\}/gi, new Date().toLocaleDateString('pt-BR')));
    }
  }

  // Sobe os arquivos na hora de escolher: o agendamento guarda só as referências
  async function escolherAnexo(e) {
    const fs = [...(e.target.files || [])];
    if (!fs.length) return;
    const grande = fs.find(f => f.size > 20 * 1024 * 1024);
    if (grande) { alert(`"${grande.name}" passa de 20 MB.`); e.target.value = ''; return; }
    if (anexos.length + fs.length > 10) { alert('Máximo de 10 arquivos por mensagem.'); e.target.value = ''; return; }
    setSubindo(true);
    try {
      const fd = new FormData();
      fs.forEach(f => fd.append('arquivo', f));
      // sem Content-Type: o browser põe o boundary do multipart sozinho
      const r = await fetch('/comunicacao/anexo', {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: fd,
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.erro || 'Falha no upload');
      setAnexos(a => [...a, ...(d.anexos || [])]);
      fecharSec('anexo');
    } catch (err) { alert(err.message); }
    setSubindo(false);
    e.target.value = '';
  }

  async function removerAnexo(arquivo) {
    await api(`/comunicacao/anexo/${encodeURIComponent(arquivo)}`, { method: 'DELETE' }).catch(() => {});
    setAnexos(a => a.filter(x => x.arquivo !== arquivo));
  }

  // Destino: cliente do cadastro, contato do CRM, parceiro OU número avulso
  const telDestino = (avulsoTel || '').replace(/\D/g, '');
  const destinoOk = modoDestino === 'avulso' ? telDestino.length >= 10 : !!clienteSel?.telefone;

  // Resumos das fases minimizadas
  const resumoRemetente = (remetentes.find(x => x.id === remetenteSel)?.nome) || 'Contato da Preserva';
  const resumoDestino = modoDestino === 'avulso'
    ? (telDestino.length >= 10 ? `${avulsoNome.trim() ? avulsoNome.trim() + ' · ' : ''}${telDestino}` : '')
    : (clienteSel ? `${clienteSel.nome || ''} · ${clienteSel.telefone || ''}` : '');
  const resumoTemplate = templateSel?.titulo || (textoPrev.trim() ? 'Texto livre' : '');
  const resumoAnexo = anexos.length ? `${anexos.length} arquivo(s)` : '';
  const resumoData = agendadoPara ? fmtDt(new Date(agendadoPara).toISOString()) : '';

  // imediato = true: manda agora (horário = já), sem exigir data marcada
  async function agendar(imediato = false) {
    if (modoDestino === 'avulso') {
      if (telDestino.length < 10) return alert('Digite o número com DDD (ex.: 83 99999-9999).');
    } else {
      if (!clienteSel) return alert(modoDestino === 'crm' ? 'Selecione o contato do CRM.' : modoDestino === 'parceiros' ? 'Selecione o parceiro.' : 'Selecione um cliente.');
      if (!clienteSel.telefone) return alert('Este contato não tem telefone cadastrado.');
    }
    if (!textoPrev.trim() && !anexos.length) return alert('Escreva a mensagem ou anexe um arquivo.');
    if (!imediato && !agendadoPara) return alert('Defina a data e hora do envio.');
    setSalvando(true);
    const resp = await api('/comunicacao/fila', {
      method: 'POST',
      body: JSON.stringify({
        // cliente_id só quando é cliente do cadastro — CRM e parceiro não são clientes
        cliente_id: modoDestino === 'cadastro' ? clienteSel._id : '',
        cliente_nome: modoDestino === 'avulso'
          ? (avulsoNome.trim() || `Avulso · ${avulsoTel}`)
          : (clienteSel.nome || clienteSel.processos?.[0]?.nome_marca || ''),
        telefone: modoDestino === 'avulso' ? telDestino : clienteSel.telefone,
        template_id: templateSel?._id || '',
        template_titulo: templateSel?.titulo || (anexos.length ? '📎 Com anexo' : 'Personalizada'),
        texto_final: textoPrev,
        anexos,
        enviar_por: remetenteSel,
        enviar_por_nome: remetentes.find(x => x.id === remetenteSel)?.nome || '',
        agendado_para: imediato ? new Date().toISOString() : new Date(agendadoPara).toISOString(),
      }),
    });
    setSalvando(false);
    // Antes isto era um await solto: se o backend recusasse (401, validação,
    // erro), a tela dizia "agendada com sucesso" e nada ia pra fila.
    if (!resp.ok) {
      const d = await resp.json().catch(() => ({}));
      return alert(resp.status === 401
        ? 'Sua sessão expirou. Faça login de novo e tente outra vez.'
        : `Não deu pra agendar: ${d.erro || `erro ${resp.status}`}`);
    }
    alert(imediato ? 'Enviando agora! Acompanhe na fila.' : 'Mensagem agendada com sucesso!');
    setClienteSel(null);
    setTemplateSel(null);
    setTextoPrev('');
    setAgendadoPara('');
    setAnexos([]);
    setAvulsoTel('');
    setAvulsoNome('');
    setFechadas({}); // formulário zerado: reabre todas as fases
    onAgendado();
  }

  return (
    // Fluxo em coluna única, na ordem de preenchimento (pedido 18/08):
    // remetente → destino → template → prévia → anexo → data → botões
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14, maxWidth: 640, minWidth: 0 }}>

        {/* Remetente: número da empresa ou o WhatsApp pessoal conectado */}
        {remetentes.length > 1 && cartao('remetente', '1. De onde sai', resumoRemetente, (
          <div style={{ display: 'flex', gap: 6 }}>
            {remetentes.map(r => {
              const on = remetenteSel === r.id;
              const conectado = r.status === 'conectado';
              return (
                <button key={r.id || 'empresa'} onClick={() => { setRemetenteSel(r.id); fecharSec('remetente'); }}
                  disabled={!conectado}
                  title={conectado ? '' : 'Desconectado — conecte em Configurações'}
                  style={{
                    flex: 1, padding: '6px 10px', fontSize: 12, fontWeight: 700, borderRadius: 6,
                    cursor: conectado ? 'pointer' : 'not-allowed', opacity: conectado ? 1 : 0.45,
                    border: '1px solid ' + (on ? '#0a1628' : '#d1d5db'),
                    background: on ? '#0a1628' : '#fff',
                    color: on ? '#fff' : '#374151',
                  }}>
                  {r.id ? '👤 ' : '🏢 '}{r.nome}{conectado ? '' : ' (off)'}
                </button>
              );
            })}
          </div>
        ))}

        {/* Destino: cliente do cadastro ou número digitado na hora */}
        {cartao('destino', '2. Para quem vai', resumoDestino, (<div>
          <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
            {[
              { k: 'cadastro', label: '🔍 Cliente' },
              { k: 'crm', label: '🎯 CRM' },
              { k: 'parceiros', label: '🤝 Parceiros' },
              { k: 'avulso', label: '✍️ Avulso' },
            ].map(o => (
              <button key={o.k} onClick={() => { if (modoDestino !== o.k) { setModoDestino(o.k); setClienteSel(null); setBusca(''); setBuscaFonte(''); } }}
                style={{
                  flex: '1 1 100px', padding: '6px 8px', fontSize: 12, fontWeight: 700, borderRadius: 6, cursor: 'pointer',
                  border: '1px solid ' + (modoDestino === o.k ? '#0a1628' : '#d1d5db'),
                  background: modoDestino === o.k ? '#0a1628' : '#fff',
                  color: modoDestino === o.k ? '#fff' : '#374151',
                }}>{o.label}</button>
            ))}
          </div>

          {modoDestino === 'avulso' ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div>
                <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 3 }}>Número com DDD</div>
                <input style={inp} value={avulsoTel} onChange={e => setAvulsoTel(e.target.value)}
                  placeholder="83 99999-9999" inputMode="tel" />
              </div>
              <div>
                <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 3 }}>Nome <span style={{ color: '#9ca3af' }}>(opcional, só pra identificar na fila)</span></div>
                <input style={inp} value={avulsoNome} onChange={e => setAvulsoNome(e.target.value)} placeholder="Ex.: João da gráfica" />
              </div>
              {avulsoTel && telDestino.length < 10 && (
                <div style={{ fontSize: 11.5, color: '#b45309' }}>⚠ Faltam dígitos — inclua o DDD.</div>
              )}
              {telDestino.length >= 10 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ fontSize: 11.5, color: '#15803d', fontWeight: 600 }}>✓ Vai para {telDestino}</span>
                  <button onClick={() => fecharSec('destino')}
                    style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 5, padding: '3px 12px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>
                    ✓ OK — minimizar
                  </button>
                </div>
              )}
            </div>
          ) : clienteSel ? (
            <div style={{ background: '#f0f4ff', border: '1px solid #bfdbfe', borderRadius: 6, padding: '8px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 13, color: '#0a1628' }}>{clienteSel.nome || clienteSel.processos?.[0]?.nome_marca}</div>
                <div style={{ fontSize: 12, color: '#6b7280' }}>📞 {clienteSel.telefone || 'Sem telefone'}</div>
              </div>
              <button style={btnOut} onClick={() => setClienteSel(null)}>Trocar</button>
            </div>
          ) : modoDestino === 'cadastro' ? (
            <div>
              <input style={inp} value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por nome, marca ou telefone..." />
              {busca && (
                <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, marginTop: 4, overflow: 'hidden', maxHeight: 200, overflowY: 'auto' }}>
                  {clientesFiltrados.length === 0 ? (
                    <div style={{ padding: '8px 12px', fontSize: 12, color: '#9ca3af' }}>Nenhum cliente encontrado</div>
                  ) : clientesFiltrados.map(c => (
                    <div key={c._id} onClick={() => selecionarCliente(c)}
                      style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', fontSize: 13 }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                      onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                      <div style={{ fontWeight: 600 }}>{c.nome || '(sem nome)'}</div>
                      <div style={{ fontSize: 11, color: '#6b7280' }}>{c.processos?.[0]?.nome_marca} · {c.telefone || 'sem telefone'}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (() => {
            // CRM e Parceiros: lista já carregada, filtro na digitação (sem acento)
            const semAc = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
            const lista = fontes[modoDestino];
            const achados = (lista || []).filter(x => !buscaFonte.trim() || semAc(x.nome + ' ' + x.telefone + ' ' + x.extra).includes(semAc(buscaFonte)));
            return (
              <div>
                {lista === undefined ? (
                  <div style={{ fontSize: 12, color: '#6b7280' }}>Carregando {modoDestino === 'crm' ? 'oportunidades' : 'parceiros'}…</div>
                ) : (
                  <>
                    <input style={inp} value={buscaFonte} onChange={e => setBuscaFonte(e.target.value)}
                      placeholder={modoDestino === 'crm' ? `Buscar nas ${lista.length} oportunidades…` : `Buscar nos ${lista.length} parceiros…`} />
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 6, marginTop: 4, overflow: 'hidden', maxHeight: 200, overflowY: 'auto' }}>
                      {achados.length === 0 ? (
                        <div style={{ padding: '8px 12px', fontSize: 12, color: '#9ca3af' }}>Ninguém com esse nome.</div>
                      ) : achados.slice(0, 25).map((c, i) => (
                        <div key={i} onClick={() => c.telefone ? selecionarCliente(c) : alert('Este contato não tem telefone cadastrado.')}
                          style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f3f4f6', fontSize: 13, opacity: c.telefone ? 1 : 0.5 }}
                          onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                          onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                          <div style={{ fontWeight: 600 }}>{c.nome}</div>
                          <div style={{ fontSize: 11, color: '#6b7280' }}>{[c.extra, c.telefone || 'sem telefone'].filter(Boolean).join(' · ')}</div>
                        </div>
                      ))}
                      {achados.length > 25 && <div style={{ padding: '4px 12px', fontSize: 10.5, color: '#9ca3af' }}>mostrando 25 de {achados.length} — digite pra refinar</div>}
                    </div>
                  </>
                )}
              </div>
            );
          })()}
        </div>))}

        {/* Template (opcional — dá pra escrever do zero ou só anexar) */}
        {cartao('template', '3. Template', resumoTemplate, (<div>
          <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 10 }}>
            Escolha um pronto ou escreva livre na pré-visualização abaixo. <span style={{ color: '#9ca3af' }}>(opcional)</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {templateSel && (
              <button onClick={() => { setTemplateSel(null); setTextoPrev(''); }}
                style={{ alignSelf: 'flex-start', background: '#fff', border: '1px solid #d1d5db', borderRadius: 5, padding: '3px 10px', fontSize: 11.5, color: '#dc2626', fontWeight: 600, cursor: 'pointer', marginBottom: 2 }}>
                × Não usar template
              </button>
            )}
            {templates.length === 0 && <div style={{ fontSize: 12, color: '#9ca3af' }}>Nenhum template cadastrado — escreva livre na pré-visualização.</div>}
            {templates.map(t => (
              <div key={t._id} onClick={() => selecionarTemplate(t)}
                style={{ padding: '8px 12px', border: `1px solid ${templateSel?._id === t._id ? '#0a1628' : '#e5e7eb'}`, borderRadius: 6, cursor: 'pointer', background: templateSel?._id === t._id ? '#f0f4ff' : '#fff', minWidth: 0, overflow: 'hidden' }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#0a1628' }}>{t.titulo}</div>
                <div style={{ fontSize: 11, color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.texto}</div>
              </div>
            ))}
          </div>
        </div>))}

        {/* Prévia + texto da mensagem (sempre editável) */}
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, minWidth: 0, overflowWrap: 'anywhere' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 12 }}>4. Pré-visualização</div>
          {(textoPrev || anexos.length) ? (
            // Cada balão = uma mensagem no WhatsApp, na ordem em que sai
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 }}>
              {anexos.map(a => (
                <div key={a.arquivo} style={{ alignSelf: 'flex-end', maxWidth: '92%', background: '#e9fbe9', border: '1px solid #bbf7d0', borderRadius: 12, borderBottomRightRadius: 2, padding: 8 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 7, background: '#fff', border: '1px solid #d1fae5', borderRadius: 8, padding: '8px 10px' }}>
                    <span style={{ fontSize: 20 }}>📄</span>
                    <span style={{ fontSize: 12.5, fontWeight: 600, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.nome}</span>
                  </div>
                </div>
              ))}
              {textoPrev && (
                <div style={{ alignSelf: 'flex-end', maxWidth: '92%', background: '#e9fbe9', border: '1px solid #bbf7d0', borderRadius: 12, borderBottomRightRadius: 2, padding: '12px 14px', fontSize: 14, lineHeight: 1.6, color: '#1a1a1a', whiteSpace: 'pre-wrap' }}>
                  {textoPrev}
                </div>
              )}
              {anexos.length > 0 && (
                <div style={{ fontSize: 11, color: '#9ca3af', textAlign: 'right' }}>
                  {anexos.length === 1 ? '1 arquivo' : `${anexos.length} arquivos`}{textoPrev ? ' + a mensagem' : ''} — {anexos.length + (textoPrev ? 1 : 0)} envios
                </div>
              )}
            </div>
          ) : (
            <div style={{ background: '#f9fafb', borderRadius: 8, padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 13, marginBottom: 16 }}>
              Escreva a mensagem abaixo, escolha um template ou anexe um arquivo
            </div>
          )}
          {/* Sempre editável: antes só aparecia depois de escolher um template,
              o que impedia escrever do zero */}
          <textarea style={{ ...inp, minHeight: 90, resize: 'vertical' }}
            placeholder={anexos.length ? 'Mensagem que vai depois dos arquivos…' : 'Escreva a mensagem…'}
            value={textoPrev} onChange={e => setTextoPrev(e.target.value)} />
        </div>

        {/* Anexo */}
        {cartao('anexo', '5. Anexo', resumoAnexo, (<div>
          <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 10 }}>
            PDF, imagem ou documento — dá pra escolher vários. Saem <strong>antes</strong> da mensagem, um por vez. <span style={{ color: '#9ca3af' }}>(opcional)</span>
          </div>
          {anexos.map((a, i) => (
            <div key={a.arquivo} style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '7px 10px', marginBottom: 6 }}>
              <span style={{ fontSize: 11, fontWeight: 800, color: '#15803d', minWidth: 16 }}>{i + 1}º</span>
              <span style={{ fontSize: 16 }}>📎</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: '#15803d', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.nome}</div>
                <div style={{ fontSize: 11, color: '#6b7280' }}>{(a.tamanho / 1024 / 1024).toFixed(2)} MB</div>
              </div>
              <button onClick={() => removerAnexo(a.arquivo)}
                style={{ background: 'none', border: 'none', color: '#dc2626', fontSize: 16, cursor: 'pointer', fontWeight: 700 }}>×</button>
            </div>
          ))}
          {anexos.length < 10 && (
            <>
              <input type="file" multiple accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg" onChange={escolherAnexo} disabled={subindo}
                style={{ ...inp, height: 'auto', padding: 7, fontSize: 12 }} />
              {subindo && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>Enviando…</div>}
            </>
          )}
        </div>))}

        {/* Data/hora */}
        {cartao('data', '6. Data e hora do envio', resumoData, (<div>
          <div style={{ fontSize: 11.5, color: '#9ca3af', marginBottom: 8 }}>Só pra agendar — o Enviar Agora ignora.</div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <CampoDataHora style={inp} value={agendadoPara} onChange={setAgendadoPara} />
            {agendadoPara && (
              <button onClick={() => fecharSec('data')}
                style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 5, padding: '5px 12px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>
                ✓ OK — minimizar
              </button>
            )}
          </div>
          {agendadoPara && (
            <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '8px 12px', fontSize: 12, color: '#92400e', marginTop: 10 }}>
              ⏰ Disparo programado para: <strong>{fmtDt(new Date(agendadoPara).toISOString())}</strong>
            </div>
          )}
        </div>))}

        {/* Confirmar */}
        <div style={{ display: 'flex', gap: 8 }}>
          {/* onClick com arrow: onClick={agendar} passaria o evento do clique
              como 1º argumento e viraria imediato=true sem querer */}
          <button style={{ ...btn('#0a1628'), flex: 1, padding: '10px', fontSize: 14, opacity: destinoOk ? 1 : 0.5 }}
            onClick={() => agendar(true)} disabled={salvando || !destinoOk}>
            {salvando ? 'Enviando...' : '🚀 Enviar Agora'}
          </button>
          <button style={{ ...btn('#16a34a'), flex: 1, padding: '10px', fontSize: 14, opacity: destinoOk ? 1 : 0.5 }}
            onClick={() => agendar(false)} disabled={salvando || !destinoOk}>
            {salvando ? 'Agendando...' : '📅 Agendar Envio'}
          </button>
        </div>
    </div>
  );
}

// ── Histórico dos últimos 30 dias (botão da aba Fila, pedido 24/10/2026) ──────
// Envios de WhatsApp já processados (enviados e com falha), agrupados por dia,
// com busca, filtro de situação, mensagem completa e "Reenviar". O servidor
// devolve os 200 mais recentes; o corte de 30 dias é feito aqui.
const DIAS_HISTORICO = 30;

function rotuloDia(d) {
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
  const dia = new Date(d); dia.setHours(0, 0, 0, 0);
  const dif = Math.round((hoje - dia) / 86400000);
  if (dif === 0) return 'Hoje';
  if (dif === 1) return 'Ontem';
  return d.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });
}

function ModalHistoricoEnvios({ onFechar, onReenviado }) {
  const navigate = useNavigate();
  const [lista, setLista] = useState(null);
  const [busca, setBusca] = useState('');
  const [situacao, setSituacao] = useState('todos');
  const [aberta, setAberta] = useState(null);
  const [reenviando, setReenviando] = useState('');

  const carregar = useCallback(() => {
    api('/comunicacao/historico').then(r => r.json())
      .then(d => setLista(Array.isArray(d) ? d : []))
      .catch(() => setLista([]));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => {
    const esc = e => { if (e.key === 'Escape') onFechar(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onFechar]);

  const desde = new Date(Date.now() - DIAS_HISTORICO * 86400000);
  const quando = m => new Date(m.enviado_em || m.agendado_para);
  const periodo = (lista || []).filter(m => quando(m) >= desde);
  // 200 = limite do servidor: se todos caem nos 30 dias, pode haver envio mais antigo fora da lista
  const cortado = (lista || []).length >= 200 && periodo.length === lista.length;
  const termo = busca.trim().toLowerCase();
  const digitos = busca.replace(/\D/g, '');
  const visiveis = periodo.filter(m => {
    if (situacao !== 'todos' && m.status !== situacao) return false;
    if (!termo) return true;
    return [m.cliente_nome, m.texto_final, m.template_titulo, m.enviar_por_nome].some(v => String(v || '').toLowerCase().includes(termo))
      || (digitos.length >= 3 && String(m.telefone || '').includes(digitos));
  });
  const grupos = [];
  for (const m of visiveis) {
    const r = rotuloDia(quando(m));
    if (!grupos.length || grupos[grupos.length - 1].rotulo !== r) grupos.push({ rotulo: r, itens: [] });
    grupos[grupos.length - 1].itens.push(m);
  }
  const nEnviados = periodo.filter(m => m.status === 'enviado').length;
  const nFalhas = periodo.filter(m => m.status === 'falhou').length;

  async function reenviar(m) {
    if (!window.confirm(`Reenviar esta mensagem para ${m.cliente_nome || m.telefone}? Ela volta para a fila e sai em instantes.`)) return;
    setReenviando(m._id);
    const r = await api(`/comunicacao/fila/${m._id}/reenviar`, { method: 'POST' }).catch(() => null);
    setReenviando('');
    if (!r || !r.ok) {
      let det = ''; try { det = (await r.json()).erro || ''; } catch { /* sem detalhe */ }
      return alert(`Não consegui reenviar (HTTP ${r?.status || 'rede'}). ${det}`.trim());
    }
    setAberta(null);
    carregar();
    onReenviado && onReenviado();
  }

  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 860, maxWidth: '96vw', height: '88vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ background: '#0a1628', padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ color: '#fff', fontSize: 14, fontWeight: 700 }}>📋 Histórico de envios — últimos {DIAS_HISTORICO} dias</div>
            <div style={{ color: '#94a3b8', fontSize: 11 }}>Mensagens de WhatsApp que já saíram da fila (enviadas e com falha) · desde {desde.toLocaleDateString('pt-BR')}</div>
          </div>
          <button type="button" onClick={onFechar} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>

        <div style={{ padding: '10px 16px', borderBottom: '1px solid #e5e7eb', display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ fontSize: 12.5, color: '#0a1628' }}>
            <strong>{periodo.length}</strong> envio(s) · <span style={{ color: '#16a34a', fontWeight: 600 }}>✓ {nEnviados} enviado(s)</span>
            {nFalhas > 0 && <> · <span style={{ color: '#dc2626', fontWeight: 600 }}>✗ {nFalhas} com falha</span></>}
          </span>
          <select value={situacao} onChange={e => setSituacao(e.target.value)} style={{ ...inp, width: 'auto', marginLeft: 'auto' }}>
            <option value="todos">Todas as situações</option>
            <option value="enviado">Só enviados</option>
            <option value="falhou">Só com falha</option>
          </select>
          <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar cliente, telefone ou texto" style={{ ...inp, width: 240 }} />
        </div>

        <div style={{ flex: 1, overflowY: 'auto' }}>
          {lista === null && <div style={{ padding: 30, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Carregando…</div>}
          {lista !== null && visiveis.length === 0 && (
            <div style={{ padding: 30, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
              {periodo.length ? 'Nenhum envio com esse filtro.' : `Nenhuma mensagem enviada nos últimos ${DIAS_HISTORICO} dias.`}
            </div>
          )}
          {grupos.map(g => (
            <div key={g.rotulo}>
              <div style={{ position: 'sticky', top: 0, zIndex: 1, background: '#f1f5f9', padding: '5px 16px', fontSize: 11.5, fontWeight: 700, color: '#475569', textTransform: 'capitalize', borderBottom: '1px solid #e2e8f0' }}>
                {g.rotulo} <span style={{ fontWeight: 400, color: '#94a3b8', textTransform: 'none' }}>· {g.itens.length} envio(s)</span>
              </div>
              {g.itens.map(m => {
                const st = statusBadge(m.status);
                const ax = m.anexos?.length ? m.anexos : (m.anexo_nome ? [{ nome: m.anexo_nome }] : []);
                const ok = aberta === m._id;
                return (
                  <div key={m._id} style={{ borderBottom: '1px solid #f1f5f9', background: ok ? '#f8fafc' : '#fff' }}>
                    <div onClick={() => setAberta(ok ? null : m._id)} title="Clique para ver a mensagem completa"
                      style={{ display: 'grid', gridTemplateColumns: '52px minmax(0, 1.3fr) minmax(0, 2fr) 92px', gap: 10, alignItems: 'center', padding: '8px 16px', cursor: 'pointer' }}>
                      <span style={{ fontSize: 12, color: '#6b7280', fontVariantNumeric: 'tabular-nums' }}>{quando(m).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</span>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.cliente_nome || '—'}</div>
                        <div style={{ fontSize: 11, color: '#9ca3af' }}>📞 {m.telefone}{m.template_titulo ? ` · ${m.template_titulo}` : ''}</div>
                      </div>
                      <div style={{ minWidth: 0, fontSize: 12, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {ax.length > 0 && <span style={{ color: '#15803d', fontWeight: 600 }}>📎 {ax.length} · </span>}
                        {m.texto_final || <em style={{ color: '#9ca3af' }}>(só o arquivo, sem legenda)</em>}
                      </div>
                      <span title={m.erro || ''} style={{ background: st.bg, color: st.cor, padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 700, justifySelf: 'start' }}>{st.label}</span>
                    </div>
                    {ok && (
                      <div style={{ padding: '0 16px 12px 78px' }}>
                        {m.erro && <div style={{ fontSize: 12, color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, padding: '6px 10px', marginBottom: 8 }}>⚠ {m.erro}</div>}
                        {ax.length > 0 && <div style={{ fontSize: 12, color: '#15803d', fontWeight: 600, marginBottom: 6 }}>📎 {ax.map(a => a.nome || a.arquivo).join(' · ')}</div>}
                        <div style={{ fontSize: 12.5, color: '#0a1628', whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.5, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 6, padding: '8px 10px', marginBottom: 8 }}>
                          {m.texto_final || <em style={{ color: '#9ca3af' }}>(só o arquivo, sem legenda)</em>}
                        </div>
                        <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 8, lineHeight: 1.6 }}>
                          {m.status === 'falhou' ? 'Falhou em' : 'Enviada em'} {fmtDt(m.enviado_em)} · agendada para {fmtDt(m.agendado_para)}
                          {' · '}sai de: {m.enviar_por ? (m.enviar_por_nome || 'WhatsApp pessoal') : 'Contato da Preserva'}
                          {m.criado_por ? ` · agendada por ${m.criado_por}` : ''}
                        </div>
                        <div style={{ display: 'flex', gap: 8 }}>
                          {m.cliente_id && (
                            <button type="button" onClick={() => { onFechar(); navigate(`/clientes/${m.cliente_id}/editar`); }} style={{ ...btnOut, padding: '4px 12px' }}>👤 Abrir ficha do cliente</button>
                          )}
                          <button type="button" onClick={() => reenviar(m)} disabled={reenviando === m._id}
                            style={{ ...btn(m.status === 'falhou' ? '#dc2626' : '#0a1628'), padding: '4px 12px', opacity: reenviando === m._id ? 0.6 : 1 }}>
                            {reenviando === m._id ? 'Reenviando…' : '↻ Reenviar'}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        {cortado && (
          <div style={{ padding: '6px 16px', fontSize: 11.5, color: '#92400e', background: '#fffbeb', borderTop: '1px solid #fde68a' }}>
            Mostrando os 200 envios mais recentes do período.
          </div>
        )}
      </div>
    </div>
  );
}

// ── Aba Fila ──────────────────────────────────────────────────────────────────
function AbaFila({ recarregar }) {
  const [lista, setLista] = useState([]);
  const [historicoAberto, setHistoricoAberto] = useState(false);
  const navigate = useNavigate();

  const carregar = useCallback(() => {
    api('/comunicacao/fila').then(r => r.json()).then(setLista).catch(() => {});
  }, []);

  useEffect(() => { carregar(); }, [carregar, recarregar]);

  async function cancelar(id) {
    if (!window.confirm('Cancelar esta mensagem agendada?')) return;
    await api(`/comunicacao/fila/${id}`, { method: 'DELETE' });
    carregar();
  }

  // "Enviar agora" (pedido 25/10/2026): desconsidera o agendamento — o horário
  // vira agora e o servidor dispara na hora (mesma rota da edição)
  const [disparando, setDisparando] = useState('');
  async function enviarAgora(m) {
    if (!window.confirm(`Enviar agora a mensagem para ${m.cliente_nome || m.telefone}?\n\nO agendamento de ${fmtDt(m.agendado_para)} será desconsiderado.`)) return;
    setDisparando(m._id);
    const r = await api(`/comunicacao/fila/${m._id}`, {
      method: 'PUT', body: JSON.stringify({ agendado_para: new Date().toISOString() }),
    }).catch(() => null);
    if (!r || !r.ok) {
      setDisparando('');
      let det = ''; try { det = (await r.json()).erro || ''; } catch { /* sem detalhe */ }
      return alert(`Não consegui disparar (HTTP ${r?.status || 'rede'}). ${det}`.trim());
    }
    // o servidor manda em instantes: a lista se atualiza até a mensagem sair da fila
    carregar();
    setTimeout(carregar, 4000);
    setTimeout(() => { carregar(); setDisparando(''); }, 12000);
  }

  // Modal de leitura/edição: clique na linha abre o texto completo; dá pra
  // corrigir a mensagem e o horário SEM perder o agendamento
  const [msgAberta, setMsgAberta] = useState(null);
  const [textoEdit, setTextoEdit] = useState('');
  const [quandoEdit, setQuandoEdit] = useState('');
  const [salvandoEdit, setSalvandoEdit] = useState(false);
  const paraInputLocal = (iso) => {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
  };
  const abrirMsg = (m) => { setMsgAberta(m); setTextoEdit(m.texto_final || ''); setQuandoEdit(paraInputLocal(m.agendado_para)); };

  async function salvarEdicaoMsg() {
    if (!msgAberta || salvandoEdit) return;
    if (!quandoEdit) return alert('Defina a data e hora do envio.');
    setSalvandoEdit(true);
    const r = await api(`/comunicacao/fila/${msgAberta._id}`, {
      method: 'PUT',
      body: JSON.stringify({ texto_final: textoEdit, agendado_para: new Date(quandoEdit).toISOString() }),
    }).catch(() => null);
    setSalvandoEdit(false);
    if (!r || !r.ok) {
      let det = ''; try { det = (await r.json()).erro || ''; } catch { /* não-JSON */ }
      return alert(`Não consegui salvar (HTTP ${r?.status || 'rede'}). ${det}`.trim());
    }
    setMsgAberta(null);
    carregar();
  }

  const agendadas = lista.filter(m => m.status === 'agendado');
  const fecharHistorico = useCallback(() => setHistoricoAberto(false), []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, marginBottom: 10 }}>
        <span style={{ fontSize: 12.5, color: '#6b7280' }}>
          {agendadas.length ? `${agendadas.length} mensagem(ns) aguardando o horário de envio` : ''}
        </span>
        <button type="button" onClick={() => setHistoricoAberto(true)} title="Envios de WhatsApp dos últimos 30 dias"
          style={{ ...btnOut, padding: '6px 14px', fontWeight: 600, color: '#0a1628' }}>
          📋 Histórico (30 dias)
        </button>
      </div>
      {historicoAberto && <ModalHistoricoEnvios onFechar={fecharHistorico} onReenviado={carregar} />}
      {agendadas.length === 0 ? (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
          Nenhuma mensagem na fila.
        </div>
      ) : (
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
          <div style={{ background: '#0a1628', display: 'grid', gridTemplateColumns: '2fr 1fr 1fr auto', gap: 0, padding: '8px 14px' }}>
            {['Cliente / Mensagem', 'Template', 'Disparo em', ''].map(h => (
              <span key={h} style={{ fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</span>
            ))}
          </div>
          {agendadas.map((m, i) => (
            <div key={m._id} onClick={() => abrirMsg(m)} title="Clique pra ler a mensagem completa e editar se precisar"
              onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
              onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fafafa' : '#fff'}
              style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr auto', alignItems: 'center', gap: 0, padding: '10px 14px', borderBottom: i < agendadas.length - 1 ? '1px solid #f3f4f6' : 'none', background: i % 2 === 0 ? '#fafafa' : '#fff', cursor: 'pointer' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#0a1628' }}>{m.cliente_nome}</div>
                {(() => {
                  const ax = (m.anexos?.length ? m.anexos : (m.anexo_nome ? [{ nome: m.anexo_nome }] : []));
                  return ax.length ? (
                    <div style={{ fontSize: 11, color: '#15803d', fontWeight: 600, marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>
                      📎 {ax.map(a => a.nome).join(' · ')}
                    </div>
                  ) : null;
                })()}
                <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>{m.texto_final || <em style={{ color: '#9ca3af' }}>(só o arquivo, sem legenda)</em>}</div>
                <div style={{ fontSize: 11, color: '#9ca3af' }}>📞 {m.telefone}</div>
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#374151' }}>{m.template_titulo}</div>
                {/* De qual número a mensagem sai */}
                <div style={{ fontSize: 11, fontWeight: 600, color: m.enviar_por ? '#1d4ed8' : '#6b7280', marginTop: 2 }}>
                  {m.enviar_por ? `👤 sai de: ${m.enviar_por_nome || 'WhatsApp pessoal'}` : '🏢 sai de: Contato da Preserva'}
                </div>
              </div>
              <div style={{ fontSize: 12, color: '#d97706', fontWeight: 600 }}>{disparando === m._id ? 'disparando agora…' : fmtDt(m.agendado_para)}</div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button title="Dispara já, sem esperar o horário agendado" disabled={disparando === m._id}
                  style={{ ...btn('#16a34a'), padding: '4px 12px', fontSize: 11, whiteSpace: 'nowrap', opacity: disparando === m._id ? 0.6 : 1 }}
                  onClick={e => { e.stopPropagation(); enviarAgora(m); }}>
                  {disparando === m._id ? 'Enviando…' : '▶ Enviar agora'}
                </button>
                <button style={{ ...btn('#dc2626'), padding: '4px 12px', fontSize: 11 }} onClick={e => { e.stopPropagation(); cancelar(m._id); }}>Cancelar</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Ler/editar mensagem agendada — salva e o envio continua programado */}
      {msgAberta && (
        <div onClick={() => setMsgAberta(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 560, maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ background: '#0a1628', padding: '10px 16px', borderRadius: '10px 10px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ color: '#fff', fontSize: 14, fontWeight: 700 }}>✉️ Mensagem agendada</div>
                <div style={{ color: '#94a3b8', fontSize: 11 }}>{msgAberta.cliente_nome} · 📞 {msgAberta.telefone}{msgAberta.template_titulo ? ` · ${msgAberta.template_titulo}` : ''} · sai de: {msgAberta.enviar_por ? (msgAberta.enviar_por_nome || 'WhatsApp pessoal') : 'Contato da Preserva'}</div>
              </div>
              <button onClick={() => setMsgAberta(null)} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
            </div>
            <div style={{ padding: 16 }}>
              {(msgAberta.anexos?.length > 0) && (
                <div style={{ fontSize: 12, color: '#15803d', fontWeight: 600, marginBottom: 8 }}>
                  📎 {msgAberta.anexos.map(a => a.nome).join(' · ')} <span style={{ color: '#9ca3af', fontWeight: 400 }}>(saem antes da mensagem)</span>
                </div>
              )}
              <div style={{ fontSize: 11.5, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>Texto da mensagem</div>
              <textarea value={textoEdit} onChange={e => setTextoEdit(e.target.value)}
                style={{ ...inp, width: '100%', boxSizing: 'border-box', minHeight: 180, resize: 'vertical', lineHeight: 1.5, marginBottom: 12 }} />
              <div style={{ fontSize: 11.5, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>Disparo em</div>
              <div style={{ marginBottom: 14 }}><CampoDataHora value={quandoEdit} onChange={setQuandoEdit} style={inp} /></div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <button onClick={salvarEdicaoMsg} disabled={salvandoEdit}
                  style={{ ...btn('#16a34a'), padding: '8px 18px', fontSize: 13, opacity: salvandoEdit ? 0.6 : 1 }}>
                  {salvandoEdit ? 'Salvando…' : '💾 Salvar — continua programado'}
                </button>
                <button onClick={() => setMsgAberta(null)} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '8px 14px', fontSize: 13, cursor: 'pointer' }}>Fechar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Aba Histórico ─────────────────────────────────────────────────────────────
function AbaHistorico() {
  const [lista, setLista] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api('/comunicacao/historico').then(r => r.json()).then(setLista).catch(() => {});
  }, []);

  return (
    <div>
      {lista.length === 0 ? (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
          Nenhuma mensagem enviada ainda.
        </div>
      ) : (
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
          <div style={{ background: '#0a1628', display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 80px', gap: 0, padding: '8px 14px' }}>
            {['Cliente / Mensagem', 'Template', 'Enviado em', 'Status'].map(h => (
              <span key={h} style={{ fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</span>
            ))}
          </div>
          {lista.map((m, i) => {
            const st = statusBadge(m.status);
            return (
              <div key={m._id} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 80px', alignItems: 'center', gap: 0, padding: '10px 14px', borderBottom: i < lista.length - 1 ? '1px solid #f3f4f6' : 'none', background: i % 2 === 0 ? '#fafafa' : '#fff' }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#0a1628', cursor: m.cliente_id ? 'pointer' : 'default', textDecoration: m.cliente_id ? 'underline' : 'none' }}
                    onClick={() => m.cliente_id && navigate(`/clientes/${m.cliente_id}/editar`)}>
                    {m.cliente_nome}
                  </div>
                  <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 300 }}>{m.texto_final}</div>
                  <div style={{ fontSize: 11, color: '#9ca3af' }}>📞 {m.telefone}</div>
                </div>
                <div style={{ fontSize: 12, color: '#374151' }}>{m.template_titulo}</div>
                <div style={{ fontSize: 12, color: '#374151' }}>{fmtDt(m.enviado_em || m.agendado_para)}</div>
                <span style={{ background: st.bg, color: st.cor, padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 700 }}>{st.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── Aba Comunicado geral ──────────────────────────────────────────────────────
// Escreve uma vez → mensagem individual pra cada pessoa da equipe (sai do
// WhatsApp da empresa pela fila, com retentativa de 24h)
function AbaComunicado({ onEnviado }) {
  const [texto, setTexto] = useState('');
  const [publico, setPublico] = useState('todos');
  const [quando, setQuando] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [formatando, setFormatando] = useState(false);
  const [antesDeFormatar, setAntesDeFormatar] = useState(null); // pra desfazer
  const [equipe, setEquipe] = useState([]);
  const [marcados, setMarcados] = useState([]);
  const [numeros, setNumeros] = useState({}); // {userId: 'ambos'|'trabalho'|'pessoal'}
  // De onde sai: '' = Contato da Preserva; senão, sessão pessoal (igual à aba Agendar)
  const [remetentes, setRemetentes] = useState([]);
  const [remetenteSel, setRemetenteSel] = useState('');

  useEffect(() => {
    api('/usuarios').then(r => r.json())
      .then(us => setEquipe((us || []).filter(u => u.email !== 'clau@preservamarcas.com.br')))
      .catch(() => {});
    api('/comunicacao/remetentes').then(r => r.json())
      .then(d => setRemetentes(Array.isArray(d) ? d : []))
      .catch(() => {});
  }, []);

  async function formatar() {
    if (!texto.trim()) return setResultado({ erro: 'Escreva o rascunho antes de formatar.' });
    setFormatando(true); setResultado(null);
    const r = await api('/comunicacao/formatar', { method: 'POST', body: JSON.stringify({ rascunho: texto, publico: 'equipe' }) })
      .then(x => x.json()).catch(() => ({ erro: 'Falha ao formatar.' }));
    setFormatando(false);
    if (r.erro) return setResultado({ erro: r.erro });
    setAntesDeFormatar(texto);
    setTexto(r.texto);
  }

  async function enviar() {
    if (!texto.trim()) return setResultado({ erro: 'Escreva o comunicado.' });
    setEnviando(true); setResultado(null);
    const body = { texto: texto.trim(), publico };
    if (publico === 'selecionados') { body.ids = marcados; body.numeros = numeros; }
    if (quando) body.agendado_para = new Date(quando).toISOString();
    body.enviar_por = remetenteSel;
    body.enviar_por_nome = remetentes.find(x => x.id === remetenteSel)?.nome || '';
    const r = await api('/comunicacao/comunicado', { method: 'POST', body: JSON.stringify(body) })
      .then(x => x.json()).catch(() => ({ erro: 'Falha ao enviar.' }));
    setResultado(r);
    setEnviando(false);
    if (r.ok) { setTexto(''); setQuando(''); onEnviado && onEnviado(); }
  }

  const inp2 = { padding: '6px 10px', borderRadius: 6, border: '1px solid #d1d5db', fontSize: 13 };
  return (
    <div style={{ maxWidth: 560 }}>
      <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '8px 12px', fontSize: 12, color: '#92400e', marginBottom: 12 }}>
        Cada pessoa recebe como <strong>mensagem individual</strong> — não é grupo. Quem envia não recebe.
      </div>
      {remetentes.length > 1 && (
        <>
          <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>De onde sai</div>
          <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
            {remetentes.map(r => {
              const on = remetenteSel === r.id;
              const conectado = r.status === 'conectado';
              return (
                <button key={r.id || 'empresa'} type="button" onClick={() => setRemetenteSel(r.id)}
                  disabled={!conectado}
                  title={conectado ? '' : 'Desconectado — conecte em Configurações'}
                  style={{
                    flex: 1, padding: '6px 10px', fontSize: 12, fontWeight: 700, borderRadius: 6,
                    cursor: conectado ? 'pointer' : 'not-allowed', opacity: conectado ? 1 : 0.45,
                    border: '1px solid ' + (on ? '#0a1628' : '#d1d5db'),
                    background: on ? '#0a1628' : '#fff',
                    color: on ? '#fff' : '#374151',
                  }}>
                  {r.id ? '👤 ' : '🏢 '}{r.nome}{conectado ? '' : ' (off)'}
                </button>
              );
            })}
          </div>
        </>
      )}
      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>Quem recebe</div>
      <select value={publico} onChange={e => setPublico(e.target.value)} style={{ ...inp2, width: '100%', marginBottom: publico === 'selecionados' ? 6 : 10 }}>
        <option value="todos">👥 Equipe toda</option>
        <option value="closers">🧭 Só closers</option>
        <option value="sdrs">📞 Só SDRs</option>
        <option value="selecionados">✔️ Escolher a dedo</option>
      </select>
      {publico === 'selecionados' && (
        <div style={{ border: '1px solid #d1d5db', borderRadius: 6, padding: '6px 4px', marginBottom: 10, background: '#fafafa' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 6px 4px' }}>
            <span style={{ fontSize: 11.5, color: '#6b7280' }}>{marcados.length} de {equipe.length} marcado(s)</span>
            <div style={{ display: 'flex', gap: 6 }}>
              <button type="button" onClick={() => setMarcados(equipe.map(u => u._id))} style={{ background: 'none', border: 'none', color: '#0a1628', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>marcar todos</button>
              <button type="button" onClick={() => setMarcados([])} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 11, cursor: 'pointer' }}>limpar</button>
            </div>
          </div>
          {equipe.map(u => {
            const on = marcados.includes(u._id);
            const tTrab = (u.telefone || '').replace(/\D/g, '');
            const tPess = (u.telefone_pessoal || '').replace(/\D/g, '');
            const dois = tTrab.length >= 10 && tPess.length >= 10;
            const semTel = !(tTrab.length >= 10 || tPess.length >= 10);
            const esc = numeros[u._id] || 'ambos';
            return (
              <div key={u._id} style={{ padding: '5px 8px', borderRadius: 4, background: on ? '#eef2ff' : 'transparent' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', textAlign: 'left' }}>
                  <input type="checkbox" checked={on} style={{ width: 15, height: 15, flexShrink: 0, margin: 0, padding: 0 }}
                    onChange={() => setMarcados(m => on ? m.filter(x => x !== u._id) : [...m, u._id])} />
                  <span style={{ fontSize: 13, fontWeight: on ? 700 : 400, color: '#0a1628', whiteSpace: 'nowrap' }}>{u.nome}</span>
                  <span style={{ fontSize: 11, color: '#9ca3af', whiteSpace: 'nowrap', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{u.cargo || ''}</span>
                  {semTel && <span style={{ fontSize: 10, color: '#b45309', whiteSpace: 'nowrap', flexShrink: 0 }}>⚠ sem telefone</span>}
                </label>
                {on && dois && (
                  <div style={{ display: 'flex', gap: 4, marginTop: 3, marginLeft: 23 }}>
                    {[['ambos', 'os dois'], ['trabalho', `trabalho ${tTrab.slice(-4)}`], ['pessoal', `pessoal ${tPess.slice(-4)}`]].map(([k, rot]) => (
                      <button key={k} type="button" onClick={() => setNumeros(n => ({ ...n, [u._id]: k }))}
                        style={{ fontSize: 10, padding: '1px 8px', borderRadius: 10, cursor: 'pointer', whiteSpace: 'nowrap',
                          border: `1px solid ${esc === k ? '#0a1628' : '#d1d5db'}`, background: esc === k ? '#0a1628' : '#fff', color: esc === k ? '#fff' : '#6b7280', fontWeight: esc === k ? 700 : 400 }}>{rot}</button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4, gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, color: '#6b7280' }}>Comunicado <span style={{ color: '#9ca3af' }}>— escreva solto e deixe o ✨ arrumar</span></span>
        <div style={{ display: 'flex', gap: 6 }}>
          {antesDeFormatar && (
            <button type="button" onClick={() => { setTexto(antesDeFormatar); setAntesDeFormatar(null); }}
              style={{ background: '#fff', border: '1px solid #d1d5db', color: '#374151', borderRadius: 6, padding: '4px 10px', fontSize: 11.5, cursor: 'pointer' }}>
              ↩ Voltar ao rascunho
            </button>
          )}
          <button type="button" onClick={formatar} disabled={formatando || !texto.trim()}
            title="Reescreve o seu rascunho no padrão das mensagens da casa"
            style={{ background: formatando ? '#e5e7eb' : 'linear-gradient(135deg,#3b82f6,#8b5cf6)', color: formatando ? '#9ca3af' : '#fff', border: 'none', borderRadius: 6, padding: '4px 14px', fontSize: 11.5, fontWeight: 700, cursor: formatando || !texto.trim() ? 'default' : 'pointer', opacity: !texto.trim() ? 0.5 : 1 }}>
            {formatando ? 'Arrumando…' : '✨ Formatar'}
          </button>
        </div>
      </div>
      <textarea value={texto} onChange={e => setTexto(e.target.value)} rows={6}
        placeholder={'Escreva do seu jeito, sem se preocupar com formato. Ex.: "segunda o expediente começa 9h por causa da manutenção" — depois clique em ✨ Formatar.'}
        style={{ ...inp2, width: '100%', resize: 'vertical', boxSizing: 'border-box' }} />
      <div style={{ fontSize: 12, color: '#6b7280', margin: '10px 0 4px' }}>Enviar em <span style={{ color: '#9ca3af' }}>(vazio = agora)</span></div>
      <div style={{ marginBottom: 12 }}><CampoDataHora value={quando} onChange={setQuando} style={inp2} /></div>
      <div>
        <button onClick={enviar} disabled={enviando}
          style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '8px 20px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: enviando ? 0.6 : 1 }}>
          {enviando ? 'Enfileirando…' : '📢 Enviar comunicado'}
        </button>
      </div>
      {resultado && (
        <div style={{ marginTop: 10, fontSize: 12.5, background: resultado.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${resultado.ok ? '#bbf7d0' : '#fecaca'}`, borderRadius: 6, padding: '8px 12px', color: resultado.ok ? '#166534' : '#b91c1c' }}>
          {resultado.ok
            ? <>✅ Na fila pra <strong>{resultado.enfileirados}</strong> pessoa(s): {resultado.para.join(', ')}.
                {resultado.sem_telefone?.length > 0 && <div style={{ color: '#b45309', marginTop: 4 }}>⚠ Sem telefone no cadastro (não receberam): {resultado.sem_telefone.join(', ')}</div>}</>
            : `⚠ ${resultado.erro}`}
        </div>
      )}
    </div>
  );
}

// ── Aba Comentário no Google Negócio (06/09/2026) ─────────────────────────────
// Só clientes com registro de marca EM VIGOR (conferido na base RPI). Mostra
// quem já recebeu o pedido de avaliação, deixa filtrar enviados × não
// enviados, marcar a dedo e mandar em lote pela fila (com intervalo entre
// mensagens pra não sair em rajada).
const TEXTO_GOOGLE_PADRAO = `Oi! Sou a Clau, a inteligência artificial da Preserva Marcas.

Vi que a sua marca foi aprovada e que o certificado de registro já chegou. Parabéns, agora ela está protegida em todo o Brasil por dez anos.

Posso te pedir uma ajuda? Deixa um comentário no nosso Google contando como foi sua experiência com a Preserva. Assim outras pessoas que estão pensando em registrar a marca sabem o que esperar da gente.

É rapidinho, é só clicar aqui:
https://g.page/r/CZkXPuHB8ahXEBM/review

Obrigada!`;

function AbaGoogle({ onEnviado }) {
  const [dados, setDados] = useState({ itens: [], total: 0, enviados: 0, sem_telefone: 0 });
  const [carregando, setCarregando] = useState(true);
  const [filtro, setFiltro] = useState('nao'); // 'nao' | 'sim' | 'todos'
  const [busca, setBusca] = useState('');
  const [marcados, setMarcados] = useState([]);
  const [texto, setTexto] = useState(TEXTO_GOOGLE_PADRAO);
  const [intervalo, setIntervalo] = useState('2');
  const [quando, setQuando] = useState('');
  const [remetentes, setRemetentes] = useState([]);
  const [remetenteSel, setRemetenteSel] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const navigate = useNavigate();

  const carregar = useCallback(() => {
    setCarregando(true);
    api('/comunicacao/google-avaliacao/clientes').then(r => r.json())
      .then(d => { if (d && Array.isArray(d.itens)) setDados(d); })
      .catch(() => {})
      .finally(() => setCarregando(false));
  }, []);

  useEffect(() => {
    carregar();
    api('/comunicacao/remetentes').then(r => r.json()).then(d => setRemetentes(Array.isArray(d) ? d : [])).catch(() => {});
    // Texto oficial fica no Gerador de Mensagem (Sucesso do Cliente); se não achar, usa o padrão acima
    api('/sucesso-cliente/mensagens').then(r => r.json()).then(lista => {
      const m = (Array.isArray(lista) ? lista : []).find(x => /CLAU/i.test(x.titulo || '') && /GOOGLE/i.test(x.titulo || ''));
      if (m?.texto) setTexto(m.texto);
    }).catch(() => {});
  }, [carregar]);

  const jaEnviou = (c) => !!(c.envio && c.envio.status !== 'falhou');
  const re = busca.trim() ? new RegExp(busca.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : null;
  const visiveis = dados.itens.filter(c => {
    if (filtro === 'nao' && jaEnviou(c)) return false;
    if (filtro === 'sim' && !jaEnviou(c)) return false;
    if (re && !(re.test(c.nome) || c.registros.some(r => re.test(r.marca)) || re.test(c.telefone))) return false;
    return true;
  });
  const comTel = (c) => c.telefone && c.telefone.length >= 10;
  const idsVisiveis = visiveis.filter(comTel).map(c => c.cliente_id);
  const marcarTodos = () => setMarcados(m => [...new Set([...m, ...idsVisiveis])]);
  const limpar = () => setMarcados([]);
  const alternar = (id) => setMarcados(m => m.includes(id) ? m.filter(x => x !== id) : [...m, id]);

  const statusDe = (c) => {
    if (!c.envio) return { label: 'Não enviado', bg: '#f3f4f6', cor: '#6b7280' };
    const em = c.envio.em ? fmtDt(c.envio.em) : '';
    if (c.envio.status === 'enviado') return { label: `Enviado ${em}`, bg: '#f0fdf4', cor: '#16a34a' };
    if (c.envio.status === 'agendado') return { label: `Agendado ${em}`, bg: '#fffbeb', cor: '#d97706' };
    return { label: `Falhou ${em}`, bg: '#fef2f2', cor: '#dc2626' };
  };

  async function enviar() {
    if (!marcados.length) return setResultado({ erro: 'Marque pelo menos um cliente na lista.' });
    if (!texto.trim()) return setResultado({ erro: 'Escreva a mensagem.' });
    const repetidos = dados.itens.filter(c => marcados.includes(c.cliente_id) && jaEnviou(c)).length;
    const aviso = `Enviar o pedido de avaliação para ${marcados.length} cliente(s)` +
      (intervalo !== '0' ? `, um a cada ${intervalo} min` : ', todos de uma vez') +
      (repetidos ? `?\n\nAtenção: ${repetidos} deles JÁ receberam antes.` : '?');
    if (!window.confirm(aviso)) return;
    setEnviando(true); setResultado(null);
    const body = { ids: marcados, texto: texto.trim(), intervalo_min: Number(intervalo), enviar_por: remetenteSel, enviar_por_nome: remetentes.find(x => x.id === remetenteSel)?.nome || '' };
    if (quando) body.agendado_para = new Date(quando).toISOString();
    const r = await api('/comunicacao/google-avaliacao/enviar', { method: 'POST', body: JSON.stringify(body) })
      .then(x => x.json()).catch(() => ({ erro: 'Falha ao enfileirar.' }));
    setEnviando(false);
    setResultado(r);
    if (r.ok) { setMarcados([]); carregar(); onEnviado && onEnviado(); }
  }

  const naoEnviados = dados.total - dados.enviados;
  const chip = (k, rot, n) => (
    <button key={k} type="button" onClick={() => { setFiltro(k); setMarcados([]); }}
      style={{ padding: '5px 12px', fontSize: 12, fontWeight: filtro === k ? 700 : 500, borderRadius: 14, cursor: 'pointer',
        border: `1px solid ${filtro === k ? '#0a1628' : '#d1d5db'}`, background: filtro === k ? '#0a1628' : '#fff', color: filtro === k ? '#fff' : '#374151' }}>
      {rot} <span style={{ opacity: 0.75 }}>({n})</span>
    </button>
  );

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 340px', gap: 16, alignItems: 'start' }}>
      {/* Lista */}
      <div>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
          {chip('nao', 'Não enviados', naoEnviados)}
          {chip('sim', 'Já enviados', dados.enviados)}
          {chip('todos', 'Todos com marca em vigor', dados.total)}
          <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar cliente, marca ou telefone"
            style={{ ...inp, width: 240, marginLeft: 'auto' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6, fontSize: 12, color: '#6b7280' }}>
          <span>{visiveis.length} cliente(s) na lista · <strong style={{ color: '#0a1628' }}>{marcados.length} marcado(s)</strong>{dados.sem_telefone ? ` · ${dados.sem_telefone} sem telefone no cadastro` : ''}</span>
          <span style={{ display: 'flex', gap: 10 }}>
            <button type="button" onClick={marcarTodos} style={{ background: 'none', border: 'none', color: '#0a1628', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>marcar todos da lista</button>
            <button type="button" onClick={limpar} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer' }}>limpar</button>
          </span>
        </div>
        {carregando ? (
          <div style={{ padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Conferindo os registros na base RPI…</div>
        ) : visiveis.length === 0 ? (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
            {filtro === 'nao' ? 'Todo mundo com marca em vigor já recebeu o pedido de avaliação.' : 'Nenhum cliente aqui.'}
          </div>
        ) : (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden', maxHeight: 560, overflowY: 'auto' }}>
            <div style={{ background: '#0a1628', display: 'grid', gridTemplateColumns: '28px 2fr 1.6fr 1fr 150px', gap: 8, padding: '8px 12px', position: 'sticky', top: 0 }}>
              {['', 'Cliente', 'Marca(s) em vigor', 'Telefone', 'Pedido de avaliação'].map((h, i) => (
                <span key={i} style={{ fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</span>
              ))}
            </div>
            {visiveis.map((c, i) => {
              const on = marcados.includes(c.cliente_id);
              const st = statusDe(c);
              const semTel = !comTel(c);
              return (
                <div key={c.cliente_id} onClick={() => !semTel && alternar(c.cliente_id)}
                  style={{ display: 'grid', gridTemplateColumns: '28px 2fr 1.6fr 1fr 150px', gap: 8, alignItems: 'center', padding: '8px 12px',
                    borderBottom: '1px solid #f3f4f6', background: on ? '#eef2ff' : (i % 2 === 0 ? '#fafafa' : '#fff'), cursor: semTel ? 'not-allowed' : 'pointer', opacity: semTel ? 0.6 : 1 }}>
                  <input type="checkbox" checked={on} disabled={semTel} onChange={() => alternar(c.cliente_id)} onClick={e => e.stopPropagation()} style={{ width: 15, height: 15, margin: 0 }} />
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#0a1628', textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={e => { e.stopPropagation(); navigate(`/clientes/${c.cliente_id}/editar`); }}>{c.nome}</div>
                    {c.cidade && <div style={{ fontSize: 11, color: '#9ca3af' }}>{c.cidade}</div>}
                  </div>
                  <div style={{ fontSize: 12, color: '#374151' }}>
                    {c.registros.map(r => (
                      <div key={r.processo} title={`Processo ${r.processo} · classe ${r.classe} · vigência até ${r.vigencia}`}>{r.marca} <span style={{ color: '#9ca3af', fontSize: 11 }}>· até {r.vigencia.slice(-4)}</span></div>
                    ))}
                  </div>
                  <div style={{ fontSize: 12, color: semTel ? '#b45309' : '#374151' }}>{semTel ? '⚠ sem telefone' : c.telefone}</div>
                  <span style={{ background: st.bg, color: st.cor, padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 700, justifySelf: 'start' }}>{st.label}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Painel de envio */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14, position: 'sticky', top: 12 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>⭐ Pedido de avaliação no Google</div>
        {remetentes.length > 1 && (
          <>
            <div style={lbl}>De onde sai</div>
            <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
              {remetentes.map(r => {
                const on = remetenteSel === r.id;
                const conectado = r.status === 'conectado';
                return (
                  <button key={r.id || 'empresa'} type="button" onClick={() => setRemetenteSel(r.id)} disabled={!conectado}
                    style={{ flex: 1, padding: '5px 8px', fontSize: 11.5, fontWeight: 700, borderRadius: 6, cursor: conectado ? 'pointer' : 'not-allowed', opacity: conectado ? 1 : 0.45,
                      border: '1px solid ' + (on ? '#0a1628' : '#d1d5db'), background: on ? '#0a1628' : '#fff', color: on ? '#fff' : '#374151' }}>
                    {r.id ? '👤 ' : '🏢 '}{r.nome}{conectado ? '' : ' (off)'}
                  </button>
                );
              })}
            </div>
          </>
        )}
        <div style={lbl}>Mensagem <span style={{ color: '#9ca3af', fontWeight: 400 }}>(pode usar {'{nome}'} e {'{marca}'})</span></div>
        <textarea value={texto} onChange={e => setTexto(e.target.value)} rows={13}
          style={{ ...inp, resize: 'vertical', lineHeight: 1.45, marginBottom: 10 }} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
          <div>
            <div style={lbl}>Intervalo entre mensagens</div>
            <select value={intervalo} onChange={e => setIntervalo(e.target.value)} style={inp}>
              <option value="0">sem intervalo</option>
              <option value="1">1 min</option>
              <option value="2">2 min</option>
              <option value="5">5 min</option>
              <option value="10">10 min</option>
            </select>
          </div>
          <div>
            <div style={lbl}>Começar em <span style={{ color: '#9ca3af', fontWeight: 400 }}>(vazio = agora)</span></div>
            <CampoDataHora value={quando} onChange={setQuando} style={inp} />
          </div>
        </div>
        <button onClick={enviar} disabled={enviando || !marcados.length}
          style={{ ...btn('#16a34a'), width: '100%', padding: '9px 0', fontSize: 13, opacity: enviando || !marcados.length ? 0.5 : 1 }}>
          {enviando ? 'Enfileirando…' : `📨 Enviar para ${marcados.length} cliente(s)`}
        </button>
        {resultado && (
          <div style={{ marginTop: 10, fontSize: 12.5, background: resultado.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${resultado.ok ? '#bbf7d0' : '#fecaca'}`, borderRadius: 6, padding: '8px 12px', color: resultado.ok ? '#166534' : '#b91c1c' }}>
            {resultado.ok
              ? <>✅ <strong>{resultado.enfileirados}</strong> mensagem(ns) na fila{resultado.intervalo_min ? `, uma a cada ${resultado.intervalo_min} min` : ''}. Acompanhe na aba Fila.
                  {resultado.sem_telefone?.length > 0 && <div style={{ color: '#b45309', marginTop: 4 }}>⚠ Sem telefone: {resultado.sem_telefone.join(', ')}</div>}
                  {resultado.sem_registro?.length > 0 && <div style={{ color: '#b45309', marginTop: 4 }}>⚠ Sem registro em vigor: {resultado.sem_registro.join(', ')}</div>}</>
              : `⚠ ${resultado.erro}`}
          </div>
        )}
        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 10, lineHeight: 1.4 }}>
          A lista vem do cruzamento dos processos do cadastro com a base RPI: só entra marca concedida, ativa e dentro do decênio. "Já enviado" considera esta aba e os envios do Sucesso do Cliente com o modelo de avaliação no Google.
        </div>
      </div>
    </div>
  );
}

// ── Aba E-mail (22/10/2026) ───────────────────────────────────────────────────
// Clientes com e-mail no cadastro e/ou uma lista avulsa colada na hora (sem
// vínculo com cadastro). Sai pela caixa configurada no ⚙️, com "sair da lista"
// em todo e-mail — quem sai não recebe mais.
const EMAIL_NO_TEXTO = /[^\s<>()[\],;:"']+@[^\s<>()[\],;:"']+/g;
const emailOk = e => /^[^\s@<>(),;:"']+@[^\s@<>(),;:"']+\.[a-z]{2,}$/i.test(e);

function lerListaEmails(texto) {
  const vistos = new Set(), validos = [], invalidos = [];
  let repetidos = 0;
  for (const bruto of String(texto || '').match(EMAIL_NO_TEXTO) || []) {
    const e = bruto.replace(/\.+$/, '').toLowerCase();
    if (!emailOk(e)) { invalidos.push(e); continue; }
    if (vistos.has(e)) { repetidos++; continue; }
    vistos.add(e); validos.push(e);
  }
  return { validos, invalidos, repetidos };
}

function statusEmail(s) {
  if (s === 'enviado') return { label: 'Enviado', bg: '#f0fdf4', cor: '#16a34a' };
  if (s === 'falhou') return { label: 'Falhou', bg: '#fef2f2', cor: '#dc2626' };
  if (s === 'cancelado') return { label: 'Cancelado', bg: '#f3f4f6', cor: '#6b7280' };
  if (s === 'descadastrado') return { label: 'Saiu da lista', bg: '#f3f4f6', cor: '#6b7280' };
  if (s === 'devolvido') return { label: 'Voltou', bg: '#fef2f2', cor: '#b91c1c' }; // a devolução chegou na caixa (endereço não existe etc.)
  return { label: 'Na fila', bg: '#fffbeb', cor: '#d97706' };
}

const textoEmailPadrao = () => assinatura('Olá {nome},');

function ModalConfigEmail({ cfg, onFechar, onSalvo }) {
  const [f, setF] = useState({ host: cfg?.host || 'smtp.hostinger.com', porta: cfg?.porta || 465, usuario: cfg?.usuario || '', senha: '', remetente_nome: cfg?.remetente_nome || 'Preserva Marcas', limite_dia: cfg?.limite_dia || 500, imap_host: cfg?.imap_host || '', imap_porta: cfg?.imap_porta || 993 });
  const [para, setPara] = useState('');
  const [msg, setMsg] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  const campo = (k, rot, extra = {}) => (
    <div>
      <div style={lbl}>{rot}</div>
      <input value={f[k]} onChange={e => setF(x => ({ ...x, [k]: e.target.value }))} style={inp} {...extra} />
    </div>
  );
  async function salvar() {
    setOcupado(true); setMsg(null);
    const r = await api('/comunicacao/email/config', { method: 'PUT', body: JSON.stringify(f) }).then(x => x.json()).catch(() => ({ erro: 'Falha ao salvar.' }));
    setOcupado(false);
    setMsg(r.ok ? { ok: true, texto: 'Configuração salva.' } : { texto: r.erro });
    if (r.ok) { setF(x => ({ ...x, senha: '' })); onSalvo(); }
  }
  async function testar() {
    setOcupado(true); setMsg(null);
    const r = await api('/comunicacao/email/testar', { method: 'POST', body: JSON.stringify({ para }) }).then(x => x.json()).catch(() => ({ erro: 'Falha no teste.' }));
    setOcupado(false);
    setMsg(r.ok ? { ok: true, texto: `E-mail de teste enviado para ${para}. Confira a caixa de entrada (e o spam).` } : { texto: r.erro });
  }
  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 520, maxWidth: '95vw', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ background: '#0a1628', color: '#fff', padding: '10px 16px', fontSize: 14, fontWeight: 700, display: 'flex', justifyContent: 'space-between' }}>
          ⚙️ E-mail de envio
          <button type="button" onClick={onFechar} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: 16, display: 'grid', gap: 10 }}>
          <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.45 }}>
            A caixa que vai mandar os e-mails (Hostinger do preserva.online). A senha fica guardada só no servidor e não aparece mais nesta tela.
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 8 }}>
            {campo('host', 'Servidor de envio (SMTP)')}
            {campo('porta', 'Porta', { type: 'number' })}
          </div>
          {campo('usuario', 'E-mail de envio', { placeholder: 'contato@preserva.online' })}
          {campo('senha', 'Senha da caixa', { type: 'password', placeholder: cfg?.tem_senha ? '•••••••• (já cadastrada — em branco mantém)' : 'senha do e-mail', autoComplete: 'new-password' })}
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 8 }}>
            {campo('remetente_nome', 'Nome que aparece para quem recebe')}
            {campo('limite_dia', 'Limite por dia', { type: 'number' })}
          </div>
          <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.45, borderTop: '1px solid #e5e7eb', paddingTop: 10 }}>
            📥 Respostas: o sistema lê esta mesma caixa (entrada e spam) a cada 3 minutos, só leitura. Em branco, o servidor de recebimento é o do envio com "imap".
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 8 }}>
            {campo('imap_host', 'Servidor de recebimento (IMAP)', { placeholder: `${String(f.host || 'smtp.hostinger.com').replace(/^smtp\./i, 'imap.')} (automático)` })}
            {campo('imap_porta', 'Porta', { type: 'number' })}
          </div>
          <button type="button" onClick={salvar} disabled={ocupado} style={{ ...btn(), padding: '8px 0', opacity: ocupado ? 0.6 : 1 }}>💾 Salvar configuração</button>
          <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 10, display: 'flex', gap: 8, alignItems: 'flex-end' }}>
            <div style={{ flex: 1 }}>
              <div style={lbl}>Enviar e-mail de teste para</div>
              <input value={para} onChange={e => setPara(e.target.value)} placeholder="seu@email.com" style={inp} />
            </div>
            <button type="button" onClick={testar} disabled={ocupado || !para.trim()} style={{ ...btnOut, padding: '7px 14px', opacity: ocupado || !para.trim() ? 0.5 : 1 }}>✉️ Testar</button>
          </div>
          {msg && (
            <div style={{ fontSize: 12.5, borderRadius: 6, padding: '8px 12px', background: msg.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${msg.ok ? '#bbf7d0' : '#fecaca'}`, color: msg.ok ? '#166534' : '#b91c1c' }}>
              {msg.ok ? '✅ ' : '⚠ '}{msg.texto}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function EnviarEmail() {
  const [cfg, setCfg] = useState(null);
  const [abrirCfg, setAbrirCfg] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState('');
  const [marcados, setMarcados] = useState([]);
  const [avulsos, setAvulsos] = useState('');
  const [assunto, setAssunto] = useState('');
  const [texto, setTexto] = useState(textoEmailPadrao);
  // 'simples' (padrão): só texto, cai na Principal do Gmail; 'cabecalho': com a
  // identidade da Preserva, para campanhas (costuma cair em Promoções)
  const [formato, setFormato] = useState('simples');
  const [anexos, setAnexos] = useState([]); // [{ arquivo, nome, tamanho }] — ver AnexosEmail
  const [agendar, setAgendar] = useState(false); // mostra o dia e a hora só quando pedir
  // Lista de clientes aberta/recolhida — fica lembrada neste navegador
  const [clientesAbertos, setClientesAbertos] = useState(() => {
    try { return localStorage.getItem('email_clientes_recolhido') !== '1'; } catch { return true; }
  });
  const alternarClientes = () => setClientesAbertos(aberto => {
    try { localStorage.setItem('email_clientes_recolhido', aberto ? '1' : '0'); } catch { /* sem armazenamento: só nesta tela */ }
    return !aberto;
  });
  const [quando, setQuando] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [envios, setEnvios] = useState([]);
  const [loteAberto, setLoteAberto] = useState(null);

  const carregarCfg = useCallback(() => api('/comunicacao/email/config').then(r => r.json()).then(setCfg).catch(() => {}), []);
  const carregarEnvios = useCallback(() => api('/comunicacao/email/envios').then(r => r.json()).then(d => setEnvios(Array.isArray(d) ? d : [])).catch(() => {}), []);
  useEffect(() => {
    carregarCfg(); carregarEnvios();
    api('/comunicacao/email/clientes').then(r => r.json()).then(d => setClientes(Array.isArray(d.itens) ? d.itens : [])).catch(() => {});
  }, [carregarCfg, carregarEnvios]);
  // Enquanto houver e-mail na fila, o andamento se atualiza sozinho
  const temFila = envios.some(l => l.itens.some(i => i.status === 'agendado'));
  useEffect(() => {
    if (!temFila) return;
    const t = setInterval(() => { carregarEnvios(); carregarCfg(); }, 15000);
    return () => clearInterval(t);
  }, [temFila, carregarEnvios, carregarCfg]);

  const re = busca.trim() ? new RegExp(busca.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : null;
  const visiveis = clientes.filter(c => !re || re.test(c.nome) || re.test(c.email));
  const lista = lerListaEmails(avulsos);
  const destinos = new Set([...clientes.filter(c => marcados.includes(c.cliente_id)).map(c => c.email), ...lista.validos]);
  const alternar = id => setMarcados(m => (m.includes(id) ? m.filter(x => x !== id) : [...m, id]));
  const marcarTodos = () => setMarcados(m => [...new Set([...m, ...visiveis.filter(c => !c.descadastrado).map(c => c.cliente_id)])]);

  // agendado = true só no botão "Agendar envio" (o principal é "Enviar agora")
  async function enviar(agendado = false) {
    if (!destinos.size) return setResultado({ erro: 'Escolha para quem enviar: marque clientes na lista ou cole e-mails na lista avulsa.' });
    if (!assunto.trim()) return setResultado({ erro: 'Escreva o assunto.' });
    if (!texto.trim()) return setResultado({ erro: 'Escreva a mensagem.' });
    if (agendado && !quando) return setResultado({ erro: 'Escolha o dia e a hora do agendamento.' });
    const inicio = agendado ? ` a partir de ${fmtDt(new Date(quando).toISOString())}` : ' agora';
    const comAnexo = anexos.length ? `, com ${anexos.length} anexo(s),` : '';
    if (!window.confirm(`Enviar o e-mail "${assunto.trim()}"${comAnexo} para ${destinos.size} endereço(s)${inicio}?`)) return;
    setEnviando(true); setResultado(null);
    const body = { assunto: assunto.trim(), texto, clientes: marcados, avulsos, formato, anexos };
    if (agendado) body.agendado_para = new Date(quando).toISOString();
    const r = await api('/comunicacao/email/enviar', { method: 'POST', body: JSON.stringify(body) }).then(x => x.json()).catch(() => ({ erro: 'Falha ao enfileirar.' }));
    setEnviando(false);
    setResultado(r);
    // os anexos ficam no servidor (os e-mails da fila apontam pra eles); a tela só limpa a lista
    if (r.ok) { setMarcados([]); setAvulsos(''); setAnexos([]); setAgendar(false); setQuando(''); carregarEnvios(); setLoteAberto(r.lote); }
  }

  async function cancelarLote(lote) {
    if (!window.confirm('Cancelar os e-mails deste envio que ainda estão na fila?')) return;
    await api(`/comunicacao/email/lote/${lote}`, { method: 'DELETE' }).catch(() => {});
    carregarEnvios();
  }
  async function reenviar(id) {
    await api(`/comunicacao/email/item/${id}/reenviar`, { method: 'POST' }).catch(() => {});
    carregarEnvios();
  }

  const contar = (itens, s) => itens.filter(i => i.status === s).length;

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      {abrirCfg && <ModalConfigEmail cfg={cfg} onFechar={() => setAbrirCfg(false)} onSalvo={carregarCfg} />}
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 340px', gap: 16, alignItems: 'start' }}>
        {/* Destinatários */}
        <div style={{ display: 'grid', gap: 12 }}>
          <div>
            {/* Recolher a lista (pedido 22/10): os marcados continuam valendo no envio */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: clientesAbertos ? 6 : 0 }}>
              <button type="button" onClick={alternarClientes} title={clientesAbertos ? 'Recolher a lista' : 'Abrir a lista'}
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 700, color: '#0a1628', textAlign: 'left' }}>
                <span style={{ fontSize: 11, color: '#6b7280', width: 12 }}>{clientesAbertos ? '▼' : '▶'}</span>
                👥 Clientes com e-mail no cadastro ({clientes.length})
                {!clientesAbertos && <span style={{ fontWeight: 400, color: '#6b7280', fontSize: 12 }}>· {marcados.length} marcado(s) — clique para abrir</span>}
              </button>
              {clientesAbertos && <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar nome ou e-mail" style={{ ...inp, width: 200, marginLeft: 'auto' }} />}
            </div>
            {clientesAbertos && (<>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#6b7280', marginBottom: 6 }}>
              <span><strong style={{ color: '#0a1628' }}>{marcados.length} marcado(s)</strong></span>
              <span style={{ display: 'flex', gap: 10 }}>
                <button type="button" onClick={marcarTodos} style={{ background: 'none', border: 'none', color: '#0a1628', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>marcar todos da lista</button>
                <button type="button" onClick={() => setMarcados([])} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer' }}>limpar</button>
              </span>
            </div>
            <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, maxHeight: 260, overflowY: 'auto' }}>
              {visiveis.length === 0 && <div style={{ padding: 20, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Nenhum cliente com e-mail{busca ? ' nessa busca' : ''}.</div>}
              {visiveis.map((c, i) => {
                const on = marcados.includes(c.cliente_id);
                return (
                  <label key={c.cliente_id} style={{ display: 'grid', gridTemplateColumns: '24px 1fr 1.2fr', gap: 8, alignItems: 'center', padding: '7px 12px', borderBottom: '1px solid #f3f4f6',
                    background: on ? '#eef2ff' : (i % 2 === 0 ? '#fafafa' : '#fff'), cursor: c.descadastrado ? 'not-allowed' : 'pointer', opacity: c.descadastrado ? 0.55 : 1 }}>
                    <input type="checkbox" checked={on} disabled={c.descadastrado} onChange={() => alternar(c.cliente_id)} style={{ width: 15, height: 15, margin: 0 }} />
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.nome}</span>
                    <span style={{ fontSize: 12, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.email}{c.descadastrado ? ' · saiu da lista' : ''}</span>
                  </label>
                );
              })}
            </div>
            </>)}
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 6 }}>📋 Lista avulsa <span style={{ fontWeight: 400, color: '#6b7280', fontSize: 12 }}>(sem vínculo com cadastro)</span></div>
            <textarea value={avulsos} onChange={e => setAvulsos(e.target.value)} rows={6}
              placeholder={'Cole aqui os e-mails — um por linha, separados por vírgula ou copiados de uma planilha.\nEx.: fulano@gmail.com, contato@empresa.com.br'}
              style={{ ...inp, resize: 'vertical', lineHeight: 1.45 }} />
            {avulsos.trim() && (
              <div style={{ fontSize: 12, marginTop: 4, color: '#374151' }}>
                <strong style={{ color: '#16a34a' }}>{lista.validos.length} válido(s)</strong>
                {lista.repetidos > 0 && <span style={{ color: '#6b7280' }}> · {lista.repetidos} repetido(s) ignorado(s)</span>}
                {lista.invalidos.length > 0 && <span style={{ color: '#b45309' }}> · {lista.invalidos.length} inválido(s): {lista.invalidos.slice(0, 4).join(', ')}{lista.invalidos.length > 4 ? '…' : ''}</span>}
              </div>
            )}
          </div>
        </div>

        {/* Painel de envio */}
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14, position: 'sticky', top: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>📧 Novo e-mail</span>
            {ehVagner() && <button type="button" onClick={() => setAbrirCfg(true)} title="Configurar a caixa que envia os e-mails" style={{ ...btnOut, padding: '3px 10px' }}>⚙️</button>}
          </div>
          {cfg && !cfg.configurado && (
            <div style={{ fontSize: 12, background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 6, padding: '6px 10px', marginBottom: 10 }}>
              ⚠ Falta configurar a caixa de envio — clique no ⚙️. Até lá os e-mails ficam esperando na fila.
            </div>
          )}
          {cfg?.configurado && !cfg.ultimo_erro && (
            <div style={{ fontSize: 12, color: '#166534', marginBottom: 10 }}>✅ Sai de <strong>{cfg.usuario}</strong> · até {cfg.limite_dia}/dia</div>
          )}
          {cfg?.ultimo_erro && (
            <div style={{ fontSize: 12, background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: 6, padding: '6px 10px', marginBottom: 10 }}>
              ⚠ Envio parado: {cfg.ultimo_erro} Corrija no ⚙️.
            </div>
          )}
          <div style={lbl}>Formato</div>
          <div style={{ display: 'grid', gap: 6, marginBottom: 10 }}>
            {[
              ['simples', '✉️ Simples', 'só texto, parece e-mail pessoal — cai na aba Principal'],
              ['cabecalho', '🎨 Com cabeçalho da Preserva', 'para campanhas — no Gmail costuma cair em Promoções'],
            ].map(([k, rot, dica]) => (
              <label key={k} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '6px 8px', borderRadius: 6, cursor: 'pointer',
                border: `1px solid ${formato === k ? '#0a1628' : '#e5e7eb'}`, background: formato === k ? '#f1f5f9' : '#fff' }}>
                <input type="radio" name="formato-email" checked={formato === k} onChange={() => setFormato(k)} style={{ marginTop: 2, width: 'auto', flex: '0 0 auto' }} />
                <span style={{ fontSize: 12.5, color: '#0a1628', fontWeight: 700 }}>{rot}<span style={{ display: 'block', fontWeight: 400, color: '#6b7280', fontSize: 11.5 }}>{dica}</span></span>
              </label>
            ))}
          </div>
          <div style={lbl}>Assunto</div>
          <input value={assunto} onChange={e => setAssunto(e.target.value)} placeholder="Ex.: Novidades sobre o seu registro de marca" style={{ ...inp, marginBottom: 8 }} />
          <div style={lbl}>Mensagem <span style={{ color: '#9ca3af', fontWeight: 400 }}>({'{nome}'} = nome do cliente; na lista avulsa some)</span></div>
          <textarea value={texto} onChange={e => setTexto(e.target.value)} rows={11} style={{ ...inp, resize: 'vertical', lineHeight: 1.45, marginBottom: 8 }} />
          <div style={lbl}>Anexos <span style={{ color: '#9ca3af', fontWeight: 400 }}>(opcional)</span></div>
          <div style={{ marginBottom: 10 }}><AnexosEmail anexos={anexos} onChange={setAnexos} /></div>
          {/* Pedido 22/10: botão de enviar agora, sem data e hora na frente;
              o agendamento fica guardado no link logo abaixo */}
          {/* Sempre clicável (só trava enquanto enfileira): sem destinatário, o
              clique explica o que falta — travado, ele parecia quebrado */}
          <button type="button" onClick={() => enviar(false)} disabled={enviando}
            style={{ ...btn('#16a34a'), width: '100%', padding: '9px 0', fontSize: 13, opacity: enviando ? 0.5 : 1 }}>
            {enviando ? 'Enfileirando…' : destinos.size ? `📧 Enviar agora para ${destinos.size} e-mail(s)` : '📧 Enviar agora'}
          </button>
          {!destinos.size && !resultado && (
            <div style={{ fontSize: 11.5, color: '#92400e', marginTop: 6 }}>Para enviar, marque clientes na lista ou cole e-mails na lista avulsa.</div>
          )}
          {!agendar ? (
            <button type="button" onClick={() => setAgendar(true)}
              style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', padding: '8px 0 0', textDecoration: 'underline' }}>
              ⏰ Agendar para outro horário
            </button>
          ) : (
            <div style={{ marginTop: 10, padding: 10, border: '1px dashed #c8d0da', borderRadius: 6 }}>
              <div style={lbl}>Dia e hora do envio</div>
              <div style={{ marginBottom: 8 }}><CampoDataHora value={quando} onChange={setQuando} style={inp} /></div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button type="button" onClick={() => enviar(true)} disabled={enviando}
                  style={{ ...btn('#0a1628'), flex: 1, padding: '7px 0', opacity: enviando ? 0.5 : 1 }}>
                  ⏰ Agendar envio
                </button>
                <button type="button" onClick={() => { setAgendar(false); setQuando(''); }} style={{ ...btnOut, padding: '7px 10px' }}>cancelar</button>
              </div>
            </div>
          )}
          {resultado && (
            <div style={{ marginTop: 10, fontSize: 12.5, background: resultado.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${resultado.ok ? '#bbf7d0' : '#fecaca'}`, borderRadius: 6, padding: '8px 12px', color: resultado.ok ? '#166534' : '#b91c1c' }}>
              {resultado.ok ? <>✅ <strong>{resultado.enfileirados}</strong> e-mail(s) na fila. Acompanhe em "Envios de e-mail" logo abaixo.</> : `⚠ ${resultado.erro}`}
              {resultado.descadastrados > 0 && <div style={{ color: '#6b7280', marginTop: 4 }}>{resultado.descadastrados} pulado(s): pediram para sair da lista.</div>}
              {resultado.repetidos > 0 && <div style={{ color: '#6b7280', marginTop: 4 }}>{resultado.repetidos} repetido(s) ignorado(s).</div>}
              {resultado.invalidos?.length > 0 && <div style={{ color: '#b45309', marginTop: 4 }}>⚠ Inválidos: {resultado.invalidos.join(', ')}</div>}
            </div>
          )}
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 10, lineHeight: 1.4 }}>
            Os dois formatos terminam com o link "sair da lista"; quem sair não recebe mais. Envio de 1 e-mail a cada 3 segundos, respeitando o limite por dia.
          </div>
        </div>
      </div>

      {/* Envios */}
      <div>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 6 }}>📬 Envios de e-mail</div>
        {envios.length === 0 ? (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 20, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Nenhum e-mail enviado ainda.</div>
        ) : (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
            {envios.map(l => {
              const naFila = contar(l.itens, 'agendado');
              const aberto = loteAberto === l.lote;
              return (
                <div key={l.lote} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <div onClick={() => setLoteAberto(aberto ? null : l.lote)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', cursor: 'pointer', background: aberto ? '#f8fafc' : '#fff', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 12, color: '#6b7280', minWidth: 110 }}>{fmtDt(l.criado_em)}</span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#0a1628', flex: 1, minWidth: 180 }}>
                      {l.assunto}
                      <span style={{ marginLeft: 8, fontSize: 10.5, fontWeight: 700, color: '#6b7280', background: '#f3f4f6', borderRadius: 4, padding: '1px 6px' }}>
                        {l.formato === 'simples' ? '✉️ simples' : '🎨 com cabeçalho'}
                      </span>
                      {l.anexos?.length > 0 && (
                        <span title={l.anexos.join(' · ')} style={{ marginLeft: 6, fontSize: 10.5, fontWeight: 700, color: '#15803d', background: '#f0fdf4', borderRadius: 4, padding: '1px 6px' }}>
                          📎 {l.anexos.length}
                        </span>
                      )}
                    </span>
                    <span style={{ fontSize: 12, color: '#16a34a' }}>✓ {contar(l.itens, 'enviado')}</span>
                    {naFila > 0 && <span style={{ fontSize: 12, color: '#d97706' }}>⏳ {naFila}</span>}
                    {contar(l.itens, 'falhou') > 0 && <span style={{ fontSize: 12, color: '#dc2626' }}>✗ {contar(l.itens, 'falhou')}</span>}
                    {contar(l.itens, 'devolvido') > 0 && <span title="Voltaram: o endereço não recebeu (aviso chegou na caixa)" style={{ fontSize: 12, color: '#b91c1c' }}>↩ voltou {contar(l.itens, 'devolvido')}</span>}
                    {contar(l.itens, 'descadastrado') > 0 && <span style={{ fontSize: 12, color: '#6b7280' }}>saíram {contar(l.itens, 'descadastrado')}</span>}
                    <span style={{ fontSize: 12, color: '#6b7280' }}>de {l.itens.length}</span>
                    {naFila > 0 && <button type="button" onClick={e => { e.stopPropagation(); cancelarLote(l.lote); }} style={{ ...btnOut, padding: '2px 8px', fontSize: 11 }}>cancelar o que falta</button>}
                    <span style={{ fontSize: 12, color: '#9ca3af' }}>{aberto ? '▲' : '▼'}</span>
                  </div>
                  {aberto && (
                    <div style={{ padding: '4px 12px 10px', maxHeight: 300, overflowY: 'auto' }}>
                      {l.itens.map(i => {
                        const st = statusEmail(i.status);
                        return (
                          <div key={i._id} style={{ display: 'grid', gridTemplateColumns: '1.3fr 1fr 110px 1.4fr 70px', gap: 8, alignItems: 'center', padding: '4px 0', fontSize: 12, borderBottom: '1px dashed #f1f5f9' }}>
                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{i.email}</span>
                            <span style={{ color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{i.nome || (i.origem === 'avulso' ? 'lista avulsa' : '—')}</span>
                            <span style={{ background: st.bg, color: st.cor, padding: '1px 8px', borderRadius: 4, fontWeight: 700, fontSize: 11, justifySelf: 'start' }}>{st.label}</span>
                            <span style={{ color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={i.erro}>{i.erro || (i.enviado_em ? fmtDt(i.enviado_em) : '')}</span>
                            {['falhou', 'cancelado'].includes(i.status)
                              ? <button type="button" onClick={() => reenviar(i._id)} style={{ ...btnOut, padding: '1px 6px', fontSize: 11 }}>reenviar</button>
                              : <span />}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// ── Respostas dos e-mails (25/10/2026) ────────────────────────────────────────
// Pedido do Vagner: ver aqui quando o cliente responde, sem abrir a caixa da
// Hostinger. O servidor lê a caixa que envia (entrada e spam) a cada 3 min, só
// leitura, e guarda o que chega ligado ao cliente e ao envio respondido. "Lida"
// vale só no sistema. Dá pra responder daqui (sai pela mesma caixa).
const TIPOS_CAIXA = [
  ['mensagem', '💬 Mensagens'],
  ['automatica', '🤖 Automáticas'],
  ['devolucao', '↩️ Não entregues'],
  ['lista', '📰 Propaganda e listas'],
  ['todas', 'Todas'],
];
const assinaturaResposta = () => assinatura('Olá,');
const tagCaixa = (bg, cor) => ({ fontSize: 10.5, fontWeight: 700, background: bg, color: cor, borderRadius: 4, padding: '1px 6px', whiteSpace: 'nowrap' });
const vazioCaixa = { padding: 20, textAlign: 'center', color: '#9ca3af', fontSize: 13 };
const umaLinha = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };

function quandoCurto(iso) {
  if (!iso) return '';
  const d = new Date(iso), hoje = new Date();
  const hora = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  if (d.toDateString() === hoje.toDateString()) return hora;
  const ontem = new Date(hoje); ontem.setDate(hoje.getDate() - 1);
  if (d.toDateString() === ontem.toDateString()) return `ontem ${hora}`;
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', ...(d.getFullYear() !== hoje.getFullYear() ? { year: '2-digit' } : {}) });
}
const tamanhoArquivo = b => (b >= 1048576 ? `${(b / 1048576).toFixed(1).replace('.', ',')} MB` : `${Math.max(1, Math.round((b || 0) / 1024))} KB`);

// 📎 Anexos do e-mail (25/10/2026, pedido do Vagner: "apresentação ou qualquer
// outro tipo de arquivo"): até 10 arquivos e 20 MB somados. Sobem na hora pela
// rota de anexos da Comunicação; o e-mail só leva a referência. O × apaga o
// arquivo do servidor. Usado no "Novo e-mail" e no "Responder".
const MAX_ANEXOS_EMAIL = 20 * 1024 * 1024;
function AnexosEmail({ anexos, onChange }) {
  const [subindo, setSubindo] = useState(false);
  const campo = useRef(null);
  const total = anexos.reduce((s, a) => s + (a.tamanho || 0), 0);
  async function escolher(e) {
    const arquivos = [...(e.target.files || [])];
    e.target.value = '';
    if (!arquivos.length) return;
    if (anexos.length + arquivos.length > 10) return alert('Máximo de 10 arquivos por e-mail.');
    if (total + arquivos.reduce((s, f) => s + f.size, 0) > MAX_ANEXOS_EMAIL) {
      return alert('Os anexos passariam de 20 MB somados — Gmail e Outlook costumam recusar e-mail desse tamanho. Para arquivo grande, mande um link (Google Drive, WeTransfer).');
    }
    setSubindo(true);
    try {
      const fd = new FormData();
      arquivos.forEach(f => fd.append('arquivo', f));
      // sem Content-Type: o navegador põe o boundary do multipart sozinho
      const r = await fetch('/comunicacao/anexo', { method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.erro || 'Falha ao enviar o arquivo.');
      onChange([...anexos, ...(d.anexos || [])]);
    } catch (err) { alert(err.message); }
    setSubindo(false);
  }
  async function remover(a) {
    await api(`/comunicacao/anexo/${encodeURIComponent(a.arquivo)}`, { method: 'DELETE' }).catch(() => {});
    onChange(anexos.filter(x => x.arquivo !== a.arquivo));
  }
  return (
    // minmax(0, 1fr): nome comprido corta com "…" em vez de esticar a caixa para fora do painel
    <div style={{ display: 'grid', gap: 6, gridTemplateColumns: 'minmax(0, 1fr)' }}>
      {anexos.map(a => (
        <div key={a.arquivo} style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '5px 10px' }}>
          <span>📎</span>
          <span title={a.nome} style={{ ...umaLinha, flex: 1, minWidth: 0, fontSize: 12.5, fontWeight: 600, color: '#15803d' }}>{a.nome}</span>
          <span style={{ fontSize: 11, color: '#6b7280', whiteSpace: 'nowrap' }}>{tamanhoArquivo(a.tamanho)}</span>
          <button type="button" onClick={() => remover(a)} title="Tirar este anexo" style={{ background: 'none', border: 'none', color: '#dc2626', fontSize: 16, cursor: 'pointer', fontWeight: 700, lineHeight: 1 }}>×</button>
        </div>
      ))}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <input ref={campo} type="file" multiple onChange={escolher} style={{ display: 'none' }} />
        {anexos.length < 10 && (
          <button type="button" onClick={() => campo.current && campo.current.click()} disabled={subindo} style={{ ...btnOut, padding: '5px 12px', opacity: subindo ? 0.6 : 1 }}>
            {subindo ? 'Enviando o arquivo…' : '📎 Anexar arquivo'}
          </button>
        )}
        <span style={{ fontSize: 11, color: '#9ca3af' }}>
          {anexos.length ? `${anexos.length} arquivo(s) · ${tamanhoArquivo(total)} de 20 MB` : 'apresentação, PDF, planilha… até 20 MB somados'}
        </span>
      </div>
    </div>
  );
}

function CaixaEmail({ onNaoLidas, alvo }) {
  const navigate = useNavigate();
  const [dados, setDados] = useState(null);
  const [tipo, setTipo] = useState('mensagem');
  const [busca, setBusca] = useState('');
  const [soNaoLidas, setSoNaoLidas] = useState(false);
  const [aberto, setAberto] = useState(null);
  const [verCitacao, setVerCitacao] = useState(false);
  const [lendo, setLendo] = useState(false);
  const [respondendo, setRespondendo] = useState(false);
  const [resposta, setResposta] = useState('');
  const [enviandoResp, setEnviandoResp] = useState(false);
  const [msgResp, setMsgResp] = useState(null);
  const [anexosResp, setAnexosResp] = useState([]); // anexos da resposta (ver AnexosEmail)
  const campoResposta = useRef(null);
  const jaLeu = useRef(false);

  const carregar = useCallback(async () => {
    const qs = new URLSearchParams({ tipo });
    if (busca.trim()) qs.set('busca', busca.trim());
    if (soNaoLidas) qs.set('nao_lidas', '1');
    const d = await api(`/comunicacao/email/caixa?${qs}`).then(r => r.json()).catch(() => null);
    if (d && Array.isArray(d.itens)) {
      setDados(d);
      if (onNaoLidas) onNaoLidas(d.contagens?.nao_lidas || 0);
    }
  }, [tipo, busca, soNaoLidas, onNaoLidas]);

  // Busca com uma pequena espera enquanto digita; e a lista se atualiza sozinha a cada minuto
  useEffect(() => {
    const t = setTimeout(carregar, busca ? 300 : 0);
    const i = setInterval(carregar, 60000);
    return () => { clearTimeout(t); clearInterval(i); };
  }, [carregar, busca]);

  const atualizar = useCallback(async () => {
    setLendo(true);
    await api('/comunicacao/email/caixa/sincronizar', { method: 'POST' }).catch(() => {});
    setLendo(false);
    carregar();
  }, [carregar]);
  // Ao abrir, lê a caixa na hora (o servidor também lê sozinho a cada 3 min)
  useEffect(() => {
    if (jaLeu.current) return;
    jaLeu.current = true;
    atualizar();
  }, [atualizar]);

  // Resposta já com "Olá," e a assinatura; o cursor fica no meio
  useEffect(() => {
    if (!respondendo || !campoResposta.current) return;
    const el = campoResposta.current;
    el.focus();
    el.setSelectionRange(6, 6);
  }, [respondendo]);

  async function abrir(item) {
    setVerCitacao(false); setRespondendo(false); setResposta(''); setMsgResp(null); setAnexosResp([]);
    const d = await api(`/comunicacao/email/caixa/${item._id}`).then(r => r.json()).catch(() => null);
    if (!d || d.erro) return;
    setAberto(d);
    if (!item.lido) {
      await api(`/comunicacao/email/caixa/${item._id}`, { method: 'PUT', body: JSON.stringify({ lido: true }) }).catch(() => {});
      carregar();
    }
  }
  // Veio do aviso (topo, canto da tela ou link do WhatsApp): abre o e-mail direto
  const abrirRef = useRef(abrir);
  abrirRef.current = abrir;
  useEffect(() => {
    if (alvo && alvo.id && !['respostas', 'campanha'].includes(alvo.id)) abrirRef.current({ _id: alvo.id, lido: false });
  }, [alvo]);
  async function marcarNaoLida() {
    await api(`/comunicacao/email/caixa/${aberto._id}`, { method: 'PUT', body: JSON.stringify({ lido: false }) }).catch(() => {});
    setAberto(null);
    carregar();
  }
  async function baixar(a) {
    const r = await api(`/comunicacao/email/caixa/${aberto._id}/anexo/${a.n}`).catch(() => null);
    if (!r || !r.ok) return alert('Não consegui baixar o anexo.');
    const url = URL.createObjectURL(await r.blob());
    const link = document.createElement('a');
    link.href = url; link.download = a.nome;
    document.body.appendChild(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }
  function comecarResposta() {
    setResposta(assinaturaResposta()); setMsgResp(null); setRespondendo(true);
  }
  async function enviarResposta() {
    const texto = resposta.trim();
    if (!texto || texto === assinaturaResposta().trim()) return setMsgResp({ texto: 'Escreva a resposta.' });
    const comAnexo = anexosResp.length ? ` com ${anexosResp.length} anexo(s)` : '';
    if (!window.confirm(`Enviar a resposta${comAnexo} para ${aberto.responder_para}?`)) return;
    setEnviandoResp(true); setMsgResp(null);
    const r = await api(`/comunicacao/email/caixa/${aberto._id}/responder`, { method: 'POST', body: JSON.stringify({ texto: resposta, anexos: anexosResp }) })
      .then(x => x.json()).catch(() => ({ erro: 'Falha ao enviar.' }));
    setEnviandoResp(false);
    if (!r.ok) return setMsgResp({ texto: r.erro || 'Falha ao enviar.' });
    setAberto(a => ({ ...a, respondido: true, respostas: [...(a.respostas || []), r.resposta] }));
    setResposta(''); setRespondendo(false); setAnexosResp([]);
    setMsgResp({ ok: true, texto: `Resposta enviada para ${r.resposta.para}.` });
    carregar();
  }

  const c = dados?.contagens || {};
  const itens = dados?.itens || [];
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <div style={{ fontSize: 12, color: '#6b7280', flex: 1, minWidth: 220 }}>
          📥 Caixa <strong style={{ color: '#0a1628' }}>{dados?.caixa || '—'}</strong>
          {dados?.ultima_leitura && <> · lida às {new Date(dados.ultima_leitura).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })} (lê sozinha a cada 3 min)</>}
        </div>
        <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar remetente, assunto ou texto" style={{ ...inp, width: 240 }} />
        <button type="button" onClick={atualizar} disabled={lendo} style={{ ...btnOut, padding: '6px 12px', opacity: lendo ? 0.6 : 1 }}>
          {lendo ? 'Lendo a caixa…' : '↻ Atualizar'}
        </button>
      </div>
      {dados && !dados.configurado && (
        <div style={{ fontSize: 12, background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 6, padding: '6px 10px' }}>
          ⚠ Falta configurar a caixa de e-mail no ⚙️ (em "📧 Enviar e-mails"). As respostas são lidas da mesma conta que envia.
        </div>
      )}
      {dados?.ultimo_erro && (
        <div style={{ fontSize: 12, background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: 6, padding: '6px 10px' }}>
          ⚠ Não consegui ler a caixa: {dados.ultimo_erro}
        </div>
      )}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
        {TIPOS_CAIXA.map(([k, rot]) => {
          const on = tipo === k;
          return (
            <button key={k} type="button" onClick={() => { setTipo(k); setAberto(null); }}
              style={{ ...(on ? btn() : btnOut), padding: '4px 10px', fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
              {rot} ({(k === 'todas' ? c.todas : c[k]) || 0})
              {k === 'mensagem' && c.nao_lidas > 0 && <span style={{ background: '#dc2626', color: '#fff', borderRadius: 10, padding: '0 6px', fontSize: 10.5, fontWeight: 700 }}>{c.nao_lidas} nova(s)</span>}
            </button>
          );
        })}
        <label style={{ fontSize: 12, color: '#374151', display: 'flex', alignItems: 'center', gap: 5, marginLeft: 'auto', cursor: 'pointer' }}>
          <input type="checkbox" checked={soNaoLidas} onChange={e => setSoNaoLidas(e.target.checked)} style={{ width: 'auto', margin: 0 }} />
          só não lidas
        </label>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '360px minmax(0, 1fr)', gap: 12, alignItems: 'start' }}>
        {/* Lista */}
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, maxHeight: 620, overflowY: 'auto', background: '#fff' }}>
          {!dados && <div style={vazioCaixa}>Carregando…</div>}
          {dados && itens.length === 0 && (
            <div style={vazioCaixa}>
              {busca.trim() ? 'Nada encontrado nessa busca.' : tipo === 'mensagem' ? 'Nenhuma mensagem ainda. Quando um cliente responder, aparece aqui.' : 'Nada por aqui.'}
            </div>
          )}
          {itens.map(m => {
            const sel = aberto?._id === m._id;
            return (
              <div key={m._id} onClick={() => abrir(m)}
                style={{ padding: '8px 12px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', background: sel ? '#eef2ff' : m.lido ? '#fff' : '#f8fafc',
                  borderLeft: `3px solid ${m.lido ? 'transparent' : '#2563eb'}` }}>
                <div style={{ display: 'flex', gap: 8, alignItems: 'baseline' }}>
                  <span style={{ ...umaLinha, flex: 1, fontSize: 13, fontWeight: m.lido ? 500 : 700, color: '#0a1628' }}>{m.de_nome || m.de_email}</span>
                  <span style={{ fontSize: 11, color: '#6b7280', whiteSpace: 'nowrap' }}>{quandoCurto(m.data)}</span>
                </div>
                <div style={{ ...umaLinha, fontSize: 12.5, fontWeight: m.lido ? 400 : 700, color: '#111827' }}>{m.assunto}</div>
                <div style={{ ...umaLinha, fontSize: 11.5, color: '#6b7280' }}>{m.trecho}</div>
                {(m.cliente_nome || m.pasta === 'spam' || m.tem_anexo || m.respondido || m.devolucao?.email) && (
                  <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: 4 }}>
                    {m.cliente_nome && <span style={tagCaixa('#eef2ff', '#3730a3')}>👤 {m.cliente_nome}</span>}
                    {m.pasta === 'spam' && <span style={tagCaixa('#fef3c7', '#92400e')}>veio no spam</span>}
                    {m.tem_anexo && <span style={tagCaixa('#f3f4f6', '#374151')}>📎 anexo</span>}
                    {m.respondido && <span style={tagCaixa('#f0fdf4', '#166534')}>↩ respondido</span>}
                    {m.devolucao?.email && <span style={tagCaixa('#fef2f2', '#b91c1c')}>não chegou: {m.devolucao.email}</span>}
                  </div>
                )}
              </div>
            );
          })}
          {dados && dados.total > itens.length && <div style={{ ...vazioCaixa, padding: 10 }}>Mostrando os {itens.length} mais recentes de {dados.total}.</div>}
        </div>

        {/* Leitura */}
        <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', minHeight: 300 }}>
          {!aberto ? <div style={{ ...vazioCaixa, paddingTop: 60 }}>Clique num e-mail para ler.</div> : (
            <div style={{ padding: 16, display: 'grid', gap: 10 }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: '#0a1628' }}>{aberto.assunto}</div>
              <div style={{ fontSize: 12.5, color: '#374151', lineHeight: 1.6 }}>
                <div><strong>De:</strong> {aberto.de_nome ? `${aberto.de_nome} <${aberto.de_email}>` : aberto.de_email}</div>
                {aberto.para && <div><strong>Para:</strong> {aberto.para}</div>}
                {aberto.cc && <div><strong>Cópia:</strong> {aberto.cc}</div>}
                <div><strong>Data:</strong> {fmtDt(aberto.data)}</div>
              </div>
              {aberto.tipo === 'devolucao' && (
                <div style={{ fontSize: 12.5, background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: 6, padding: '8px 10px', lineHeight: 1.5 }}>
                  ⚠ Não entregue{aberto.devolucao?.email ? <>: o e-mail para <strong>{aberto.devolucao.email}</strong> voltou</> : ''}
                  {aberto.envio ? <> (envio “{aberto.envio.assunto}”{aberto.envio.enviado_em ? ` de ${fmtDt(aberto.envio.enviado_em)}` : ''} — na lista de envios aparece como “Voltou”)</> : ''}.
                  {aberto.devolucao?.motivo && <div style={{ color: '#7f1d1d', marginTop: 4 }}>Motivo: {aberto.devolucao.motivo}</div>}
                </div>
              )}
              {aberto.tipo !== 'devolucao' && (aberto.envio || aberto.cliente_id) && (
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', fontSize: 12, background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 6, padding: '6px 10px' }}>
                  {aberto.envio && <span>↩ Resposta ao e-mail <strong>“{aberto.envio.assunto}”</strong>{aberto.envio.enviado_em ? ` enviado em ${fmtDt(aberto.envio.enviado_em)}` : ''}</span>}
                  {aberto.cliente_id && (
                    <button type="button" onClick={() => navigate(`/clientes/${aberto.cliente_id}/editar`)} style={{ ...btnOut, padding: '3px 10px', marginLeft: 'auto' }}>
                      👤 Abrir ficha de {aberto.cliente_nome}
                    </button>
                  )}
                </div>
              )}
              {aberto.tipo === 'devolucao' && aberto.cliente_id && (
                <button type="button" onClick={() => navigate(`/clientes/${aberto.cliente_id}/editar`)} style={{ ...btnOut, padding: '3px 10px', justifySelf: 'start' }}>
                  👤 Abrir ficha de {aberto.cliente_nome} (conferir o e-mail do cadastro)
                </button>
              )}
              {aberto.pasta === 'spam' && (
                <div style={{ fontSize: 12, background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 6, padding: '6px 10px' }}>
                  Este e-mail caiu na pasta de spam da caixa.
                </div>
              )}
              <div style={{ fontSize: 13.5, color: '#111827', whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.55 }}>{aberto.novo || '(sem texto)'}</div>
              {aberto.citacao && (
                <div>
                  <button type="button" onClick={() => setVerCitacao(v => !v)} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', padding: 0 }}>
                    {verCitacao ? '▲ esconder a mensagem anterior' : '▼ ver a mensagem anterior'}
                  </button>
                  {verCitacao && (
                    <div style={{ marginTop: 6, fontSize: 12.5, color: '#6b7280', whiteSpace: 'pre-wrap', wordBreak: 'break-word', borderLeft: '3px solid #e5e7eb', paddingLeft: 10 }}>{aberto.citacao}</div>
                  )}
                </div>
              )}
              {aberto.anexos?.length > 0 && (
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {aberto.anexos.map(a => (a.baixar ? (
                    <button key={a.n} type="button" onClick={() => baixar(a)} style={{ ...btnOut, padding: '4px 10px' }}>
                      📎 {a.nome} <span style={{ color: '#9ca3af' }}>({tamanhoArquivo(a.tamanho)})</span>
                    </button>
                  ) : (
                    <span key={a.n} style={{ fontSize: 12, color: '#9ca3af' }} title="Arquivo não guardado no sistema — está na caixa da Hostinger">📎 {a.nome} ({tamanhoArquivo(a.tamanho)})</span>
                  )))}
                </div>
              )}
              {aberto.respostas?.length > 0 && (
                <div style={{ display: 'grid', gap: 6 }}>
                  {aberto.respostas.map((r, i) => (
                    <div key={i} style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '8px 10px', fontSize: 12.5 }}>
                      <div style={{ color: '#166534', fontWeight: 700, marginBottom: 4 }}>↩ Você respondeu em {fmtDt(r.enviado_em)} para {r.para}</div>
                      <div style={{ whiteSpace: 'pre-wrap', color: '#14532d' }}>{r.texto}</div>
                      {r.anexos?.length > 0 && <div style={{ color: '#166534', marginTop: 6 }}>📎 {r.anexos.map(a => a.nome).join(' · ')}</div>}
                    </div>
                  ))}
                </div>
              )}
              {msgResp && (
                <div style={{ fontSize: 12.5, borderRadius: 6, padding: '8px 12px', background: msgResp.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${msgResp.ok ? '#bbf7d0' : '#fecaca'}`, color: msgResp.ok ? '#166534' : '#b91c1c' }}>
                  {msgResp.ok ? '✅ ' : '⚠ '}{msgResp.texto}
                </div>
              )}
              {aberto.tipo === 'mensagem' && !aberto.grande && (respondendo ? (
                <div style={{ display: 'grid', gap: 8, borderTop: '1px solid #e5e7eb', paddingTop: 10 }}>
                  <div style={lbl}>Resposta para {aberto.responder_para}</div>
                  <textarea ref={campoResposta} value={resposta} onChange={e => setResposta(e.target.value)} rows={8} style={{ ...inp, resize: 'vertical', lineHeight: 1.45 }} />
                  <AnexosEmail anexos={anexosResp} onChange={setAnexosResp} />
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <button type="button" onClick={enviarResposta} disabled={enviandoResp} style={{ ...btn('#16a34a'), padding: '7px 16px', opacity: enviandoResp ? 0.6 : 1 }}>
                      {enviandoResp ? 'Enviando…' : '📧 Enviar resposta'}
                    </button>
                    {/* cancelar apaga do servidor o que foi anexado e não saiu */}
                    <button type="button" onClick={() => {
                      anexosResp.forEach(a => api(`/comunicacao/anexo/${encodeURIComponent(a.arquivo)}`, { method: 'DELETE' }).catch(() => {}));
                      setAnexosResp([]); setRespondendo(false);
                    }} style={{ ...btnOut, padding: '7px 12px' }}>cancelar</button>
                  </div>
                  <div style={{ fontSize: 11, color: '#9ca3af' }}>
                    Sai de {dados?.caixa || 'contato@preserva.online'}, na mesma conversa, com a mensagem recebida citada embaixo. Uma cópia vai para "Enviados" da Hostinger.
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', gap: 8, borderTop: '1px solid #e5e7eb', paddingTop: 10 }}>
                  <button type="button" onClick={comecarResposta} style={{ ...btn(), padding: '7px 16px' }}>↩ Responder</button>
                  <button type="button" onClick={marcarNaoLida} style={{ ...btnOut, padding: '7px 12px' }}>marcar como não lida</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── Campanha automática (25/10/2026) ──────────────────────────────────────────
// Pedido do Vagner: coloca a lista e a mensagem uma vez e o sistema vai
// enviando sozinho, de segunda a sexta, das 8h às 18h, um e-mail de cada vez;
// quando a lista estiver acabando, ele cola mais e a fila continua. Uma campanha
// aberta por vez. Aquecimento da caixa: 50 → 300 por dia. Ver emailCampanha.js.
const textoCampanhaPadrao = () => assinatura('Olá {nome},');
const fmtDia = iso => (iso ? new Date(`${iso.slice(0, 10)}T12:00:00`).toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit' }) : '');
const fmtHora = iso => (iso ? new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : '');

function ResumoInclusao({ r }) {
  if (!r) return null;
  const partes = [
    r.repetidos > 0 && `${r.repetidos} repetido(s) na lista`,
    r.ja_na_campanha > 0 && `${r.ja_na_campanha} já estavam na campanha`,
    r.descadastrados > 0 && `${r.descadastrados} pediram para sair da lista`,
    r.devolvidos > 0 && `${r.devolvidos} já voltaram antes (endereço inexistente)`,
    r.clientes > 0 && `${r.clientes} já são clientes`,
  ].filter(Boolean);
  return (
    <div style={{ fontSize: 12, color: '#374151', lineHeight: 1.5 }}>
      <strong style={{ color: r.adicionados ? '#166534' : '#b45309' }}>{r.adicionados} e-mail(s) entraram na fila</strong>
      {partes.length > 0 && <span style={{ color: '#6b7280' }}> · pulados: {partes.join(' · ')}</span>}
      {r.invalidos?.length > 0 && <div style={{ color: '#b45309' }}>⚠ {r.invalidos.length} linha(s) sem e-mail válido: {r.invalidos.slice(0, 4).join(', ')}{r.invalidos.length > 4 ? '…' : ''}</div>}
    </div>
  );
}

function CampanhaEmail() {
  const [dados, setDados] = useState(null);
  const [form, setForm] = useState(() => ({ nome: '', assunto: '', texto: textoCampanhaPadrao(), formato: 'simples', lista: '' }));
  const [anexos, setAnexos] = useState([]);
  const [ocupado, setOcupado] = useState(false);
  const [msg, setMsg] = useState(null); // { ok, texto, r }
  const [mais, setMais] = useState(null); // texto colado em "Colar mais e-mails" (null = fechado)
  const [edicao, setEdicao] = useState(null); // { assunto, texto, formato, anexos } (null = fechado)

  const carregar = useCallback(() => api('/comunicacao/email/campanha').then(r => r.json()).then(d => { if (d && !d.erro) setDados(d); }).catch(() => {}), []);
  useEffect(() => {
    carregar();
    const t = setInterval(carregar, 30000);
    return () => clearInterval(t);
  }, [carregar]);

  const c = dados?.aberta;
  const campo = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const validos = lerListaEmails(form.lista).validos.length;

  async function enviarJson(url, method, body) {
    return api(url, { method, body: JSON.stringify(body || {}) }).then(x => x.json()).catch(() => ({ erro: 'Falha de conexão.' }));
  }
  async function criar() {
    if (!form.assunto.trim()) return setMsg({ texto: 'Escreva o assunto.' });
    if (!form.texto.trim()) return setMsg({ texto: 'Escreva a mensagem.' });
    if (!validos) return setMsg({ texto: 'Cole a lista de e-mails (um por linha).' });
    if (!window.confirm(`Criar a campanha e começar?\n\nVai enviar sozinha, de segunda a sexta, das 8h às 18h, um e-mail de cada vez — começando com ${dados?.aquecimento?.de || 50} por dia e subindo até ${dados?.aquecimento?.ate || 300}.`)) return;
    setOcupado(true); setMsg(null);
    const r = await enviarJson('/comunicacao/email/campanha', 'POST', { ...form, anexos });
    setOcupado(false);
    if (!r.ok) return setMsg({ texto: r.erro, r: r.adicionados !== undefined ? r : null });
    setMsg({ ok: true, texto: 'Campanha criada.', r });
    setForm({ nome: '', assunto: '', texto: textoCampanhaPadrao(), formato: 'simples', lista: '' }); setAnexos([]);
    carregar();
  }
  async function incluirMais() {
    if (!lerListaEmails(mais || '').validos.length) return setMsg({ texto: 'Cole os e-mails (um por linha).' });
    setOcupado(true); setMsg(null);
    const r = await enviarJson(`/comunicacao/email/campanha/${c._id}/emails`, 'POST', { lista: mais });
    setOcupado(false);
    if (!r.ok) return setMsg({ texto: r.erro });
    setMsg({ ok: true, texto: 'Lista atualizada.', r });
    setMais(null);
    carregar();
  }
  async function mudarStatus(status) {
    setOcupado(true);
    const r = await enviarJson(`/comunicacao/email/campanha/${c._id}`, 'PUT', { status });
    setOcupado(false);
    if (!r.ok) return setMsg({ texto: r.erro });
    setMsg(null);
    carregar();
  }
  async function salvarEdicao() {
    setOcupado(true);
    const r = await enviarJson(`/comunicacao/email/campanha/${c._id}`, 'PUT', edicao);
    setOcupado(false);
    if (!r.ok) return setMsg({ texto: r.erro });
    setMsg({ ok: true, texto: 'Mensagem salva — vale para quem ainda não recebeu.' });
    setEdicao(null);
    carregar();
  }
  async function encerrar() {
    if (!window.confirm(`Encerrar a campanha "${c.nome}"?\n\nOs ${c.pendentes} e-mail(s) que ainda não saíram serão cancelados. Ela vai para o histórico.`)) return;
    setOcupado(true);
    const r = await enviarJson(`/comunicacao/email/campanha/${c._id}/encerrar`, 'POST');
    setOcupado(false);
    if (!r.ok) return setMsg({ texto: r.erro });
    setMsg({ ok: true, texto: `Campanha encerrada${r.cancelados ? ` (${r.cancelados} e-mail(s) cancelados)` : ''}.` });
    carregar();
  }

  const caixaMsg = msg && (
    <div style={{ fontSize: 12.5, borderRadius: 6, padding: '8px 12px', background: msg.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${msg.ok ? '#bbf7d0' : '#fecaca'}`, color: msg.ok ? '#166534' : '#b91c1c', display: 'grid', gap: 4 }}>
      <div>{msg.ok ? '✅ ' : '⚠ '}{msg.texto}</div>
      {msg.r && <ResumoInclusao r={msg.r} />}
    </div>
  );
  if (!dados) return <div style={vazioCaixa}>Carregando…</div>;

  // ── Sem campanha aberta: formulário para criar ──
  if (!c) {
    return (
      <div style={{ display: 'grid', gap: 12, maxWidth: 760 }}>
        <div style={{ fontSize: 12.5, color: '#374151', background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 12px', lineHeight: 1.55 }}>
          <strong style={{ color: '#0a1628' }}>Como funciona:</strong> você define a mensagem e cola a lista uma vez. O sistema envia sozinho, de segunda a sexta,
          das 8h às 18h (sem feriados), <strong>um e-mail de cada vez</strong>, espalhado ao longo do dia. Começa com {dados.aquecimento?.de || 50} por dia e sobe sozinho
          até {dados.aquecimento?.ate || 300} em {dados.aquecimento?.dias || 15} dias de envio (aquecimento da caixa). Quando a lista estiver acabando, você recebe aviso
          e cola mais. Quem pediu para sair, endereço que já voltou e quem já é cliente ficam de fora.
          {dados.caixa && <div style={{ marginTop: 4, color: '#6b7280' }}>Sai de <strong>{dados.caixa}</strong>.</div>}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div>
            <div style={lbl}>Nome da campanha <span style={{ color: '#9ca3af', fontWeight: 400 }}>(só para você)</span></div>
            <input value={form.nome} onChange={e => campo('nome', e.target.value)} placeholder="Ex.: Prospecção lojas Campina Grande" style={inp} />
          </div>
          <div>
            <div style={lbl}>Assunto</div>
            <input value={form.assunto} onChange={e => campo('assunto', e.target.value)} placeholder="Ex.: Sua marca já está registrada?" style={inp} />
          </div>
        </div>
        <div>
          <div style={lbl}>Mensagem <span style={{ color: '#9ca3af', fontWeight: 400 }}>({'{nome}'} = nome que vier na lista; sem nome, some)</span></div>
          <textarea value={form.texto} onChange={e => campo('texto', e.target.value)} rows={10} style={{ ...inp, resize: 'vertical', lineHeight: 1.45 }} />
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {[['simples', '✉️ Simples', 'só texto — cai na aba Principal'], ['cabecalho', '🎨 Com cabeçalho', 'costuma cair em Promoções']].map(([k, rot, dica]) => (
            <label key={k} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '6px 10px', borderRadius: 6, cursor: 'pointer', border: `1px solid ${form.formato === k ? '#0a1628' : '#e5e7eb'}`, background: form.formato === k ? '#f1f5f9' : '#fff' }}>
              <input type="radio" name="formato-campanha" checked={form.formato === k} onChange={() => campo('formato', k)} style={{ marginTop: 2, width: 'auto', flex: '0 0 auto' }} />
              <span style={{ fontSize: 12.5, color: '#0a1628', fontWeight: 700 }}>{rot}<span style={{ display: 'block', fontWeight: 400, color: '#6b7280', fontSize: 11.5 }}>{dica}</span></span>
            </label>
          ))}
        </div>
        <div>
          <div style={lbl}>Anexos <span style={{ color: '#9ca3af', fontWeight: 400 }}>(opcional)</span></div>
          <AnexosEmail anexos={anexos} onChange={setAnexos} />
        </div>
        <div>
          <div style={lbl}>Lista de e-mails <span style={{ color: '#9ca3af', fontWeight: 400 }}>(um por linha — pode ser "Nome &lt;email&gt;" ou copiado de planilha)</span></div>
          <textarea value={form.lista} onChange={e => campo('lista', e.target.value)} rows={8} placeholder={'fulano@gmail.com\nLoja do Zé <contato@lojadoze.com.br>\nMaria Souza;maria@empresa.com.br'} style={{ ...inp, resize: 'vertical', lineHeight: 1.45 }} />
          {form.lista.trim() && <div style={{ fontSize: 12, marginTop: 4, color: '#166534', fontWeight: 600 }}>{validos} e-mail(s) válido(s)</div>}
        </div>
        <div>
          <button type="button" onClick={criar} disabled={ocupado} style={{ ...btn('#16a34a'), padding: '9px 18px', fontSize: 13, opacity: ocupado ? 0.6 : 1 }}>
            {ocupado ? 'Criando…' : '🔁 Criar campanha e começar'}
          </button>
        </div>
        {caixaMsg}
        {dados.encerradas?.length > 0 && (
          <div style={{ fontSize: 12, color: '#6b7280' }}>
            <div style={{ fontWeight: 700, color: '#374151', marginBottom: 4 }}>Campanhas encerradas</div>
            {dados.encerradas.map(e => <div key={e._id}>• {e.nome} — {e.enviados} enviado(s), de {fmtDt(e.criado_em)} a {fmtDt(e.encerrada_em)}</div>)}
          </div>
        )}
      </div>
    );
  }

  // ── Campanha aberta: andamento ──
  const metaCumprida = c.hoje >= c.meta_hoje;
  let situacao;
  if (c.status === 'pausada') situacao = { cor: '#92400e', bg: '#fffbeb', borda: '#fde68a', texto: `⏸ Pausada — ${c.pausa_motivo || ''}` };
  else if (!c.pendentes) situacao = { cor: '#374151', bg: '#f3f4f6', borda: '#e5e7eb', texto: '✅ A lista acabou — cole mais e-mails para continuar' };
  else if (!dados.janela?.aberta) situacao = { cor: '#1e3a8a', bg: '#eff6ff', borda: '#bfdbfe', texto: `🌙 Fora do horário — volta ${fmtDia(dados.janela.volta)} às 8h` };
  else if (metaCumprida) situacao = { cor: '#1e3a8a', bg: '#eff6ff', borda: '#bfdbfe', texto: '✔ Meta de hoje cumprida — continua no próximo dia útil às 8h' };
  else situacao = { cor: '#166534', bg: '#f0fdf4', borda: '#bbf7d0', texto: `🟢 Enviando${c.proximo_envio_em ? ` — próximo por volta das ${fmtHora(c.proximo_envio_em)}` : ''}` };
  const enviadosTotal = c.enviados + c.devolvidos;
  const taxaVolta = enviadosTotal ? Math.round((c.devolvidos / enviadosTotal) * 1000) / 10 : 0;
  const quadro = (titulo, valor, sub, cor = '#0a1628') => (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 12px' }}>
      <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>{titulo}</div>
      <div style={{ fontSize: 20, fontWeight: 800, color: cor, fontVariantNumeric: 'tabular-nums' }}>{valor}</div>
      {sub && <div style={{ fontSize: 11.5, color: '#6b7280' }}>{sub}</div>}
    </div>
  );

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: '#0a1628', flex: 1, minWidth: 220 }}>🔁 {c.nome}</div>
        {c.status === 'ativa'
          ? <button type="button" onClick={() => mudarStatus('pausada')} disabled={ocupado} style={{ ...btnOut, padding: '6px 12px' }}>⏸ Pausar</button>
          : <button type="button" onClick={() => mudarStatus('ativa')} disabled={ocupado} style={{ ...btn('#16a34a'), padding: '6px 14px' }}>▶ Retomar</button>}
        <button type="button" onClick={() => { setMais(m => (m === null ? '' : null)); setEdicao(null); }} style={{ ...btn(), padding: '6px 14px' }}>➕ Colar mais e-mails</button>
        <button type="button" onClick={() => { setEdicao(e => (e ? null : { assunto: c.assunto, texto: c.texto, formato: c.formato, anexos: c.anexos })); setMais(null); }} style={{ ...btnOut, padding: '6px 12px' }}>✏️ Editar mensagem</button>
        <button type="button" onClick={encerrar} disabled={ocupado} style={{ ...btnOut, padding: '6px 12px', color: '#b91c1c' }}>Encerrar</button>
      </div>
      <div style={{ fontSize: 12.5, fontWeight: 600, color: situacao.cor, background: situacao.bg, border: `1px solid ${situacao.borda}`, borderRadius: 6, padding: '7px 12px' }}>{situacao.texto}</div>
      {dados.erro_caixa && (
        <div style={{ fontSize: 12, background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: 6, padding: '6px 10px' }}>
          ⚠ Envio parado: {dados.erro_caixa} Corrija no ⚙️ (em "📧 Enviar e-mails").
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10 }}>
        {quadro('Hoje', `${c.hoje} de ${c.meta_hoje}`, `dia ${c.dia_aquecimento} de 15 do aquecimento → até ${c.meta_final}/dia`)}
        {quadro('Na fila', c.pendentes, c.previsao_fim ? `acaba por volta de ${fmtDia(c.previsao_fim)}` : (c.pendentes ? '' : 'cole mais para continuar'), c.pendentes ? '#0a1628' : '#b45309')}
        {quadro('Enviados', enviadosTotal, `de ${c.total} na lista`)}
        {quadro('Responderam', c.respostas, 'ver em 📥 Respostas', '#166534')}
        {quadro('Voltaram', c.devolvidos, `${taxaVolta.toString().replace('.', ',')}% — pausa sozinha acima de 5%`, c.devolvidos ? '#b91c1c' : '#0a1628')}
        {quadro('Saíram da lista', c.descadastrados, c.falhou ? `${c.falhou} falharam no envio` : '')}
      </div>
      {mais !== null && (
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, display: 'grid', gap: 8 }}>
          <div style={lbl}>Mais e-mails <span style={{ color: '#9ca3af', fontWeight: 400 }}>(entram no fim da fila, depois dos {c.pendentes} que faltam — quem já está na campanha não repete)</span></div>
          <textarea value={mais} onChange={e => setMais(e.target.value)} rows={7} autoFocus placeholder={'um por linha — pode ser "Nome <email>" ou copiado de planilha'} style={{ ...inp, resize: 'vertical', lineHeight: 1.45 }} />
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <button type="button" onClick={incluirMais} disabled={ocupado} style={{ ...btn('#16a34a'), padding: '7px 14px', opacity: ocupado ? 0.6 : 1 }}>
              {ocupado ? 'Incluindo…' : `➕ Adicionar ${lerListaEmails(mais).validos.length || ''} à fila`}
            </button>
            <button type="button" onClick={() => setMais(null)} style={{ ...btnOut, padding: '7px 12px' }}>cancelar</button>
          </div>
        </div>
      )}
      {edicao && (
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, display: 'grid', gap: 8 }}>
          <div style={{ fontSize: 12, color: '#6b7280' }}>Vale para quem ainda não recebeu. Quem já recebeu não recebe de novo.</div>
          <div><div style={lbl}>Assunto</div><input value={edicao.assunto} onChange={e => setEdicao(x => ({ ...x, assunto: e.target.value }))} style={inp} /></div>
          <div><div style={lbl}>Mensagem</div><textarea value={edicao.texto} onChange={e => setEdicao(x => ({ ...x, texto: e.target.value }))} rows={10} style={{ ...inp, resize: 'vertical', lineHeight: 1.45 }} /></div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {[['simples', '✉️ Simples'], ['cabecalho', '🎨 Com cabeçalho']].map(([k, rot]) => (
              <label key={k} style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 12.5, cursor: 'pointer' }}>
                <input type="radio" name="formato-edicao" checked={edicao.formato === k} onChange={() => setEdicao(x => ({ ...x, formato: k }))} style={{ width: 'auto', margin: 0 }} />{rot}
              </label>
            ))}
          </div>
          <div><div style={lbl}>Anexos</div><AnexosEmail anexos={edicao.anexos || []} onChange={a => setEdicao(x => ({ ...x, anexos: a }))} /></div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" onClick={salvarEdicao} disabled={ocupado} style={{ ...btn(), padding: '7px 16px', opacity: ocupado ? 0.6 : 1 }}>💾 Salvar mensagem</button>
            <button type="button" onClick={() => setEdicao(null)} style={{ ...btnOut, padding: '7px 12px' }}>cancelar</button>
          </div>
        </div>
      )}
      {caixaMsg}
      {!edicao && (
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 12px' }}>
          <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 4 }}>
            Mensagem · {c.formato === 'cabecalho' ? '🎨 com cabeçalho' : '✉️ simples'}{c.anexos?.length ? ` · 📎 ${c.anexos.map(a => a.nome).join(', ')}` : ''}
          </div>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 4 }}>{c.assunto}</div>
          <div style={{ fontSize: 12.5, color: '#374151', whiteSpace: 'pre-wrap', maxHeight: 120, overflow: 'hidden' }}>{c.texto}</div>
        </div>
      )}
      <div>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 6 }}>Últimos envios</div>
        {c.recentes.length === 0 ? (
          <div style={{ ...vazioCaixa, background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8 }}>
            Nenhum envio ainda{dados.janela?.aberta ? ' — o primeiro sai em instantes.' : `. O primeiro sai ${fmtDia(dados.janela?.volta)} às 8h.`}
          </div>
        ) : (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
            {c.recentes.map(i => {
              const st = statusEmail(i.status);
              return (
                <div key={i._id} style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr 90px 1.4fr', gap: 8, alignItems: 'center', padding: '5px 12px', fontSize: 12, borderBottom: '1px solid #f3f4f6' }}>
                  <span style={umaLinha}>{i.email}</span>
                  <span style={{ ...umaLinha, color: '#6b7280' }}>{i.nome || '—'}</span>
                  <span style={{ background: st.bg, color: st.cor, padding: '1px 8px', borderRadius: 4, fontWeight: 700, fontSize: 11, justifySelf: 'start' }}>{st.label}</span>
                  <span style={{ ...umaLinha, color: '#9ca3af' }} title={i.erro}>{i.erro || fmtDt(i.enviado_em)}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// A aba E-mail tem três partes: enviar (com a lista de envios), as respostas e
// a campanha automática. A parte escolhida fica lembrada neste navegador.
const parteDoAlvo = alvo => (alvo.id === 'campanha' ? 'campanha' : 'respostas');
function AbaEmail({ naoLidas, onNaoLidas, alvo }) {
  const [parte, setParte] = useState(() => {
    if (alvo) return parteDoAlvo(alvo);
    try { const p = localStorage.getItem('email_parte'); return ['respostas', 'campanha'].includes(p) ? p : 'enviar'; } catch { return 'enviar'; }
  });
  const trocar = p => {
    setParte(p);
    try { localStorage.setItem('email_parte', p); } catch { /* sem armazenamento: só nesta tela */ }
  };
  // Chegou por um aviso (e-mail novo → respostas; campanha → campanha automática)
  useEffect(() => { if (alvo) setParte(parteDoAlvo(alvo)); }, [alvo]);
  return (
    <div style={{ display: 'grid', gap: 14 }}>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {[['enviar', '📧 Enviar e-mails'], ['respostas', '📥 Respostas'], ['campanha', '🔁 Campanha automática']].map(([k, rot]) => (
          <button key={k} type="button" onClick={() => trocar(k)}
            style={{ ...(parte === k ? btn() : btnOut), padding: '6px 14px', display: 'flex', alignItems: 'center', gap: 6 }}>
            {rot}
            {k === 'respostas' && naoLidas > 0 && <span style={{ background: '#dc2626', color: '#fff', borderRadius: 10, padding: '0 7px', fontSize: 11, fontWeight: 700 }}>{naoLidas}</span>}
          </button>
        ))}
      </div>
      {parte === 'enviar' && <EnviarEmail />}
      {parte === 'respostas' && <CaixaEmail onNaoLidas={onNaoLidas} alvo={alvo} />}
      {parte === 'campanha' && <CampanhaEmail />}
    </div>
  );
}

// ── Aba SMS (22/10/2026) ──────────────────────────────────────────────────────
// Clientes com celular no cadastro e/ou uma lista avulsa de números. Sai pela
// Comtele (chave e rota no ⚙️), de segunda a sábado, das 9h às 21h. Todo SMS
// começa com o prefixo; o fim é opcional e vem em branco (a Comtele cobra cada
// resposta, então o SMS não convida a responder). Quem responde SAIR sai igual.
// As regras abaixo são as mesmas do servidor (backend/src/smsMassa.js), para a
// prévia e a contagem baterem com o que a Comtele cobra.
const GSM_BASICO = new Set([...'@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà']);
const GSM_EXTRA = new Set([...'^{}\\[~]|€']);
const soAlfabetoSms = s => [...String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')]
  .filter(ch => GSM_BASICO.has(ch) || GSM_EXTRA.has(ch)).join('').replace(/[ \t]{2,}/g, ' ');

function normalizarCelular(bruto) {
  let d = String(bruto || '').replace(/\D/g, '');
  if (d.startsWith('0')) d = d.replace(/^0+/, '');
  if ((d.length === 12 || d.length === 13) && d.startsWith('55')) d = d.slice(2);
  // Celular no formato antigo, sem o 9 (como vem do WhatsApp): DDD + 8 dígitos
  // começando com 6–9 ganha o 9; fixo (2–5) continua fora — igual ao servidor
  if (d.length === 10 && /[6-9]/.test(d[2])) d = `${d.slice(0, 2)}9${d.slice(2)}`;
  if (d.length !== 11 || d[2] !== '9') return null;
  return `55${d}`;
}
const mostrarCelular = n => (n && n.length === 13 ? `(${n.slice(2, 4)}) ${n.slice(4, 9)}-${n.slice(9)}` : n);

// Igual ao do servidor (smsMassa.js), que monta cada SMS na hora em que sai:
// {saudacao} = Bom dia / Boa tarde / Boa noite naquela hora (Brasília)
function saudacaoDaHora(agora = new Date()) {
  const h = Number(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Sao_Paulo', hour: 'numeric', hour12: false }).format(agora)) % 24;
  return h >= 5 && h < 12 ? 'Bom dia' : h >= 12 && h < 18 ? 'Boa tarde' : 'Boa noite';
}
// Variável entre chaves — ou entre parênteses: (nome)
const variavelSms = (nome, antes = '') => new RegExp(`${antes}[{(]${nome}[})]`, 'gi');

// vars = o que veio da lista das Oportunidades: { sdr, closer, mes, data };
// saudacao fixa só na conta de caracteres (a mais longa)
function montarSms({ texto, nome, vars, cfg, tirarAcentos, agora, saudacao }) {
  const nomeCliente = String(nome || '').trim();
  const v = k => String(vars?.[k] || '').trim();
  const comEspaco = valor => (valor ? ` ${valor}` : '');
  const corpo = String(texto || '')
    .replace(variavelSms('sauda[cç][aã]o'), saudacao || saudacaoDaHora(agora || new Date()))
    // sem nome, some junto com a vírgula de antes: "Boa tarde, {nome}!" → "Boa tarde!"
    .replace(variavelSms('nome', nomeCliente ? ' ?' : ',? ?'), comEspaco(nomeCliente))
    .replace(variavelSms('sdr'), v('sdr') || 'nossa equipe')
    .replace(variavelSms('closer', ' ?'), comEspaco(v('closer')))
    .replace(variavelSms('m[eê]s', ' ?'), comEspaco(v('mes')))
    .replace(variavelSms('data', ' ?'), comEspaco(v('data')))
    .replace(/^ +/gm, '')
    .trim();
  const prefixo = String(cfg?.prefixo ?? 'PRESERVA MARCAS:').trim();
  const rodape = String(cfg?.rodape ?? '').trim();
  const sms = [prefixo, corpo, rodape].filter(Boolean).join(' ');
  return tirarAcentos ? soAlfabetoSms(sms) : sms;
}

function contarSms(sms) {
  const chars = [...String(sms || '')];
  const unicode = chars.some(ch => !GSM_BASICO.has(ch) && !GSM_EXTRA.has(ch));
  const n = unicode ? String(sms).length : chars.reduce((t, ch) => t + (GSM_EXTRA.has(ch) ? 2 : 1), 0);
  const [um, parte] = unicode ? [70, 67] : [160, 153];
  return { caracteres: n, unicode, partes: n <= um ? 1 : Math.ceil(n / parte) };
}

// Um número por linha, ou separados por vírgula/";" — com ou sem máscara e +55
function lerListaCelulares(texto) {
  const vistos = new Set(), validos = [], invalidos = [];
  let repetidos = 0;
  for (const p of String(texto || '').split(/[\n,;/]+/).map(s => s.trim()).filter(s => /\d{4}/.test(s))) {
    const n = normalizarCelular(p);
    if (!n) { invalidos.push(p); continue; }
    if (vistos.has(n)) { repetidos++; continue; }
    vistos.add(n); validos.push(n);
  }
  return { validos, invalidos, repetidos };
}

// Situação da entrega que a Comtele avisa (o valor original fica guardado)
function entregaSms(e) {
  const verde = { bg: '#f0fdf4', cor: '#16a34a' }, cinza = { bg: '#f3f4f6', cor: '#6b7280' }, vermelho = { bg: '#fef2f2', cor: '#dc2626' };
  const mapa = {
    Delivered: ['Entregue', verde], Read: ['Lido', verde],
    Sent: ['Na operadora', cinza], Analysis: ['Processando', cinza], Created: ['Processando', cinza],
    Processing: ['Processando', cinza], Queued: ['Processando', cinza], Sending: ['Processando', cinza],
    Expired: ['Expirou', vermelho], Failed: ['Não entregue', vermelho], Undeliverable: ['Não entregue', vermelho],
    Invalid: ['Mensagem inválida', vermelho], InvalidNumber: ['Número inválido', vermelho], Rejected: ['Recusado', vermelho],
    LowBalance: ['Sem saldo', vermelho], Blocked: ['Bloqueado', vermelho], Canceled: ['Cancelado', cinza], LimitExceeded: ['Não entregue', vermelho],
  };
  const [label, c] = mapa[e] || [e, cinza];
  return { label, ...c };
}

const fmtReal = v => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 3 });

function ModalConfigSms({ cfg, onFechar, onSalvo }) {
  const [f, setF] = useState({ chave_api: '', rota_id: cfg?.rota_id || '', prefixo: cfg?.prefixo ?? 'PRESERVA MARCAS:', rodape: cfg?.rodape ?? '', limite_dia: cfg?.limite_dia || 300 });
  const [rotas, setRotas] = useState([]);
  const [saldo, setSaldo] = useState(null);
  const [para, setPara] = useState('');
  const [msg, setMsg] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  const [copiado, setCopiado] = useState('');
  const campo = (k, rot, extra = {}) => (
    <div>
      <div style={lbl}>{rot}</div>
      <input value={f[k]} onChange={e => setF(x => ({ ...x, [k]: e.target.value }))} style={inp} {...extra} />
    </div>
  );
  // Rotas contratadas e saldo vêm da própria Comtele, com a chave já salva
  const buscarComtele = useCallback(async () => {
    const [r, s] = await Promise.all([
      api('/comunicacao/sms/rotas').then(x => x.json()).catch(() => ({ erro: 'Não consegui buscar as rotas na Comtele.' })),
      api('/comunicacao/sms/saldo').then(x => x.json()).catch(() => ({})),
    ]);
    if (Array.isArray(r)) {
      setRotas(r);
      if (r.length === 1) setF(x => (x.rota_id ? x : { ...x, rota_id: r[0].id }));
    } else setMsg({ texto: r.erro });
    setSaldo(typeof s.saldo === 'number' ? s.saldo : null);
    return Array.isArray(r);
  }, []);
  useEffect(() => { if (cfg?.tem_chave) buscarComtele(); }, [cfg?.tem_chave, buscarComtele]);

  async function salvar() {
    setOcupado(true); setMsg(null);
    const rota = rotas.find(r => String(r.id) === String(f.rota_id));
    const body = { ...f, rota_nome: rota?.nome || cfg?.rota_nome || '', rota_preco: rota ? rota.preco : cfg?.rota_preco };
    const r = await api('/comunicacao/sms/config', { method: 'PUT', body: JSON.stringify(body) }).then(x => x.json()).catch(() => ({ erro: 'Falha ao salvar.' }));
    if (!r.ok) { setOcupado(false); return setMsg({ texto: r.erro }); }
    const chaveNova = !!f.chave_api.trim();
    setF(x => ({ ...x, chave_api: '' }));
    onSalvo();
    const comtele = chaveNova || !rotas.length ? await buscarComtele() : true;
    setOcupado(false);
    if (!comtele) return; // o erro da Comtele (chave recusada etc.) já está na tela
    setMsg(f.rota_id ? { ok: true, texto: 'Configuração salva.' } : { ok: true, texto: 'Chave salva. Agora escolha a rota de envio e clique em Salvar de novo.' });
  }
  async function testar() {
    setOcupado(true); setMsg(null);
    const r = await api('/comunicacao/sms/testar', { method: 'POST', body: JSON.stringify({ para }) }).then(x => x.json()).catch(() => ({ erro: 'Falha no teste.' }));
    setOcupado(false);
    setMsg(r.ok ? { ok: true, texto: `SMS de teste enviado para ${r.numero}. Deve chegar em alguns segundos.` } : { texto: r.erro });
  }
  // Sem permissão de área de transferência, deixa o endereço selecionado para o Ctrl+C
  async function copiar(texto, qual) {
    let ok = false;
    try { await navigator.clipboard.writeText(texto); ok = true; } catch { /* tenta do jeito antigo abaixo */ }
    const campo = document.getElementById(`aviso-sms-${qual}`);
    if (!ok && campo) { campo.focus(); campo.select(); try { ok = document.execCommand('copy'); } catch { ok = false; } }
    setCopiado(ok ? qual : `${qual}-manual`);
    setTimeout(() => setCopiado(''), 3000);
  }
  const linkAviso = (qual, rot, url) => (
    <div>
      <div style={lbl}>{rot}</div>
      <div style={{ display: 'flex', gap: 6 }}>
        <input id={`aviso-sms-${qual}`} readOnly value={url || ''} onFocus={e => e.target.select()} style={{ ...inp, fontSize: 11.5, color: '#374151', background: '#f9fafb' }} />
        <button type="button" onClick={() => copiar(url, qual)} style={{ ...btnOut, padding: '4px 10px', whiteSpace: 'nowrap' }}>
          {copiado === qual ? '✓ copiado' : copiado === `${qual}-manual` ? 'selecionado: copie' : 'copiar'}
        </button>
      </div>
    </div>
  );
  const semRotas = !rotas.length && cfg?.rota_id;
  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 540, maxWidth: '95vw', maxHeight: '92vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ background: '#0a1628', color: '#fff', padding: '10px 16px', fontSize: 14, fontWeight: 700, display: 'flex', justifyContent: 'space-between', position: 'sticky', top: 0 }}>
          ⚙️ SMS pela Comtele
          <button type="button" onClick={onFechar} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: 16, display: 'grid', gap: 10 }}>
          <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.45 }}>
            A chave fica no painel da Comtele, em <strong>Configurações → Chaves de API</strong>. Ela fica guardada só no servidor e não aparece mais nesta tela.
            Se a Comtele pedir IP liberado para a chave, use <strong>195.179.193.80</strong> (o servidor do sistema).
          </div>
          {campo('chave_api', 'Chave de acesso (API) da Comtele', { type: 'password', placeholder: cfg?.tem_chave ? '•••••••• (já cadastrada — em branco mantém)' : 'cole aqui a chave da Comtele', autoComplete: 'new-password' })}
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 8, alignItems: 'end' }}>
            <div>
              <div style={lbl}>Rota de envio</div>
              <select value={f.rota_id} onChange={e => setF(x => ({ ...x, rota_id: e.target.value }))} style={inp} disabled={!rotas.length && !semRotas}>
                <option value="">{rotas.length ? '— escolha a rota —' : (cfg?.tem_chave ? '— carregando… —' : 'salve a chave para ver as rotas')}</option>
                {rotas.map(r => <option key={r.id} value={r.id}>{r.nome}{r.preco != null ? ` · ${fmtReal(r.preco)} por SMS` : ''}</option>)}
                {semRotas && <option value={cfg.rota_id}>{cfg.rota_nome || `Rota ${cfg.rota_id}`}</option>}
              </select>
            </div>
            {campo('limite_dia', 'Limite por dia', { type: 'number' })}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {campo('prefixo', 'Começo de todo SMS', { maxLength: 30 })}
            {campo('rodape', 'Fim de todo SMS (opcional)', { maxLength: 40, placeholder: 'em branco = nada no fim' })}
          </div>
          {saldo !== null && <div style={{ fontSize: 12.5, color: '#0a1628' }}>💰 Saldo na Comtele: <strong>{saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>}
          <button type="button" onClick={salvar} disabled={ocupado} style={{ ...btn(), padding: '8px 0', opacity: ocupado ? 0.6 : 1 }}>💾 Salvar configuração</button>
          <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 10, display: 'flex', gap: 8, alignItems: 'flex-end' }}>
            <div style={{ flex: 1 }}>
              <div style={lbl}>Enviar SMS de teste para <span style={{ fontWeight: 400, color: '#9ca3af' }}>(gasta 1 SMS)</span></div>
              <input value={para} onChange={e => setPara(e.target.value)} placeholder="(83) 9 9999-9999" style={inp} />
            </div>
            <button type="button" onClick={testar} disabled={ocupado || !para.trim() || !cfg?.configurado} title={cfg?.configurado ? '' : 'Salve a chave e a rota primeiro'}
              style={{ ...btnOut, padding: '7px 14px', opacity: ocupado || !para.trim() || !cfg?.configurado ? 0.5 : 1 }}>📱 Testar</button>
          </div>
          {msg && (
            <div style={{ fontSize: 12.5, borderRadius: 6, padding: '8px 12px', background: msg.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${msg.ok ? '#bbf7d0' : '#fecaca'}`, color: msg.ok ? '#166534' : '#b91c1c' }}>
              {msg.ok ? '✅ ' : '⚠ '}{msg.texto}
            </div>
          )}
          <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 10, display: 'grid', gap: 8 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>Avisos de entrega e de resposta</div>
            <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.45 }}>
              Cadastre estes dois endereços nos webhooks da conta da Comtele. Sem eles o SMS sai normalmente, mas a tela não mostra se chegou, nem as respostas, nem quem pediu para sair.
            </div>
            {linkAviso('status', 'Webhook de status (entrega)', cfg?.webhook_status)}
            {linkAviso('resposta', 'Webhook de respostas', cfg?.webhook_resposta)}
          </div>
        </div>
      </div>
    </div>
  );
}

// 💰 Saldo e uso da Comtele (25/10/2026, pedido do Vagner: "um modal com as
// informações da Comtele, tipo saldo"): saldo e quanto ele dura no ritmo atual,
// gasto de hoje/semana/mês, entregas, rotas e as últimas mensagens e respostas —
// direto dos relatórios da Comtele (ver /comunicacao/sms/painel em smsMassa.js).
function ModalComtele({ onFechar }) {
  const [d, setD] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const carregar = useCallback(async () => {
    setCarregando(true); setErro('');
    const r = await api('/comunicacao/sms/painel').then(x => x.json()).catch(() => ({ erro: 'Falha de conexão.' }));
    setCarregando(false);
    if (r.erro) return setErro(r.erro);
    setD(r);
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  const p = d?.periodos || {};
  const status = Object.entries(d?.status_30 || {}).sort((a, b) => b[1] - a[1]);
  const total30 = status.reduce((s, [, n]) => s + n, 0);
  const entregues30 = status.filter(([s]) => s === 'Delivered' || s === 'Read').reduce((s, [, n]) => s + n, 0);
  const saldoBaixo = d && (d.saldo < 10 || (d.dias_de_saldo != null && d.dias_de_saldo < 3));
  const quadro = (titulo, valor, sub, cor = '#0a1628') => (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 12px' }}>
      <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.4 }}>{titulo}</div>
      <div style={{ fontSize: 20, fontWeight: 800, color: cor, fontVariantNumeric: 'tabular-nums' }}>{valor}</div>
      {sub && <div style={{ fontSize: 11.5, color: '#6b7280' }}>{sub}</div>}
    </div>
  );
  const secao = titulo => <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', margin: '4px 0 6px' }}>{titulo}</div>;
  const quem = x => (x.nome ? <>{x.nome} <span style={{ color: '#9ca3af' }}>{x.numero}</span></> : x.numero);

  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#f8fafc', borderRadius: 10, width: 760, maxWidth: '96vw', maxHeight: '92vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ background: '#0a1628', color: '#fff', padding: '10px 16px', fontSize: 14, fontWeight: 700, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          💰 Comtele — saldo e uso
          <button type="button" onClick={onFechar} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: 16, overflowY: 'auto', display: 'grid', gap: 12 }}>
          {erro && <div style={{ fontSize: 12.5, background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: 6, padding: '8px 12px' }}>⚠ {erro}</div>}
          {!d && !erro && <div style={vazioCaixa}>Consultando a Comtele…</div>}
          {d && (<>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10 }}>
              {quadro('Saldo', fmtReal(d.saldo), d.sms_restantes != null ? `≈ ${d.sms_restantes.toLocaleString('pt-BR')} SMS na rota ${d.rota?.nome || ''}` : '', saldoBaixo ? '#b91c1c' : '#166534')}
              {quadro('Dura', d.dias_de_saldo == null ? '—' : d.dias_de_saldo > 365 ? '+ de 1 ano' : `~${d.dias_de_saldo.toLocaleString('pt-BR')} dia(s)`, d.media_dia_7 > 0 ? `no ritmo dos últimos 7 dias (${fmtReal(d.media_dia_7)}/dia)` : 'sem gasto nos últimos 7 dias')}
              {quadro('Gasto hoje', fmtReal(p.hoje?.custo || 0), `${p.hoje?.sms || 0} SMS · ${p.hoje?.respostas || 0} resposta(s)`)}
              {quadro('Gasto no mês', fmtReal(p.mes?.custo || 0), `${p.mes?.sms || 0} SMS · ${p.mes?.respostas || 0} resposta(s)`)}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              {saldoBaixo && <span style={{ fontSize: 12.5, fontWeight: 600, color: '#92400e', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '6px 10px' }}>⚠ Saldo baixo — recarregue para os envios não pararem.</span>}
              <a href="https://portal.comtele.com.br" target="_blank" rel="noopener noreferrer" style={{ ...btn('#16a34a'), textDecoration: 'none', padding: '6px 14px' }}>Recarregar no painel da Comtele ↗</a>
            </div>

            {secao('Uso')}
            <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
              {[['', 'SMS enviados', 'partes cobradas', 'respostas', 'custo estimado'],
                ['Hoje', p.hoje], ['Últimos 7 dias', p.dias7], ['Este mês', p.mes], ['Últimos 30 dias', p.dias30]].map((linha, i) => {
                const cab = i === 0;
                const v = cab ? null : linha[1] || {};
                const cel = cab ? linha : [linha[0], v.sms || 0, v.partes || 0, v.respostas || 0, fmtReal(v.custo || 0)];
                return (
                  <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.3fr repeat(4, 1fr)', gap: 8, padding: '6px 12px', fontSize: 12.5, borderBottom: '1px solid #f3f4f6', background: cab ? '#f8fafc' : '#fff', color: cab ? '#6b7280' : '#0a1628', fontWeight: cab ? 600 : 400, fontVariantNumeric: 'tabular-nums' }}>
                    {cel.map((c, j) => <span key={j} style={{ textAlign: j ? 'right' : 'left', fontWeight: !cab && j === 0 ? 600 : undefined }}>{c}</span>)}
                  </div>
                );
              })}
            </div>

            {secao(`Entregas (últimos 30 dias)${total30 ? ` — ${Math.round((entregues30 / total30) * 100)}% entregues` : ''}`)}
            {total30 === 0 ? <div style={{ ...vazioCaixa, padding: 10 }}>Nenhum SMS nos últimos 30 dias.</div> : (
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {status.map(([s, n]) => {
                  const en = entregaSms(s);
                  return <span key={s} title={`situação na Comtele: ${s}`} style={{ background: en.bg, color: en.cor, borderRadius: 4, padding: '2px 10px', fontSize: 12, fontWeight: 700 }}>{en.label}: {n}</span>;
                })}
              </div>
            )}

            {secao('Rotas e tarifas')}
            <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
              {(d.rotas || []).map(r => (
                <div key={r.id} style={{ display: 'grid', gridTemplateColumns: '1.2fr 1.4fr 1fr 1fr 80px', gap: 8, padding: '6px 12px', fontSize: 12.5, borderBottom: '1px solid #f3f4f6', fontVariantNumeric: 'tabular-nums' }}>
                  <strong style={{ color: '#0a1628' }}>{r.nome}</strong>
                  <span style={{ color: '#6b7280' }}>{r.produto}</span>
                  <span>{fmtReal(r.preco)} / SMS</span>
                  <span style={{ color: '#6b7280' }}>{fmtReal(r.preco_resposta)} / resposta</span>
                  <span style={{ color: '#166534', fontWeight: 700 }}>{String(r.id) === String(d.rota?.id) ? '✓ em uso' : ''}</span>
                </div>
              ))}
            </div>

            {secao('Últimos SMS enviados')}
            {!d.ultimos_envios?.length ? <div style={{ ...vazioCaixa, padding: 10 }}>Nenhum ainda.</div> : (
              <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                {d.ultimos_envios.map((m, i) => {
                  const en = entregaSms(m.status);
                  return (
                    <div key={i} style={{ display: 'grid', gridTemplateColumns: '120px 1.6fr 120px 1fr', gap: 8, alignItems: 'center', padding: '5px 12px', fontSize: 12, borderBottom: '1px solid #f3f4f6' }}>
                      <span style={{ color: '#6b7280' }}>{fmtDt(m.quando)}</span>
                      <span style={umaLinha}>{quem(m)}</span>
                      <span title={m.detalhe} style={{ background: en.bg, color: en.cor, borderRadius: 4, padding: '1px 8px', fontWeight: 700, fontSize: 11, justifySelf: 'start' }}>{en.label}</span>
                      <span style={{ ...umaLinha, color: '#9ca3af' }} title={m.detalhe}>{m.rota}</span>
                    </div>
                  );
                })}
              </div>
            )}

            {secao('Últimas respostas recebidas')}
            {!d.ultimas_respostas?.length ? <div style={{ ...vazioCaixa, padding: 10 }}>Nenhuma resposta ainda.</div> : (
              <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
                {d.ultimas_respostas.map((r, i) => (
                  <div key={i} style={{ display: 'grid', gridTemplateColumns: '120px 1.2fr 2fr', gap: 8, alignItems: 'center', padding: '5px 12px', fontSize: 12, borderBottom: '1px solid #f3f4f6' }}>
                    <span style={{ color: '#6b7280' }}>{fmtDt(r.quando)}</span>
                    <span style={umaLinha}>{quem(r)}</span>
                    <span style={{ ...umaLinha, color: '#1d4ed8', fontWeight: 600 }} title={r.texto}>💬 {r.texto}</span>
                  </div>
                ))}
              </div>
            )}

            <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 11.5, color: '#9ca3af' }}>
              <span style={{ flex: 1 }}>
                Direto da Comtele · atualizado às {fmtHora(d.atualizado_em)} · custo estimado (partes do SMS × tarifa da rota; a Comtele cobra mesmo sem entrega)
                {d.truncado ? ' · mostrando os 1.000 envios mais recentes do período' : ''}
              </span>
              <button type="button" onClick={carregar} disabled={carregando} style={{ ...btnOut, padding: '4px 10px', opacity: carregando ? 0.6 : 1 }}>{carregando ? 'Atualizando…' : '↻ Atualizar'}</button>
            </div>
          </>)}
        </div>
      </div>
    </div>
  );
}

// ── 📥 SMS para uma lista baixada das Oportunidades (26/10/2026) ──────────────
// Pedido do Vagner: usar a planilha que ele baixou nas Oportunidades para montar
// mensagens que façam sentido, com o {nome}, a {sdr} e o {closer} de cada
// contato. Quem ainda não falou com o consultor (Lead, Sem interação) recebe a
// mensagem 2, que não diz que ele tirou dúvidas. O servidor monta cada SMS na
// hora em que sai; aqui é a prévia.
// Versão curta (26/10/2026, pedido do Vagner): cabe em 1 SMS de 160 letras — na
// lista de junho a maior ficou com 147. A versão longa dava 2 SMS por pessoa.
const MODELOS_LISTA = {
  1: '{saudacao}, {nome}! Lembra da {sdr} e do consultor {closer}? Quer registrar sua marca? WhatsApp 83 98698-7687 ou @preservamarcas',
  2: '{saudacao}, {nome}! A {sdr} falou com você sobre sua marca. Ainda quer registrar? WhatsApp 83 98698-7687 ou @preservamarcas',
};
const ETAPAS_MENSAGEM_2 = ['Lead', 'Sem interação']; // igual ao servidor
const ORDEM_ETAPAS = ['1º Contato', 'Viabilidade', 'Negociação', 'Perdido', 'Ganho', 'Lead', 'Sem interação'];
const VARIAVEIS_LISTA = [
  ['{saudacao}', 'Bom dia, Boa tarde ou Boa noite, conforme a hora em que o SMS sai'],
  ['{nome}', '1º nome do contato; sem nome (ou nome de empresa), some junto com a vírgula'],
  ['{sdr}', '1º nome da SDR; sem SDR, ou se foi o próprio consultor, sai "nossa equipe"'],
  ['{closer}', '1º nome do consultor que atendeu'],
  ['{mes}', 'mês em que a oportunidade entrou (ex.: junho)'],
  ['{data}', 'dia em que a oportunidade entrou (ex.: 15/06)'],
];
const linkBtn = { background: 'none', border: 'none', color: '#0a1628', fontSize: 12, cursor: 'pointer', padding: 0, textDecoration: 'underline' };
const caixaAviso = { fontSize: 12, background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 6, padding: '6px 10px' };

function SmsListaOportunidades({ cfg, saldo, inicial, onEnviado }) {
  const [aberto, setAberto] = useState(false);
  const [downloads, setDownloads] = useState(null);
  const [listaId, setListaId] = useState('');
  const [lista, setLista] = useState(null);
  const [erroLista, setErroLista] = useState('');
  const [etapasOn, setEtapasOn] = useState([]);
  const [pular, setPular] = useState(true);
  // No navegador fica só o texto que ele mudou: igual ao modelo não é salvo, e
  // assim um modelo novo aparece sozinho (a chave _v2 descarta a versão longa)
  const [textos, setTextos] = useState(() => {
    try { return { ...MODELOS_LISTA, ...JSON.parse(localStorage.getItem('sms_lista_textos_v2') || '{}') }; } catch { return { ...MODELOS_LISTA }; }
  });
  const [verTodas, setVerTodas] = useState(false);
  const [verFora, setVerFora] = useState(false);
  const [agendar, setAgendar] = useState(false);
  const [quando, setQuando] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const refs = { 1: ref1, 2: ref2 };

  // Veio do 🕘 Histórico das Oportunidades (botão 📱 Mandar SMS): abre com a lista
  useEffect(() => { if (inicial?.id) { setAberto(true); setListaId(inicial.id); setResultado(null); } }, [inicial]);
  useEffect(() => {
    if (!aberto || downloads) return;
    api('/oportunidades/exportacoes').then(r => r.json()).then(d => setDownloads(Array.isArray(d) ? d : [])).catch(() => setDownloads([]));
  }, [aberto, downloads]);
  useEffect(() => {
    setLista(null); setErroLista(''); setVerTodas(false); setVerFora(false);
    if (!listaId) return undefined;
    let vivo = true;
    api(`/comunicacao/sms/lista-oportunidades/${listaId}`).then(r => r.json()).then(d => {
      if (!vivo) return;
      if (!d || d.erro || !Array.isArray(d.contatos)) { setErroLista(d?.erro || 'Não consegui abrir a lista.'); return; }
      setLista(d);
      // Ganho já é cliente: fica de fora, a não ser que ele marque
      setEtapasOn([...new Set(d.contatos.map(c => c.etapa))].filter(e => e !== 'Ganho'));
    }).catch(() => { if (vivo) setErroLista('Não consegui abrir a lista.'); });
    return () => { vivo = false; };
  }, [listaId]);
  useEffect(() => {
    const mudados = Object.fromEntries(Object.entries(textos).filter(([g, t]) => t !== MODELOS_LISTA[g]));
    try {
      localStorage.setItem('sms_lista_textos_v2', JSON.stringify(mudados));
      localStorage.removeItem('sms_lista_textos');
    } catch { /* sem armazenamento: vale só nesta tela */ }
  }, [textos]);

  // Quem recebe, quem fica de fora (e por quê) e a conta de SMS
  const calc = useMemo(() => {
    const contatos = lista?.contatos || [];
    const vistos = new Set();
    const linhas = contatos.map(c => {
      let fora = '';
      if (!etapasOn.includes(c.etapa)) fora = 'etapa desmarcada';
      else if (!c.numero) fora = c.telefone ? 'telefone fixo ou incompleto' : 'sem telefone';
      else if (c.descadastrado) fora = 'pediu para sair dos SMS';
      else if (pular && c.na_fila) fora = 'já está na fila de SMS';
      else if (pular && c.ja_recebeu_em) fora = `já recebeu SMS em ${fmtDt(c.ja_recebeu_em)}`;
      else if (vistos.has(c.numero)) fora = 'celular repetido na lista';
      if (!fora) vistos.add(c.numero);
      return { ...c, fora };
    });
    const recebem = linhas.filter(l => !l.fora);
    let totalSms = 0;
    const maiorPartes = { 1: 0, 2: 0 };
    for (const l of recebem) {
      const p = contarSms(montarSms({ texto: textos[l.grupo], nome: l.nome, vars: l.vars, cfg, tirarAcentos: true, saudacao: 'Boa tarde' })).partes;
      totalSms += p;
      maiorPartes[l.grupo] = Math.max(maiorPartes[l.grupo], p);
    }
    const porEtapa = {};
    for (const c of contatos) porEtapa[c.etapa] = (porEtapa[c.etapa] || 0) + 1;
    const marcada = l => etapasOn.includes(l.etapa);
    return {
      linhas, recebem, totalSms, maiorPartes, porEtapa,
      porGrupo: { 1: recebem.filter(l => l.grupo === 1), 2: recebem.filter(l => l.grupo === 2) },
      semCelular: linhas.filter(l => marcada(l) && !l.numero).length,
      sairam: linhas.filter(l => marcada(l) && l.numero && l.descadastrado).length,
      jaReceberam: linhas.filter(l => marcada(l) && l.numero && !l.descadastrado && (l.ja_recebeu_em || l.na_fila)).length,
    };
  }, [lista, etapasOn, pular, textos, cfg]);
  const { linhas, recebem, porGrupo, totalSms, maiorPartes, porEtapa, semCelular, sairam, jaReceberam } = calc;

  const etapasDaLista = [...ORDEM_ETAPAS.filter(e => porEtapa[e]), ...Object.keys(porEtapa).filter(e => !ORDEM_ETAPAS.includes(e))];
  const grupoDe = e => (ETAPAS_MENSAGEM_2.includes(e) ? 2 : 1);
  const custo = cfg?.rota_preco != null && totalSms ? totalSms * cfg.rota_preco : null;
  const limiteDia = Number(cfg?.limite_dia) || 300;
  const dias = Math.ceil(recebem.length / limiteDia);
  const agoraPrevia = agendar && quando ? new Date(quando) : new Date();
  const montar = l => montarSms({ texto: textos[l.grupo], nome: l.nome, vars: l.vars, cfg, tirarAcentos: true, agora: agoraPrevia });
  // Exemplo da prévia: de preferência alguém com nome, SDR e consultor
  const exemplo = g => porGrupo[g].find(l => l.nome && l.vars?.sdr && l.vars?.closer) || porGrupo[g].find(l => l.nome) || porGrupo[g][0];

  // O que pode deixar a mensagem sem sentido
  const avisos = [];
  if (porGrupo[2].length && /[{(]closer[})]|consultor/i.test(textos[2] || '')) avisos.push('A mensagem 2 vai para quem ainda não falou com o consultor. Confira se o texto não diz que ele tirou dúvidas.');
  if ([1, 2].some(g => porGrupo[g].length && /\b(bom dia|boa tarde|boa noite)\b/i.test(textos[g] || '') && !/[{(]sauda[cç][aã]o[})]/i.test(textos[g] || ''))) {
    avisos.push('Troque o "Boa tarde" fixo por {saudacao}: o SMS pode sair de manhã ou à noite (a fila manda das 9h às 21h).');
  }
  if (etapasOn.includes('Ganho') && porEtapa.Ganho) avisos.push('Ganho está marcado: esses já são clientes. Confira se a mensagem faz sentido para eles.');

  function inserir(g, variavel) {
    const el = refs[g].current;
    const t = textos[g] || '';
    const ini = el ? el.selectionStart : t.length;
    const fim = el ? el.selectionEnd : t.length;
    setTextos(x => ({ ...x, [g]: t.slice(0, ini) + variavel + t.slice(fim) }));
    setTimeout(() => { if (el) { el.focus(); el.selectionStart = el.selectionEnd = ini + variavel.length; } }, 0);
  }
  const alternarEtapa = e => setEtapasOn(x => (x.includes(e) ? x.filter(y => y !== e) : [...x, e]));

  async function enviar(agendado = false) {
    if (!recebem.length) return setResultado({ erro: 'Ninguém desta lista vai receber: confira as etapas marcadas.' });
    const semTexto = [1, 2].find(g => porGrupo[g].length && !String(textos[g] || '').trim());
    if (semTexto) return setResultado({ erro: `Escreva a mensagem ${semTexto}.` });
    if (agendado && !quando) return setResultado({ erro: 'Escolha o dia e a hora do agendamento.' });
    const inicio = agendado ? ` a partir de ${fmtDt(new Date(quando).toISOString())}` : ' agora';
    const resumo = [1, 2].filter(g => porGrupo[g].length).map(g => `Mensagem ${g}: ${porGrupo[g].length} celular(es)`).join('\n');
    const prazo = dias > 1 ? `\nNo limite de ${limiteDia} por dia, termina em uns ${dias} dias.` : '';
    if (!window.confirm(`Enviar o SMS para ${recebem.length} celular(es)${inicio}?\n\n${resumo}\n\nSerão cobrados ${totalSms} SMS${custo != null ? ` (cerca de ${fmtReal(custo)})` : ''}.${prazo}`)) return;
    setEnviando(true); setResultado(null);
    const body = { oportunidades: { id: lista.id, etapas: etapasOn, pular_ja_receberam: pular, textos: { 1: textos[1], 2: textos[2] } }, tirar_acentos: true };
    if (agendado) body.agendado_para = new Date(quando).toISOString();
    const r = await api('/comunicacao/sms/enviar', { method: 'POST', body: JSON.stringify(body) }).then(x => x.json()).catch(() => ({ erro: 'Falha ao enfileirar.' }));
    setEnviando(false);
    setResultado(r);
    if (r.ok) { setListaId(''); setAgendar(false); setQuando(''); if (onEnviado) onEnviado(r); }
  }

  const chipEtapa = on => ({ padding: '3px 10px', borderRadius: 999, fontSize: 12, cursor: 'pointer', border: `1px solid ${on ? '#0a1628' : '#d1d5db'}`,
    background: on ? '#0a1628' : '#fff', color: on ? '#fff' : '#6b7280', fontWeight: on ? 600 : 400 });
  const balao = { background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 10, padding: '8px 10px', fontSize: 12.5, color: '#0a1628', whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.45 };

  return (
    <div style={{ background: '#fff', border: '1px solid #c7d2fe', borderRadius: 8 }}>
      <button type="button" onClick={() => setAberto(a => !a)}
        style={{ width: '100%', background: 'none', border: 'none', padding: '10px 14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, textAlign: 'left', flexWrap: 'wrap' }}>
        <span style={{ fontSize: 11, color: '#6b7280', width: 12 }}>{aberto ? '▼' : '▶'}</span>
        <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>📥 SMS para uma lista baixada das Oportunidades</span>
        <span style={{ fontSize: 12, color: '#6b7280' }}>· cada contato recebe a mensagem com o nome dele, a SDR e o consultor que o atenderam</span>
      </button>
      {aberto && (
        <div style={{ padding: '0 14px 14px', display: 'grid', gap: 12 }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>Lista</span>
            <select value={listaId} onChange={e => { setListaId(e.target.value); setResultado(null); }} style={{ ...inp, flex: 1, minWidth: 260, width: 'auto' }}>
              <option value="">
                {downloads === null ? 'Carregando os downloads…' : downloads.length ? '— escolha um download das Oportunidades —' : 'Nenhum download ainda: baixe em Oportunidades › ⬇️ Baixar contatos'}
              </option>
              {(downloads || []).map(d => (
                <option key={d._id} value={d._id}>{fmtDt(d.criado_em)} · {d.total_contatos} contato(s) · {d.filtros_texto || 'sem filtro'}</option>
              ))}
            </select>
          </div>
          {erroLista && <div style={{ fontSize: 12.5, color: '#b91c1c' }}>⚠ {erroLista}</div>}
          {listaId && !lista && !erroLista && <div style={{ fontSize: 12.5, color: '#6b7280' }}>Abrindo a lista…</div>}
          {lista && cfg && !cfg.configurado && <div style={caixaAviso}>⚠ Falta configurar a Comtele (⚙️ no Novo SMS, abaixo). Até lá os SMS ficam esperando na fila.</div>}
          {lista && (
            <>
              {/* Quem recebe: etapas da lista, separadas pela mensagem que cada uma recebe */}
              <div style={{ display: 'grid', gap: 6 }}>
                {[[1, '💬 Falaram com o consultor → mensagem 1'], [2, '🕓 Ainda não falaram com o consultor → mensagem 2']].map(([g, titulo]) => {
                  const etapas = etapasDaLista.filter(e => grupoDe(e) === g);
                  if (!etapas.length) return null;
                  return (
                    <div key={g} style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 12, fontWeight: 600, color: '#374151', width: 300 }}>{titulo}</span>
                      {etapas.map(e => {
                        const on = etapasOn.includes(e);
                        return (
                          <button key={e} type="button" onClick={() => alternarEtapa(e)} style={chipEtapa(on)}
                            title={e === 'Ganho' ? 'Já são clientes: ficam de fora, a não ser que você marque' : on ? 'Clique para tirar esta etapa' : 'Clique para incluir esta etapa'}>
                            {on ? '✓ ' : ''}{e} ({porEtapa[e]})
                          </button>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
              <div style={{ fontSize: 12.5, color: '#374151', display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                <strong style={{ color: recebem.length ? '#16a34a' : '#b91c1c' }}>{recebem.length} celular(es) recebem</strong>
                {semCelular > 0 && <span style={{ color: '#6b7280' }}>· {semCelular} sem celular (fixo ou sem número)</span>}
                {sairam > 0 && <span style={{ color: '#6b7280' }}>· {sairam} {sairam === 1 ? 'pediu' : 'pediram'} para sair</span>}
                {jaReceberam > 0 && (
                  <label style={{ display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer', color: '#0a1628' }}>
                    · <input type="checkbox" checked={pular} onChange={e => setPular(e.target.checked)} style={{ width: 'auto', margin: 0 }} />
                    {jaReceberam === 1 ? 'pular o 1 que já recebeu SMS' : `pular os ${jaReceberam} que já receberam SMS`}
                  </label>
                )}
              </div>

              {/* As duas mensagens */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 12 }}>
                {[1, 2].map(g => {
                  const ex = exemplo(g);
                  const n = porGrupo[g].length;
                  const sms = ex ? montar(ex) : '';
                  const cont = contarSms(sms);
                  return (
                    <div key={g} style={{ border: '1px solid #e5e7eb', borderRadius: 8, padding: 10, background: n ? '#fff' : '#fafafa' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8, marginBottom: 6 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>
                          Mensagem {g} <span style={{ fontWeight: 400, color: '#6b7280', fontSize: 12 }}>· {g === 1 ? 'falaram com o consultor' : 'ainda não falaram com o consultor'} · {n} celular(es)</span>
                        </span>
                        {textos[g] !== MODELOS_LISTA[g] && (
                          <button type="button" onClick={() => setTextos(x => ({ ...x, [g]: MODELOS_LISTA[g] }))} style={linkBtn} title="Voltar ao texto modelo">↺ modelo</button>
                        )}
                      </div>
                      <textarea ref={refs[g]} value={textos[g] || ''} rows={6} maxLength={600}
                        onChange={e => { const t = e.target.value; setTextos(x => ({ ...x, [g]: t })); }}
                        style={{ ...inp, resize: 'vertical', lineHeight: 1.45 }} />
                      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', margin: '6px 0 8px' }}>
                        {VARIAVEIS_LISTA.map(([v, d]) => (
                          <button key={v} type="button" onClick={() => inserir(g, v)} title={`${d}. Clique para pôr no texto.`}
                            style={{ ...btnOut, padding: '1px 7px', fontSize: 11, fontFamily: 'monospace' }}>{v}</button>
                        ))}
                      </div>
                      {ex ? (
                        <>
                          <div style={{ fontSize: 11.5, color: '#6b7280', marginBottom: 3 }}>
                            Como chega para <strong style={{ color: '#0a1628' }}>{ex.nome || ex.celular}</strong> ({ex.etapa}{ex.sdr_lista ? ` · SDR ${ex.sdr_lista}` : ''}{ex.closer_lista ? ` · consultor ${ex.closer_lista}` : ''})
                          </div>
                          <div style={balao}>{sms}</div>
                          <div style={{ fontSize: 11.5, color: cont.partes > 1 ? '#b45309' : '#6b7280', marginTop: 3, fontVariantNumeric: 'tabular-nums' }}>
                            {cont.caracteres} caracteres = {cont.partes} SMS por celular{maiorPartes[g] > cont.partes ? ` (alguns chegam a ${maiorPartes[g]}, por causa do tamanho do nome)` : ''}
                          </div>
                        </>
                      ) : (
                        <div style={{ fontSize: 12, color: '#9ca3af' }}>Ninguém marcado para esta mensagem.</div>
                      )}
                    </div>
                  );
                })}
              </div>
              <div style={{ fontSize: 11.5, color: '#6b7280', lineHeight: 1.55 }}>
                {VARIAVEIS_LISTA.map(([v, d]) => (
                  <div key={v}><code style={{ color: '#0a1628', fontWeight: 700 }}>{v}</code> = {d}</div>
                ))}
              </div>
              {avisos.map(a => <div key={a} style={caixaAviso}>⚠ {a}</div>)}

              {/* Todas as mensagens, uma por uma */}
              <div>
                <button type="button" onClick={() => setVerTodas(v => !v)} style={linkBtn}>
                  {verTodas ? '▲ Esconder as mensagens' : `▼ Ver as ${recebem.length} mensagens, uma por uma`}
                </button>
                {verTodas && (
                  <div style={{ marginTop: 6 }}>
                    {linhas.length > recebem.length && (
                      <label style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 12, color: '#374151', cursor: 'pointer', marginBottom: 6 }}>
                        <input type="checkbox" checked={verFora} onChange={e => setVerFora(e.target.checked)} style={{ width: 'auto', margin: 0 }} />
                        mostrar também quem fica de fora ({linhas.length - recebem.length}) e o motivo
                      </label>
                    )}
                    <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, maxHeight: 420, overflowY: 'auto' }}>
                      {(verFora ? linhas : recebem).map((l, i) => (
                        <div key={`${l.oportunidade_id}-${i}`} style={{ display: 'grid', gridTemplateColumns: '120px 190px minmax(0, 1fr)', gap: 10, padding: '6px 10px', borderBottom: '1px solid #f3f4f6', fontSize: 12, background: l.fora ? '#fafafa' : '#fff' }}>
                          <span style={{ fontVariantNumeric: 'tabular-nums', color: l.fora ? '#9ca3af' : '#374151' }}>{l.celular || l.telefone || '—'}</span>
                          <span style={{ minWidth: 0 }}>
                            <div style={{ fontWeight: 600, color: l.fora ? '#9ca3af' : '#0a1628' }}>{l.nome || <span style={{ fontWeight: 400, color: '#9ca3af' }}>sem nome</span>}</div>
                            <div title={l.nome_lista} style={{ color: '#9ca3af', fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.nome_lista || '—'} · {l.etapa}</div>
                          </span>
                          <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: l.fora ? '#9ca3af' : '#0a1628' }}>
                            {l.fora ? `Fica de fora: ${l.fora}.` : montar(l)}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Envio */}
              <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 10, display: 'grid', gap: 8 }}>
                <div style={{ fontSize: 12.5, color: '#0a1628', fontVariantNumeric: 'tabular-nums' }}>
                  {recebem.length} celular(es) · <strong>{totalSms} SMS cobrados</strong>{custo != null && <> · cerca de <strong>{fmtReal(custo)}</strong></>}
                  {dias > 1 && <span style={{ color: '#6b7280' }}> · no limite de {limiteDia} por dia, leva uns {dias} dias</span>}
                </div>
                {saldo != null && custo != null && custo > saldo && (
                  <div style={caixaAviso}>⚠ O saldo da Comtele ({fmtReal(saldo)}) não cobre tudo: dá para uns {Math.floor(saldo / (custo / recebem.length))} celulares. O resto espera na fila até você recarregar.</div>
                )}
                <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                  <button type="button" onClick={() => enviar(false)} disabled={enviando || !recebem.length}
                    style={{ ...btn('#16a34a'), padding: '8px 16px', fontSize: 13, opacity: enviando || !recebem.length ? 0.5 : 1 }}>
                    {enviando ? 'Enfileirando…' : `📱 Enviar para ${recebem.length} celular(es)`}
                  </button>
                  {!agendar ? (
                    <button type="button" onClick={() => setAgendar(true)} style={{ ...linkBtn, color: '#6b7280' }}>⏰ Agendar para outro horário</button>
                  ) : (
                    <span style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                      <span style={{ minWidth: 230 }}><CampoDataHora value={quando} onChange={setQuando} style={inp} /></span>
                      <button type="button" onClick={() => enviar(true)} disabled={enviando} style={{ ...btn('#0a1628'), padding: '7px 12px', opacity: enviando ? 0.5 : 1 }}>⏰ Agendar envio</button>
                      <button type="button" onClick={() => { setAgendar(false); setQuando(''); }} style={{ ...btnOut, padding: '7px 10px' }}>cancelar</button>
                    </span>
                  )}
                </div>
                <div style={{ fontSize: 11, color: '#9ca3af', lineHeight: 1.4 }}>
                  Cada SMS é montado na hora em que sai, então a {'{saudacao}'} acompanha o horário. Sai de segunda a sábado, das 9h às 21h, 1 por segundo, até {limiteDia} por dia. Acompanhe em "📬 Envios de SMS", lá embaixo.
                </div>
              </div>
            </>
          )}
          {resultado && (
            <div style={{ fontSize: 12.5, background: resultado.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${resultado.ok ? '#bbf7d0' : '#fecaca'}`, borderRadius: 6, padding: '8px 12px', color: resultado.ok ? '#166534' : '#b91c1c' }}>
              {resultado.ok
                ? <>✅ <strong>{resultado.enfileirados}</strong> SMS na fila{resultado.lotes?.length > 1 ? ` (${resultado.lotes.length} envios, um por mensagem)` : ''}. Acompanhe em "📬 Envios de SMS", lá embaixo.</>
                : `⚠ ${resultado.erro}`}
              {resultado.fora_do_horario && <div style={{ color: '#6b7280', marginTop: 4 }}>🌙 Fora do horário de envio: começam a sair às 9h.</div>}
              {resultado.ja_receberam > 0 && <div style={{ color: '#6b7280', marginTop: 4 }}>{resultado.ja_receberam} pulado(s): já tinham recebido SMS.</div>}
              {resultado.descadastrados > 0 && <div style={{ color: '#6b7280', marginTop: 4 }}>{resultado.descadastrados} pulado(s): pediram para sair da lista.</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function AbaSms({ listaInicial }) {
  const [cfg, setCfg] = useState(null);
  const [abrirCfg, setAbrirCfg] = useState(false);
  const [abrirComtele, setAbrirComtele] = useState(false);
  const [saldoTopo, setSaldoTopo] = useState(null); // saldo no botão 💰 do painel
  const [urgente, setUrgente] = useState(false); // ⚡ sai na hora, mesmo fora do horário
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState('');
  const [marcados, setMarcados] = useState([]);
  const [avulsos, setAvulsos] = useState('');
  const [texto, setTexto] = useState('');
  const [tirarAcentos, setTirarAcentos] = useState(true);
  const [agendar, setAgendar] = useState(false);
  const [clientesAbertos, setClientesAbertos] = useState(() => {
    try { return localStorage.getItem('sms_clientes_recolhido') !== '1'; } catch { return true; }
  });
  const alternarClientes = () => setClientesAbertos(aberto => {
    try { localStorage.setItem('sms_clientes_recolhido', aberto ? '1' : '0'); } catch { /* sem armazenamento: só nesta tela */ }
    return !aberto;
  });
  const [quando, setQuando] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [envios, setEnvios] = useState([]);
  const [loteAberto, setLoteAberto] = useState(null);

  const carregarCfg = useCallback(() => api('/comunicacao/sms/config').then(r => r.json()).then(setCfg).catch(() => {}), []);
  const carregarEnvios = useCallback(() => api('/comunicacao/sms/envios').then(r => r.json()).then(d => setEnvios(Array.isArray(d) ? d : [])).catch(() => {}), []);
  useEffect(() => {
    carregarCfg(); carregarEnvios();
    api('/comunicacao/sms/clientes').then(r => r.json()).then(d => setClientes(Array.isArray(d.itens) ? d.itens : [])).catch(() => {});
  }, [carregarCfg, carregarEnvios]);
  const carregarSaldo = useCallback(() => api('/comunicacao/sms/saldo').then(r => r.json()).then(d => setSaldoTopo(typeof d.saldo === 'number' ? d.saldo : null)).catch(() => {}), []);
  useEffect(() => { if (cfg?.configurado) carregarSaldo(); }, [cfg?.configurado, carregarSaldo]);
  // Com SMS na fila ou recém-enviado (entrega e respostas chegando), atualiza sozinho
  const temFila = envios.some(l => l.itens.some(i => i.status === 'agendado'));
  const recente = envios.some(l => Date.now() - new Date(l.criado_em).getTime() < 15 * 60000);
  useEffect(() => {
    if (!temFila && !recente) return;
    const t = setInterval(() => { carregarEnvios(); carregarCfg(); }, 15000);
    return () => clearInterval(t);
  }, [temFila, recente, carregarEnvios, carregarCfg]);

  const termo = busca.trim();
  const re = termo ? new RegExp(termo.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : null;
  const digitos = termo.replace(/\D/g, '');
  const visiveis = clientes.filter(c => !re || re.test(c.nome) || (digitos.length >= 3 && c.numero.includes(digitos)));
  const lista = lerListaCelulares(avulsos);
  // número → nome (o do cadastro vale mais que o da lista avulsa)
  const destinos = new Map();
  for (const c of clientes) if (marcados.includes(c.cliente_id) && !c.descadastrado && !destinos.has(c.numero)) destinos.set(c.numero, c.nome);
  for (const n of lista.validos) if (!destinos.has(n)) destinos.set(n, '');
  const alternar = id => setMarcados(m => (m.includes(id) ? m.filter(x => x !== id) : [...m, id]));
  const marcarTodos = () => setMarcados(m => [...new Set([...m, ...visiveis.filter(c => !c.descadastrado).map(c => c.cliente_id)])]);

  // Prévia com o nome do primeiro marcado; a conta de SMS usa o nome de cada um
  const nomePrevia = [...destinos.values()].find(Boolean) || '';
  const previa = montarSms({ texto, nome: nomePrevia, cfg, tirarAcentos });
  const contagem = contarSms(previa);
  let totalSms = 0, maiorPartes = 0;
  for (const nome of destinos.values()) {
    const p = contarSms(montarSms({ texto, nome, cfg, tirarAcentos })).partes;
    totalSms += p; maiorPartes = Math.max(maiorPartes, p);
  }
  const custo = cfg?.rota_preco != null && totalSms ? totalSms * cfg.rota_preco : null;

  async function enviar(agendado = false) {
    if (!destinos.size) return setResultado({ erro: 'Escolha para quem enviar: marque clientes na lista ou cole celulares na lista avulsa.' });
    if (!texto.trim()) return setResultado({ erro: 'Escreva a mensagem.' });
    if (agendado && !quando) return setResultado({ erro: 'Escolha o dia e a hora do agendamento.' });
    const inicio = agendado ? ` a partir de ${fmtDt(new Date(quando).toISOString())}` : ' agora';
    const aviso = urgente ? '\n\n⚡ Urgente: sai mesmo fora do horário (domingo, feriado, noite).' : '';
    if (!window.confirm(`Enviar o SMS para ${destinos.size} celular(es)${inicio}?\n\nSerão cobrados ${totalSms} SMS${custo != null ? ` (cerca de ${fmtReal(custo)})` : ''}.${aviso}`)) return;
    setEnviando(true); setResultado(null);
    const body = { texto, clientes: marcados, avulsos, tirar_acentos: tirarAcentos, urgente };
    if (agendado) body.agendado_para = new Date(quando).toISOString();
    const r = await api('/comunicacao/sms/enviar', { method: 'POST', body: JSON.stringify(body) }).then(x => x.json()).catch(() => ({ erro: 'Falha ao enfileirar.' }));
    setEnviando(false);
    setResultado(r);
    if (r.ok) { setMarcados([]); setAvulsos(''); setAgendar(false); setQuando(''); setUrgente(false); carregarEnvios(); setLoteAberto(r.lote); setTimeout(carregarSaldo, 8000); }
  }

  async function cancelarLote(lote) {
    if (!window.confirm('Cancelar os SMS deste envio que ainda estão na fila?')) return;
    await api(`/comunicacao/sms/lote/${lote}`, { method: 'DELETE' }).catch(() => {});
    carregarEnvios();
  }
  // ⚡ O que está esperando o horário sai agora (o envio vira urgente)
  async function enviarUrgente(l, naFila) {
    if (!window.confirm(`Enviar agora os ${naFila} SMS deste envio, mesmo fora do horário?\n\n"${String(l.texto).slice(0, 80)}"`)) return;
    const r = await api(`/comunicacao/sms/lote/${l.lote}/urgente`, { method: 'POST' }).then(x => x.json()).catch(() => ({ erro: 'Falha de conexão.' }));
    if (!r.ok) return alert(r.erro || 'Não consegui enviar agora.');
    carregarEnvios(); setTimeout(carregarEnvios, 5000); setTimeout(carregarSaldo, 8000);
  }
  async function reenviar(id) {
    await api(`/comunicacao/sms/item/${id}/reenviar`, { method: 'POST' }).catch(() => {});
    carregarEnvios();
  }

  const contar = (itens, s) => itens.filter(i => i.status === s).length;
  const entregues = itens => itens.filter(i => i.entrega === 'Delivered' || i.entrega === 'Read').length;
  const respostas = itens => itens.filter(i => i.resposta).length;

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      {abrirCfg && <ModalConfigSms cfg={cfg} onFechar={() => setAbrirCfg(false)} onSalvo={carregarCfg} />}
      {abrirComtele && <ModalComtele onFechar={() => { setAbrirComtele(false); carregarSaldo(); }} />}
      <SmsListaOportunidades cfg={cfg} saldo={saldoTopo} inicial={listaInicial}
        onEnviado={r => { carregarEnvios(); setLoteAberto(r.lote); setTimeout(carregarSaldo, 8000); }} />
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 340px', gap: 16, alignItems: 'start' }}>
        {/* Destinatários */}
        <div style={{ display: 'grid', gap: 12 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: clientesAbertos ? 6 : 0 }}>
              <button type="button" onClick={alternarClientes} title={clientesAbertos ? 'Recolher a lista' : 'Abrir a lista'}
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 700, color: '#0a1628', textAlign: 'left' }}>
                <span style={{ fontSize: 11, color: '#6b7280', width: 12 }}>{clientesAbertos ? '▼' : '▶'}</span>
                👥 Clientes com celular no cadastro ({clientes.length})
                {!clientesAbertos && <span style={{ fontWeight: 400, color: '#6b7280', fontSize: 12 }}>· {marcados.length} marcado(s) — clique para abrir</span>}
              </button>
              {clientesAbertos && <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar nome ou celular" style={{ ...inp, width: 200, marginLeft: 'auto' }} />}
            </div>
            {clientesAbertos && (<>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#6b7280', marginBottom: 6 }}>
              <span><strong style={{ color: '#0a1628' }}>{marcados.length} marcado(s)</strong> · telefone fixo não recebe SMS e fica fora da lista</span>
              <span style={{ display: 'flex', gap: 10 }}>
                <button type="button" onClick={marcarTodos} style={{ background: 'none', border: 'none', color: '#0a1628', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>marcar todos da lista</button>
                <button type="button" onClick={() => setMarcados([])} style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer' }}>limpar</button>
              </span>
            </div>
            <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, maxHeight: 260, overflowY: 'auto' }}>
              {visiveis.length === 0 && <div style={{ padding: 20, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Nenhum cliente com celular{busca ? ' nessa busca' : ''}.</div>}
              {visiveis.map((c, i) => {
                const on = marcados.includes(c.cliente_id);
                return (
                  <label key={c.cliente_id} style={{ display: 'grid', gridTemplateColumns: '24px 1fr 1fr', gap: 8, alignItems: 'center', padding: '7px 12px', borderBottom: '1px solid #f3f4f6',
                    background: on ? '#eef2ff' : (i % 2 === 0 ? '#fafafa' : '#fff'), cursor: c.descadastrado ? 'not-allowed' : 'pointer', opacity: c.descadastrado ? 0.55 : 1 }}>
                    <input type="checkbox" checked={on} disabled={c.descadastrado} onChange={() => alternar(c.cliente_id)} style={{ width: 15, height: 15, margin: 0 }} />
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.nome}</span>
                    <span style={{ fontSize: 12, color: '#374151', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{c.celular}{c.descadastrado ? ' · pediu para sair' : ''}</span>
                  </label>
                );
              })}
            </div>
            </>)}
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 6 }}>📋 Lista avulsa <span style={{ fontWeight: 400, color: '#6b7280', fontSize: 12 }}>(sem vínculo com cadastro)</span></div>
            <textarea value={avulsos} onChange={e => setAvulsos(e.target.value)} rows={6}
              placeholder={'Cole aqui os celulares — um por linha, separados por vírgula ou copiados de uma planilha.\nEx.: (83) 99999-1234, 83 98888-4321'}
              style={{ ...inp, resize: 'vertical', lineHeight: 1.45 }} />
            {avulsos.trim() && (
              <div style={{ fontSize: 12, marginTop: 4, color: '#374151' }}>
                <strong style={{ color: '#16a34a' }}>{lista.validos.length} celular(es) válido(s)</strong>
                {lista.repetidos > 0 && <span style={{ color: '#6b7280' }}> · {lista.repetidos} repetido(s) ignorado(s)</span>}
                {lista.invalidos.length > 0 && <span style={{ color: '#b45309' }}> · {lista.invalidos.length} inválido(s) ou fixo(s): {lista.invalidos.slice(0, 4).join(', ')}{lista.invalidos.length > 4 ? '…' : ''}</span>}
              </div>
            )}
          </div>
        </div>

        {/* Painel de envio */}
        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 14, position: 'sticky', top: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>📱 Novo SMS</span>
            <span style={{ display: 'flex', gap: 6 }}>
              {cfg?.configurado && (
                <button type="button" onClick={() => setAbrirComtele(true)} title="Saldo e uso da Comtele"
                  style={{ ...btnOut, padding: '3px 10px', fontWeight: 700, color: saldoTopo != null && saldoTopo < 10 ? '#b91c1c' : '#166534', fontVariantNumeric: 'tabular-nums' }}>
                  💰 {saldoTopo != null ? fmtReal(saldoTopo) : 'Saldo'}
                </button>
              )}
              {ehVagner() && <button type="button" onClick={() => setAbrirCfg(true)} title="Configurar a Comtele" style={{ ...btnOut, padding: '3px 10px' }}>⚙️</button>}
            </span>
          </div>
          {cfg && !cfg.configurado && (
            <div style={{ fontSize: 12, background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', borderRadius: 6, padding: '6px 10px', marginBottom: 10 }}>
              ⚠ Falta configurar a Comtele — clique no ⚙️. Até lá os SMS ficam esperando na fila.
            </div>
          )}
          {cfg?.configurado && !cfg.ultimo_erro && (
            <div style={{ fontSize: 12, color: '#166534', marginBottom: 10 }}>✅ Sai pela Comtele{cfg.rota_nome ? <> · rota <strong>{cfg.rota_nome}</strong></> : ''} · até {cfg.limite_dia}/dia</div>
          )}
          {cfg?.ultimo_erro && (
            <div style={{ fontSize: 12, background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c', borderRadius: 6, padding: '6px 10px', marginBottom: 10 }}>
              ⚠ Envio parado: {cfg.ultimo_erro} Corrija no ⚙️.
            </div>
          )}
          {cfg && cfg.horario_ok === false && (
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>🌙 Agora está fora do horário de envio (segunda a sábado, 9h às 21h): o que entrar na fila sai a partir das 9h — ou marque <strong>⚡ Envio urgente</strong> para sair já.</div>
          )}
          <div style={lbl}>Mensagem <span style={{ color: '#9ca3af', fontWeight: 400 }}>({'{nome}'} = nome do cliente; na lista avulsa some · {'{saudacao}'} = Bom dia, Boa tarde ou Boa noite)</span></div>
          <textarea value={texto} onChange={e => setTexto(e.target.value)} rows={5} maxLength={600}
            placeholder="Ex.: Olá {nome}, sua marca foi publicada na revista do INPI. Fale com a gente: (83) 9 9999-9999"
            style={{ ...inp, resize: 'vertical', lineHeight: 1.45, marginBottom: 6 }} />
          <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12.5, color: '#0a1628', cursor: 'pointer', marginBottom: 8 }}>
            <input type="checkbox" checked={tirarAcentos} onChange={e => setTirarAcentos(e.target.checked)} style={{ width: 'auto', flex: '0 0 auto', marginTop: 2 }} />
            <span><strong>Tirar acentos e emojis</strong> (recomendado)<span style={{ display: 'block', color: '#6b7280', fontSize: 11.5 }}>sem eles cabem 160 caracteres em 1 SMS; com acento, só 70</span></span>
          </label>
          <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12.5, color: '#0a1628', cursor: 'pointer', marginBottom: 8,
            background: urgente ? '#fffbeb' : 'transparent', border: `1px solid ${urgente ? '#fde68a' : 'transparent'}`, borderRadius: 6, padding: urgente ? '4px 6px' : 0 }}>
            <input type="checkbox" checked={urgente} onChange={e => setUrgente(e.target.checked)} style={{ width: 'auto', flex: '0 0 auto', marginTop: 2 }} />
            <span><strong>⚡ Envio urgente</strong><span style={{ display: 'block', color: '#6b7280', fontSize: 11.5 }}>sai na hora, mesmo fora do horário (domingo, feriado, noite) — para aviso importante, não para propaganda</span></span>
          </label>
          <div style={lbl}>Como chega no celular{nomePrevia ? ` de ${nomePrevia}` : ''}</div>
          <div style={{ background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 10, padding: '8px 10px', fontSize: 12.5, color: texto.trim() ? '#0a1628' : '#9ca3af', whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.45, marginBottom: 4 }}>
            {texto.trim() ? previa : 'Escreva a mensagem para ver a prévia.'}
          </div>
          {texto.trim() && (
            <div style={{ fontSize: 11.5, color: contagem.partes > 1 ? '#b45309' : '#6b7280', marginBottom: 8, fontVariantNumeric: 'tabular-nums' }}>
              {contagem.caracteres} caracteres = {contagem.partes} SMS{contagem.unicode ? ' · tem acento ou emoji (limite de 70 por SMS)' : ''}
              {maiorPartes > 1 && <div>⚠ Passou do limite: cada parte é cobrada como 1 SMS.</div>}
            </div>
          )}
          {destinos.size > 0 && (
            <div style={{ fontSize: 12, color: '#0a1628', background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 6, padding: '6px 10px', marginBottom: 8, fontVariantNumeric: 'tabular-nums' }}>
              {destinos.size} celular(es) · <strong>{totalSms} SMS cobrados</strong>{custo != null && <> · cerca de <strong>{fmtReal(custo)}</strong></>}
            </div>
          )}
          <button type="button" onClick={() => enviar(false)} disabled={enviando}
            style={{ ...btn('#16a34a'), width: '100%', padding: '9px 0', fontSize: 13, opacity: enviando ? 0.5 : 1 }}>
            {enviando ? 'Enfileirando…' : destinos.size ? `📱 Enviar agora para ${destinos.size} celular(es)` : '📱 Enviar agora'}
          </button>
          {!destinos.size && !resultado && (
            <div style={{ fontSize: 11.5, color: '#92400e', marginTop: 6 }}>Para enviar, marque clientes na lista ou cole celulares na lista avulsa.</div>
          )}
          {!agendar ? (
            <button type="button" onClick={() => setAgendar(true)}
              style={{ background: 'none', border: 'none', color: '#6b7280', fontSize: 12, cursor: 'pointer', padding: '8px 0 0', textDecoration: 'underline' }}>
              ⏰ Agendar para outro horário
            </button>
          ) : (
            <div style={{ marginTop: 10, padding: 10, border: '1px dashed #c8d0da', borderRadius: 6 }}>
              <div style={lbl}>Dia e hora do envio</div>
              <div style={{ marginBottom: 8 }}><CampoDataHora value={quando} onChange={setQuando} style={inp} /></div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button type="button" onClick={() => enviar(true)} disabled={enviando}
                  style={{ ...btn('#0a1628'), flex: 1, padding: '7px 0', opacity: enviando ? 0.5 : 1 }}>
                  ⏰ Agendar envio
                </button>
                <button type="button" onClick={() => { setAgendar(false); setQuando(''); }} style={{ ...btnOut, padding: '7px 10px' }}>cancelar</button>
              </div>
            </div>
          )}
          {resultado && (
            <div style={{ marginTop: 10, fontSize: 12.5, background: resultado.ok ? '#f0fdf4' : '#fef2f2', border: `1px solid ${resultado.ok ? '#bbf7d0' : '#fecaca'}`, borderRadius: 6, padding: '8px 12px', color: resultado.ok ? '#166534' : '#b91c1c' }}>
              {resultado.ok ? <>✅ <strong>{resultado.enfileirados}</strong> SMS na fila. Acompanhe em "Envios de SMS" logo abaixo.</> : `⚠ ${resultado.erro}`}
              {resultado.fora_do_horario && <div style={{ color: '#6b7280', marginTop: 4 }}>🌙 Fora do horário de envio: começam a sair às 9h (ou use "⚡ enviar agora" no envio, logo abaixo).</div>}
              {resultado.descadastrados > 0 && <div style={{ color: '#6b7280', marginTop: 4 }}>{resultado.descadastrados} pulado(s): pediram para sair da lista.</div>}
              {resultado.repetidos > 0 && <div style={{ color: '#6b7280', marginTop: 4 }}>{resultado.repetidos} repetido(s) ignorado(s).</div>}
              {resultado.sem_celular?.length > 0 && <div style={{ color: '#b45309', marginTop: 4 }}>Sem celular no cadastro: {resultado.sem_celular.join(', ')}</div>}
              {resultado.invalidos?.length > 0 && <div style={{ color: '#b45309', marginTop: 4 }}>⚠ Inválidos ou fixos: {resultado.invalidos.join(', ')}</div>}
            </div>
          )}
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 10, lineHeight: 1.4 }}>
            A Comtele cobra cada resposta recebida, por isso o SMS não pede resposta; se alguém responder SAIR ou PARAR mesmo assim, não recebe mais. Sai de segunda a sábado, das 9h às 21h (o ⚡ urgente sai a qualquer hora), 1 por segundo, respeitando o limite por dia.
          </div>
        </div>
      </div>

      {/* Envios */}
      <div>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 6 }}>📬 Envios de SMS</div>
        {envios.length === 0 ? (
          <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: 20, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Nenhum SMS enviado ainda.</div>
        ) : (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
            {envios.map(l => {
              const naFila = contar(l.itens, 'agendado');
              const aberto = loteAberto === l.lote;
              return (
                <div key={l.lote} style={{ borderBottom: '1px solid #f3f4f6' }}>
                  <div onClick={() => setLoteAberto(aberto ? null : l.lote)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', cursor: 'pointer', background: aberto ? '#f8fafc' : '#fff', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 12, color: '#6b7280', minWidth: 110 }}>{fmtDt(l.criado_em)}</span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: '#0a1628', flex: 1, minWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={l.texto}>
                      {l.urgente && <span title="envio urgente: sai mesmo fora do horário" style={{ marginRight: 6, fontSize: 10.5, fontWeight: 700, color: '#92400e', background: '#fffbeb', borderRadius: 4, padding: '1px 6px' }}>⚡ urgente</span>}
                      {l.texto}
                    </span>
                    <span style={{ fontSize: 12, color: '#16a34a' }} title="enviados para a Comtele">✓ {contar(l.itens, 'enviado')}</span>
                    {entregues(l.itens) > 0 && <span style={{ fontSize: 12, color: '#16a34a' }} title="entrega confirmada no aparelho">📲 {entregues(l.itens)}</span>}
                    {naFila > 0 && <span style={{ fontSize: 12, color: '#d97706' }} title="na fila">⏳ {naFila}</span>}
                    {contar(l.itens, 'falhou') > 0 && <span style={{ fontSize: 12, color: '#dc2626' }} title="falharam">✗ {contar(l.itens, 'falhou')}</span>}
                    {respostas(l.itens) > 0 && <span style={{ fontSize: 12, color: '#1d4ed8' }} title="responderam">💬 {respostas(l.itens)}</span>}
                    {contar(l.itens, 'descadastrado') > 0 && <span style={{ fontSize: 12, color: '#6b7280' }}>saíram {contar(l.itens, 'descadastrado')}</span>}
                    <span style={{ fontSize: 12, color: '#6b7280' }}>de {l.itens.length}</span>
                    {naFila > 0 && cfg?.horario_ok === false && !l.urgente && (
                      <button type="button" onClick={e => { e.stopPropagation(); enviarUrgente(l, naFila); }} title="Está esperando o horário (seg a sáb, 9h–21h) — enviar já"
                        style={{ ...btn('#d97706'), padding: '2px 8px', fontSize: 11 }}>⚡ enviar agora</button>
                    )}
                    {naFila > 0 && <button type="button" onClick={e => { e.stopPropagation(); cancelarLote(l.lote); }} style={{ ...btnOut, padding: '2px 8px', fontSize: 11 }}>cancelar o que falta</button>}
                    <span style={{ fontSize: 12, color: '#9ca3af' }}>{aberto ? '▲' : '▼'}</span>
                  </div>
                  {aberto && (
                    <div style={{ padding: '4px 12px 10px', maxHeight: 320, overflowY: 'auto' }}>
                      {l.itens.map(i => {
                        const st = statusEmail(i.status);
                        const en = i.entrega ? entregaSms(i.entrega) : null;
                        return (
                          <div key={i._id} title={i.texto_enviado ? `Como saiu: ${i.texto_enviado}` : ''} style={{ display: 'grid', gridTemplateColumns: '120px 1fr 100px 110px 1.4fr 70px', gap: 8, alignItems: 'center', padding: '4px 0', fontSize: 12, borderBottom: '1px dashed #f1f5f9' }}>
                            <span style={{ fontVariantNumeric: 'tabular-nums' }}>{i.celular}</span>
                            <span style={{ color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{i.nome || ({ avulso: 'lista avulsa', oportunidade: 'Oportunidades (sem nome)' }[i.origem] || '—')}</span>
                            <span style={{ background: st.bg, color: st.cor, padding: '1px 8px', borderRadius: 4, fontWeight: 700, fontSize: 11, justifySelf: 'start' }}>{st.label}</span>
                            {en ? <span style={{ background: en.bg, color: en.cor, padding: '1px 8px', borderRadius: 4, fontWeight: 700, fontSize: 11, justifySelf: 'start' }} title={`situação na Comtele: ${i.entrega}`}>{en.label}</span> : <span />}
                            {i.resposta
                              ? <span style={{ color: '#1d4ed8', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={i.resposta}>💬 {i.resposta}</span>
                              : <span style={{ color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={i.erro}>{i.erro || (i.enviado_em ? fmtDt(i.enviado_em) : '')}</span>}
                            {['falhou', 'cancelado'].includes(i.status)
                              ? <button type="button" onClick={() => reenviar(i._id)} style={{ ...btnOut, padding: '1px 6px', fontSize: 11 }}>reenviar</button>
                              : <span />}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// ── Página Principal ──────────────────────────────────────────────────────────
// No topo, os três canais; o WhatsApp tem as abas dele logo abaixo (25/10/2026)
const CANAIS = [
  { k: 'email', label: '📧 E-mail' },
  { k: 'sms', label: '📱 SMS' },
  { k: 'whatsapp', label: '💬 WhatsApp' },
];
const ABAS_WHATSAPP = [
  { k: 'agendar', label: '📅 Agendar Envio' },
  { k: 'comunicado', label: '📢 Comunicado' },
  { k: 'google', label: '⭐ Comentário no Google' },
  { k: 'fila', label: '⏳ Fila' },
  { k: 'historico', label: '📋 Histórico' },
  { k: 'templates', label: '📝 Templates' },
];

export default function Comunicacao() {
  // A página abre sempre no WhatsApp › Agendar Envio (o uso do dia a dia);
  // Templates fica por último — é configuração, não rotina. Indo ao E-mail ou
  // ao SMS e voltando, o WhatsApp continua na aba em que estava.
  const [canal, setCanal] = useState('whatsapp');
  const [aba, setAba] = useState('agendar');
  const [recarregarFila, setRecarregarFila] = useState(0);
  // Respostas de e-mail ainda não lidas: número na aba (pergunta a cada 2 min).
  // Quando muda aqui (leu, marcou como não lida), o número do topo acompanha na hora.
  const [naoLidasEmail, setNaoLidasEmail] = useState(0);
  const atualizarNaoLidas = useCallback(n => {
    setNaoLidasEmail(n);
    window.dispatchEvent(new CustomEvent('preserva:email-nao-lidas', { detail: n }));
  }, []);
  useEffect(() => {
    const ver = () => api('/comunicacao/email/caixa/resumo').then(r => r.json()).then(d => atualizarNaoLidas(d.nao_lidas || 0)).catch(() => {});
    ver();
    const t = setInterval(ver, 120000);
    // o topo do sistema pergunta a cada minuto e avisa aqui (só muda o número, sem reavisar)
    const mudou = e => setNaoLidasEmail(Number(e.detail) || 0);
    window.addEventListener('preserva:email-nao-lidas', mudou);
    return () => { clearInterval(t); window.removeEventListener('preserva:email-nao-lidas', mudou); };
  }, [atualizarNaoLidas]);
  // ?email=<id> (ou ?email=respostas): veio de um aviso de e-mail novo;
  // ?campanha=1: veio de um aviso da campanha automática
  const location = useLocation();
  const [alvoEmail, setAlvoEmail] = useState(null);
  // ?sms_lista=<id>: veio do 🕘 Histórico das Oportunidades (botão 📱 Mandar SMS)
  const [listaSms, setListaSms] = useState(null);
  useEffect(() => {
    const q = new URLSearchParams(location.search);
    if (q.get('sms_lista')) {
      setCanal('sms');
      setListaSms({ id: q.get('sms_lista'), n: Date.now() });
      return;
    }
    const id = q.get('campanha') ? 'campanha' : q.get('email');
    if (!id) return;
    setCanal('email');
    setAlvoEmail({ id, n: Date.now() });
  }, [location.search, location.key]);

  const noWhats = canal === 'whatsapp';
  return (
    <div style={{ maxWidth: 1000 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>💬 Comunicação</h1>
        <div style={{ fontSize: 12, color: '#6b7280', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '4px 10px' }}>
          Mensagens disparadas automaticamente pelo servidor
        </div>
      </div>

      {/* Canais */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 20, borderBottom: '2px solid #e5e7eb' }}>
        {CANAIS.map(({ k, label }) => (
          <button key={k} onClick={() => setCanal(k)} style={{
            background: 'none', border: 'none', borderBottom: canal === k ? '2px solid #0a1628' : '2px solid transparent',
            marginBottom: -2, padding: '8px 18px', fontSize: 13, fontWeight: canal === k ? 700 : 400,
            color: canal === k ? '#0a1628' : '#6b7280', cursor: 'pointer',
          }}>
            {label}
            {k === 'email' && naoLidasEmail > 0 && (
              <span title="Respostas de e-mail ainda não lidas" style={{ marginLeft: 6, background: '#dc2626', color: '#fff', borderRadius: 10, padding: '0 6px', fontSize: 11, fontWeight: 700 }}>{naoLidasEmail}</span>
            )}
          </button>
        ))}
      </div>

      {/* Abas do WhatsApp — no mesmo formato das partes do E-mail */}
      {noWhats && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 14 }}>
          {ABAS_WHATSAPP.map(({ k, label }) => (
            <button key={k} type="button" onClick={() => setAba(k)} style={{ ...(aba === k ? btn() : btnOut), padding: '6px 14px' }}>
              {label}
            </button>
          ))}
        </div>
      )}

      {canal === 'email' && <AbaEmail naoLidas={naoLidasEmail} onNaoLidas={atualizarNaoLidas} alvo={alvoEmail} />}
      {canal === 'sms' && <AbaSms listaInicial={listaSms} />}
      {noWhats && aba === 'agendar' && <AbaAgendar onAgendado={() => { setRecarregarFila(r => r + 1); setAba('fila'); }} />}
      {noWhats && aba === 'comunicado' && <AbaComunicado onEnviado={() => setRecarregarFila(r => r + 1)} />}
      {noWhats && aba === 'google' && <AbaGoogle onEnviado={() => setRecarregarFila(r => r + 1)} />}
      {noWhats && aba === 'fila' && <AbaFila recarregar={recarregarFila} />}
      {noWhats && aba === 'historico' && <AbaHistorico />}
      {noWhats && aba === 'templates' && <AbaTemplates />}
    </div>
  );
}
